// src/components/dated-searches/dated-searches.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment DatedSearchesTitleFragment on LodgingHeader {\n    text\n    subText\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment DatedSearchesButtonsFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment DatedSearchesHorizontalFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment DatedSearchesListFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment DatedSearchesRowFragment on LodgingList {\n    title {\n      ...DatedSearchesTitleFragment\n    }\n    items {\n      label {\n        text\n      }\n      link {\n        text\n        icon {\n          id\n          description\n          token\n        }\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n        size\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  query DatedSearchesQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $filters: PropertySearchFiltersInput!\n    $dataType: String!\n    $pageType: String!\n  ) {\n    lodgingDestination(context: $context, destination: $destination, filters: $filters) {\n      datedSearches(dataType: $dataType, pageType: $pageType) {\n        ...DatedSearchesListFragment\n        ...DatedSearchesRowFragment\n        ...DatedSearchesButtonsFragment\n        ...DatedSearchesHorizontalFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {\n    campaignId\n    clientSideAnalytics {\n      referrerId\n      eventType\n      linkName\n    }\n    events {\n      eventType\n      eventTarget\n      banditDisplayed\n      payloadId\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {\n    campaignId\n    eventTarget\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment PriceSummaryFragment on PropertyPrice {\n    displayMessages {\n      lineItems {\n        ...PriceMessageFragment\n        ...EnrichedMessageFragment\n      }\n    }\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  fragment PriceMessageFragment on DisplayPrice {\n    __typename\n    role\n    price {\n      formatted\n      accessibilityLabel\n    }\n    disclaimer {\n      content\n      primaryUIButton {\n        accessibility\n        primary\n      }\n    }\n  }\n\n  fragment EnrichedMessageFragment on LodgingEnrichedMessage {\n    __typename\n    value\n    state\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingBadgeFragment on EGDSStandardBadge {\n    text\n    theme\n    graphic {\n      __typename\n      ... on Icon {\n        description\n        id\n      }\n      ... on Mark {\n        description\n        id\n      }\n    }\n    size\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSParagraphFragment on EGDSParagraph {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    text\n    theme\n    weight\n    size\n    decorative\n    accessibility\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSTextFragment on EGDSText {\n    ... on EGDSParagraph {\n      ...LodgingEGDSParagraphFragment\n    }\n    ... on EGDSStylizedText {\n      ...EGDSStylizedTextFragment\n    }\n    ... on EGDSPlainText {\n      __typename\n      text\n    }\n    ... on EGDSInlineLink {\n      ...LodgingEGDSInlineLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSHeadingFragment on EGDSHeading {\n    __typename\n    text\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ... on Icon {\n        id\n        size\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...LodgingEGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSLocalizedTextTemplateFragment on EGDSLocalizedTextTemplate {\n    __typename\n    template\n    token\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingStandardBadgeFragment on LodgingStandardBadge {\n    standardBadge {\n      text\n      theme\n      graphic {\n        __typename\n        ... on Icon {\n          description\n          id\n        }\n        ... on Mark {\n          description\n          id\n        }\n      }\n      size\n    }\n    impressionEventAnalytics {\n      referrerId\n      linkName\n      event\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingPriceSummaryFragment on Offer {\n    price {\n      options {\n        leadingCaption\n        displayPrice {\n          formatted\n        }\n        priceDisclaimer {\n          content\n          primaryButton {\n            text\n          }\n          trigger {\n            icon {\n              description\n            }\n          }\n        }\n        accessibilityLabel\n        strikeOut {\n          formatted\n        }\n        loyaltyPrice {\n          unit\n          amount {\n            formatted\n          }\n          totalStrikeOutPoints {\n            formatted\n          }\n        }\n      }\n      priceMessaging {\n        value\n        theme\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardCompareSectionFragment on LodgingCardCompareSection {\n    __typename\n    compareAction {\n      ... on EGDSBasicCheckBox {\n        __typename\n        label {\n          text\n        }\n        checkedAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n        uncheckedAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardDateSectionFragment on LodgingCardDateSection {\n    date {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSRatingFragment on EGDSRating {\n    accessibility\n    rating\n    ... on EGDSIconRating {\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardFeaturedMessageFragment on LodgingCardFeaturedMessage {\n    icon {\n      id\n      description\n      size\n    }\n    text\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductAmenityFragment on EGDSIconText {\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardHeadingSectionFragment on LodgingCardHeadingSection {\n    heading\n    productRating {\n      ...LodgingEGDSRatingFragment\n    }\n    featuredMessages {\n      ...LodgingCardFeaturedMessageFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMarketingFeeDetailFragment on MarketingFeeDetails {\n    tierMessage {\n      accessibilityLabel\n      value\n      egdsMark {\n        id\n      }\n    }\n    marketingFeeMessageDialog {\n      content\n      dialog {\n        footer {\n          buttons {\n            primary\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    text\n    size\n    theme\n  }\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardBadgedRatingFragment on LodgingCardBadgedRating {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    phrases {\n      phraseParts {\n        ...EGDSStylizedTextFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMoreDetailsTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardChangeUnitDialogActionFragment on LodgingCardChangeUnitDialogAction {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardChangeUnitSheetActionFragment on LodgingCardChangeUnitSheetAction {\n    sheet {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      closeText\n    }\n    trigger {\n      ...LodgingCardMoreDetailsTriggerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardGuestRatingFragment on LodgingCardPhrase {\n    accessibilityLabel\n    phraseParts {\n      ... on EGDSIconRating {\n        ...EGDSIconRatingFragment\n      }\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n    parts {\n      text\n      ... on EGDSStylizedText {\n        ...EGDSStylizedTextFragment\n      }\n      ... on EGDSText {\n        ...LodgingEGDSTextFragment\n      }\n    }\n  }\n\n  fragment EGDSIconRatingFragment on EGDSIconRating {\n    rating\n    icon {\n      size\n      theme\n      token\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMoreDetailsLinkTriggerFragment on LodgingCardMoreDetailsTrigger {\n    accessibilityLabel\n    analytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    label\n  }\n\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDetailsDialogActionFragment on LodgingCardPropertyDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardUnitDetailsDialogActionFragment on LodgingCardUnitDetailsDialog {\n    dialog {\n      closeAnalytics {\n        linkName\n        referrerId\n      }\n      toolbar {\n        ...EGDSDialogToolbarFragment\n      }\n    }\n    trigger {\n      ...LodgingCardMoreDetailsLinkTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDialogActionFragment on LodgingCardDetailsAction {\n    __typename\n    ... on LodgingCardUnitDetailsDialog {\n      ...LodgingCardUnitDetailsDialogActionFragment\n    }\n    ... on LodgingCardPropertyDetailsDialog {\n      ...LodgingCardPropertyDetailsDialogActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardPropertyDescriptionSectionFragment on LodgingCardPropertyDescriptionSection {\n    heading {\n      text\n    }\n    description {\n      text\n    }\n    # Link is used for tracking purposes on the client, do not remove\n    link {\n      action {\n        resource {\n          value\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductFooterMessagesFragment on EGDSTextWithMarkListItem {\n    mark {\n      description\n      id\n      url {\n        value\n      }\n    }\n    egdsElementId\n    style\n    text\n  }\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingProductSpannableFooterMessagesFragment on EarnMessageContainerListItem {\n    graphic {\n      ... on Mark {\n        description\n        id\n        token\n        url {\n          value\n          relativePath\n        }\n      }\n      ... on Icon {\n        description\n        id\n        size\n        theme\n        title\n      }\n      ... on Illustration {\n        id\n        description\n      }\n    }\n    style\n    text\n    stylizedText {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardProductSummarySectionFragment on LodgingCardProductSummarySection {\n    heading {\n      ...LodgingEGDSHeadingFragment\n    }\n    amenities {\n      ...LodgingProductAmenityFragment\n    }\n    messages {\n      ...LodgingEGDSTextFragment\n    }\n    descriptionSection {\n      ...LodgingCardPropertyDescriptionSectionFragment\n    }\n    changeActionDialog {\n      ...LodgingCardChangeUnitDialogActionFragment\n    }\n    changeActionSheet {\n      ...LodgingCardChangeUnitSheetActionFragment\n    }\n    detailsAction {\n      ...LodgingCardPropertyDialogActionFragment\n    }\n    guestRating {\n      ...LodgingCardGuestRatingFragment\n    }\n    guestRatingSection {\n      __typename\n      ... on LodgingCardPhrase {\n        ...LodgingCardGuestRatingFragment\n      }\n      ... on LodgingCardBadgedRating {\n        ...LodgingCardBadgedRatingFragment\n      }\n    }\n    footerMessages {\n      listItems {\n        ...LodgingProductFooterMessagesFragment\n        ...LodgingProductSpannableFooterMessagesFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardContentSectionFragment on LodgingCard {\n    __typename\n    headingSection {\n      ...LodgingCardHeadingSectionFragment\n    }\n    summarySections {\n      ...LodgingCardProductSummarySectionFragment\n    }\n    priceSection {\n      priceSummary {\n        ...PriceSummaryFragment\n        marketingFeeDetails {\n          ...LodgingCardMarketingFeeDetailFragment\n        }\n      }\n      badge {\n        ...LodgingBadgeFragment\n      }\n      standardBadge {\n        ...LodgingStandardBadgeFragment\n      }\n      button {\n        accessibility\n        action {\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n        disabled\n        icon {\n          description\n          id\n        }\n        primary\n        attemptEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        successEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        adaptexSuccessActionTracking {\n          ...AdaptexCampaignTrackingDetailFragment\n        }\n      }\n    }\n    compareSection {\n      ...LodgingCardCompareSectionFragment\n    }\n    dateSection {\n      ...LodgingCardDateSectionFragment\n    }\n    callOut {\n      ...LodgingEGDSTextFragment\n    }\n    id\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardLinkFragment on UILinkAction {\n    __typename\n    accessibility\n    resource {\n      __typename\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    useRelativePath\n    target\n  }\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardLinkActionFragment on LodgingCardLinkAction {\n    link {\n      text\n      action {\n        target\n        resource {\n          ... on HttpURI {\n            value\n            relativePath\n          }\n        }\n        useRelativePath\n        analytics {\n          referrerId\n          linkName\n        }\n      }\n      icon {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSImageFragment on Image {\n    description\n    url\n    thumbnailClickAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingMediaItemFragment on LodgingMediaItem {\n    id\n    media {\n      ... on Image {\n        ...LodgingEGDSImageFragment\n      }\n    }\n    trackingId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {\n    accessibilityHeadingText\n    navClickAnalytics {\n      referrerId\n      linkName\n    }\n    intersectionAnalytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    media {\n      ...LodgingMediaItemFragment\n    }\n    nextButtonText\n    previousButtonText\n  }\n\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessCampaignIds {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n    label\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardSaveItemFragment on LodgingSaveItem {\n    items {\n      itemId\n    }\n    labels {\n      saveLabel\n      removeLabel\n    }\n    messages {\n      saveMessage\n      removeMessage\n    }\n    initialChecked\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {\n    gallery {\n      ...LodgingGalleryCarouselFragment\n    }\n    saveItem {\n      ...LodgingCardSaveItemFragment\n    }\n    saveTripItem {\n      ...TripsSaveItemFragment\n    }\n    badges {\n      primaryBadge {\n        ...LodgingBadgeFragment\n      }\n      secondaryBadge {\n        ...LodgingBadgeFragment\n      }\n      tertiaryBadge {\n        ...LodgingBadgeFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingCardFragment on LodgingCard {\n    featuredHeader {\n      header {\n        text\n      }\n    }\n    cardLink {\n      ...LodgingCardLinkFragment\n    }\n    footerActions {\n      ...LodgingCardLinkActionFragment\n    }\n    mediaSection {\n      ...LodgingCardMediaSectionFragment\n    }\n    id\n    ...LodgingCardContentSectionFragment\n    clickstreamEvents {\n      productPresented {\n        ...ProductEventFragment\n      }\n      productSelected {\n        ...ProductEventFragment\n      }\n    }\n    impressionAnalytics {\n      url\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    adaptexSuccessActionTracking {\n      ...AdaptexCampaignTrackingDetailFragment\n    }\n  }\n\n  fragment ProductEventFragment on LodgingProductEvent {\n    event {\n      ...ClickstreamEventFragment\n    }\n    product_list {\n      ...ProductListFragment\n    }\n    search_request {\n      ...RequestFragment\n    }\n  }\n\n  fragment ClickstreamEventFragment on EGClickstreamEvent {\n    eventCategory\n    eventName\n    eventType\n    eventVersion\n  }\n\n  fragment ProductListFragment on LodgingProduct {\n    product_id\n  }\n\n  fragment RequestFragment on LodgingSearchRequest {\n    search_id\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingUILinkActionFragment on UILinkAction {\n    resource {\n      ... on HttpURI {\n        relativePath\n        value\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSButtonFragment on EGDSButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    ... on UIPrimaryButton {\n      egdsElementId\n    }\n    disabled\n    primary\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingActionButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {\n    accessibility\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    primary\n    action {\n      ...LodgingUILinkActionFragment\n    }\n    icon {\n      ...LodgingEGDSIconFragment\n    }\n    egdsElementId\n  }\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingEGDSCheckboxFragment on EGDSBasicCheckBox {\n    ...LodgingEGDSBasicCheckBoxFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment DynamicMapFragment on EGDSBasicMap {\n    label\n    initialViewport\n    center {\n      latitude\n      longitude\n    }\n    zoom\n    bounds {\n      northeast {\n        latitude\n        longitude\n      }\n      southwest {\n        latitude\n        longitude\n      }\n    }\n    computedBoundsOptions {\n      coordinates {\n        latitude\n        longitude\n      }\n      gaiaId\n      lowerQuantile\n      upperQuantile\n      marginMultiplier\n      minMargin\n      minimumPins\n      interpolationRatio\n    }\n    config {\n      ... on EGDSDynamicMapConfig {\n        accessToken\n        egdsMapProvider\n        externalConfigEndpoint {\n          value\n        }\n        mapId\n      }\n    }\n    markers {\n      ... on EGDSMapFeature {\n        id\n        description\n        markerPosition {\n          latitude\n          longitude\n        }\n        type\n        markerStatus\n        qualifiers\n        text\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        onSelectAccessibilityMessage\n        onEnterAccessibilityMessage\n      }\n    }\n  }\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment MapToolbarFragment on MapToolbar {\n    title\n    subtitle\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment OverfilteredCardFragment on PropertySearchListingsOverfilteredCard {\n    content {\n      heading\n      message\n    }\n  }\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  query PropertySearchDynamicSearchMapQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $returnPropertyType: Boolean = true\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: $returnPropertyType\n    ) {\n      dynamicMap {\n        mapToolbar {\n          ...MapToolbarFragment\n        }\n        autoSearchOnMapMove {\n          ...LodgingEGDSCheckboxFragment\n        }\n        action {\n          ...LodgingEGDSFloatingButtonFragment\n        }\n        adaptExSuccessEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        filterPlacement\n        map {\n          ...DynamicMapFragment\n        }\n      }\n      propertySearchListings {\n        ...LodgingCardFragment\n        ...OverfilteredCardFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment MapTriggerFragment on LodgingMapTrigger {\n    icon {\n      id\n      title\n      token\n    }\n    label\n    small {\n      description\n      url\n    }\n    medium {\n      description\n      url\n    }\n    large {\n      description\n      url\n    }\n    clientSideAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  query PropertySearchMapDialogTriggerQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n    $returnPropertyType: Boolean = true\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: $returnPropertyType\n    ) {\n      mapTrigger {\n        ...MapTriggerFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
import React6 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/dated-searches/__private/__fragments/dated-searches-buttons.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard } from "uitk-react-cards";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/dated-searches/__private/__fragments/dated-searches-title.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
var __DatedSearchesTitleFragment = gql(_templateObject());
var DatedSearchesTitle = function(param) {
    var data = param.data;
    var text = data.text, subText = data.subText;
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "three"
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkHeading, {
        tag: "h2",
        size: 5
    }, text), /* @__PURE__ */ React.createElement(UitkSubheading, {
        tag: "h4"
    }, subText)));
};
DatedSearchesTitle.fragment = __DatedSearchesTitleFragment;
DatedSearchesTitle.displayName = "DatedSearchesTitle";
// src/components/dated-searches/__private/__fragments/dated-searches-buttons.tsx
var __DatedSearchesButtonsFragment = gql2(_templateObject1(), DatedSearchesTitle.fragment);
var DatedSearchesButtons = function(param) {
    var className = param.className, data = param.data;
    var clickTracker = useClickTracker();
    if (!data) {
        return null;
    }
    var items = data.items, title = data.title;
    return /* @__PURE__ */ React2.createElement(UitkCard, {
        className: className
    }, /* @__PURE__ */ React2.createElement(DatedSearchesTitle, {
        data: title
    }), items.map(function(param, index) {
        var label = param.label, link = param.link;
        return link && label && /* @__PURE__ */ React2.createElement(UitkCard, {
            key: index
        }, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            margin: "two",
            padding: {
                inline: "two"
            },
            border: [
                "inlinestart",
                "inlineend",
                "blockstart",
                "blockend"
            ]
        }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            padding: {
                block: "two"
            }
        }, /* @__PURE__ */ React2.createElement(UitkLink, {
            align: "center",
            analytics: {
                id: link.action.analytics.referrerId,
                description: link.action.analytics.linkName,
                callback: function(id, desc) {
                    return clickTracker(id, desc);
                }
            }
        }, /* @__PURE__ */ React2.createElement("a", {
            href: link.action.resource.value
        }, /* @__PURE__ */ React2.createElement(UitkIcon, {
            size: UitkIconSize.SMALL,
            name: "today"
        }), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
            margin: {
                inline: "two"
            }
        }, /* @__PURE__ */ React2.createElement("div", null, label.text)), link.text))))));
    }));
};
DatedSearchesButtons.fragment = __DatedSearchesButtonsFragment;
DatedSearchesButtons.displayName = "DatedSearchesButtons";
// src/components/dated-searches/__private/__fragments/dated-searches-horizontal.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var __DatedSearchesHorizontalFragment = gql3(_templateObject2(), DatedSearchesTitle.fragment);
var DatedSearchesHorizontal = function(param) {
    var className = param.className, data = param.data;
    var clickTracker = useClickTracker2();
    if (!data) {
        return null;
    }
    var items = data.items, title = data.title;
    return /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        className: className,
        columns: 4,
        space: "two"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: 4
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(DatedSearchesTitle, {
        data: title
    }))), items.length > 0 && items.map(function(param, index) {
        var label = param.label, link = param.link;
        return /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
            colSpan: 1,
            key: index
        }, /* @__PURE__ */ React3.createElement(UitkCard2, null, /* @__PURE__ */ React3.createElement(UitkSpacing3, {
            padding: "four"
        }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
            direction: "column"
        }, link && /* @__PURE__ */ React3.createElement(UitkSpacing3, {
            padding: {
                block: "two"
            }
        }, /* @__PURE__ */ React3.createElement(UitkLink2, {
            align: "center",
            analytics: {
                id: link.action.analytics.referrerId,
                description: link.action.analytics.linkName,
                callback: function(id, desc) {
                    return clickTracker(id, desc);
                }
            }
        }, /* @__PURE__ */ React3.createElement("a", {
            href: link.action.resource.value
        }, link.text))), label && /* @__PURE__ */ React3.createElement(UitkText, {
            align: "center"
        }, label.text)))));
    }));
};
DatedSearchesHorizontal.fragment = __DatedSearchesHorizontalFragment;
DatedSearchesHorizontal.displayName = "DatedSearchesHorizontal";
// src/components/dated-searches/__private/__fragments/dated-searches-list.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkTable, UitkTableBody, UitkTableCell, UitkTableCellBorder, UitkTableRow } from "uitk-react-tables";
import { UitkText as UitkText2 } from "uitk-react-text";
var __DatedSearchesListFragment = gql4(_templateObject3(), DatedSearchesTitle.fragment);
var DatedSearchesList = function(param) {
    var className = param.className, data = param.data;
    var clickTracker = useClickTracker3();
    if (!data) {
        return null;
    }
    var items = data.items, title = data.title;
    return /* @__PURE__ */ React4.createElement(UitkCard3, {
        className: className,
        "data-stid": "dated-searches-list"
    }, /* @__PURE__ */ React4.createElement(DatedSearchesTitle, {
        data: title
    }), items.length > 0 && /* @__PURE__ */ React4.createElement(UitkTable, null, /* @__PURE__ */ React4.createElement(UitkTableBody, null, items.map(function(param, index) {
        var label = param.label, link = param.link;
        var _label;
        return /* @__PURE__ */ React4.createElement(UitkTableRow, {
            key: index
        }, /* @__PURE__ */ React4.createElement(UitkTableCell, {
            align: {
                vertical: "bottom"
            },
            border: UitkTableCellBorder.horizontal
        }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
            justifyContent: "space-between"
        }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem, {
            shrink: 0
        }, /* @__PURE__ */ React4.createElement(UitkText2, null, (_label = label) === null || _label === void 0 ? void 0 : _label.text)), link && /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React4.createElement(UitkLink3, {
            align: "right",
            analytics: {
                id: link.action.analytics.referrerId,
                description: link.action.analytics.linkName,
                callback: function(id, desc) {
                    return clickTracker(id, desc);
                }
            }
        }, /* @__PURE__ */ React4.createElement("a", {
            href: link.action.resource.value
        }, link.text))))));
    }))));
};
DatedSearchesList.fragment = __DatedSearchesListFragment;
DatedSearchesList.displayName = "DatedSearchesList";
// src/components/dated-searches/__private/__fragments/dated-searches-row.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard4, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var __DatedSearchesRowFragment = gql5(_templateObject4(), DatedSearchesTitle.fragment);
var DatedSearchesRow = function(param) {
    var className = param.className, data = param.data;
    var clickTracker = useClickTracker4();
    if (!data) {
        return null;
    }
    var items = data.items, title = data.title;
    return /* @__PURE__ */ React5.createElement(UitkCard4, {
        className: className
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGrid2, {
        columns: 4
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: 4
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(DatedSearchesTitle, {
        data: title
    }))), items.length > 0 && items.map(function(param, index) {
        var label = param.label, link = param.link;
        return /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
            colSpan: 1,
            key: index
        }, /* @__PURE__ */ React5.createElement(UitkCardContentSection, null, label && /* @__PURE__ */ React5.createElement(UitkText3, {
            weight: "bold",
            size: 300
        }, label.text), link && /* @__PURE__ */ React5.createElement(UitkSpacing4, {
            padding: {
                block: "two"
            }
        }, /* @__PURE__ */ React5.createElement(UitkLink4, {
            analytics: {
                id: link.action.analytics.referrerId,
                description: link.action.analytics.linkName,
                callback: function(id, desc) {
                    return clickTracker(id, desc);
                }
            }
        }, /* @__PURE__ */ React5.createElement("a", {
            href: link.action.resource.value
        }, link.text)))));
    })));
};
DatedSearchesRow.fragment = __DatedSearchesRowFragment;
DatedSearchesRow.displayName = "DatedSearchesRow";
// src/components/dated-searches/dated-searches.tsx
var __DatedSearchesQuery = gql6(_templateObject5(), DatedSearchesList.fragment, DatedSearchesRow.fragment, DatedSearchesButtons.fragment, DatedSearchesHorizontal.fragment);
var DatedSearches = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, view = props.view, className = props.className;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs || {}), {
        context: context
    });
    var _useQuery = useQuery(__DatedSearchesQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var datedSearches = data.lodgingDestination.datedSearches;
    switch(view){
        case "ROW":
            return /* @__PURE__ */ React6.createElement(DatedSearchesRow, {
                className: className,
                data: datedSearches
            });
        case "BUTTONS":
            return /* @__PURE__ */ React6.createElement(DatedSearchesButtons, {
                className: className,
                data: datedSearches
            });
        case "HORIZONTAL":
            return /* @__PURE__ */ React6.createElement(DatedSearchesHorizontal, {
                className: className,
                data: datedSearches
            });
        default:
            return /* @__PURE__ */ React6.createElement(DatedSearchesList, {
                className: className,
                data: datedSearches
            });
    }
};
DatedSearches.displayName = "sharedui-DatedSearches";
// src/components/dynamic-search-map/dynamic-search-map.tsx
import React72 from "react";
import { gql as gql66, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { ITrackType as ITrackType5, useClickstreamAnalytics as useClickstreamAnalytics5, useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2, useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
// ../internal/src/components/common/adaptex/adaptex-analytics-event-fragment.ts
import { gql as gql7 } from "@apollo/client";
var AdaptExAnalyticsEventFragment = gql7(_templateObject6());
// ../internal/src/components/common/client-side-analytics/client-side-analytics.ts
import { useCallback } from "react";
import { gql as gql8 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql8(_templateObject7());
var referrerMap = {
    CLICK: "click",
    IMPRESSION: "impression"
};
var trackAnalyticsList = function(clickstreamAnalytics, analytics) {
    if (analytics) {
        var _uisPrimeMessages;
        var track = clickstreamAnalytics.track;
        var referrerId = analytics.referrerId, linkName = analytics.linkName, uisPrimeMessages = analytics.uisPrimeMessages;
        var _analytics_eventType;
        var eventType = referrerMap[(_analytics_eventType = analytics.eventType) !== null && _analytics_eventType !== void 0 ? _analytics_eventType : "CLICK"];
        var message = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: eventType
            }
        };
        var data = !((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.length) ? message : [
            message
        ].concat(_to_consumable_array(uisPrimeMessages.map(function(param) {
            var schemaName = param.schemaName, messageContent = param.messageContent;
            return {
                schemaName: schemaName,
                messageContent: JSON.parse(messageContent)
            };
        })));
        track(ITrackType.EVENT, {
            data: data
        });
    }
};
var useTrackClientSideAnalytics = function(analytics) {
    var clickstreamAnalytics = useClickstreamAnalytics();
    return useCallback(function() {
        if (analytics) {
            trackAnalyticsList(clickstreamAnalytics, analytics);
        }
    }, [
        analytics,
        clickstreamAnalytics
    ]);
};
// ../internal/src/components/lodging-card/lodging-card.tsx
import React62, { useEffect as useEffect2 } from "react";
import { gql as gql56 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker5, useClickstreamAnalytics as useClickstreamAnalytics4, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useMesoViewabilityWrapper } from "@shared-ui/sponsored-content-meso-viewability-wrapper";
// ../internal/src/utils/analytics.ts
var parseLodgingCardImpressionSchema = function(uisPrimeMessages) {
    var _uisPrimeMessages_, _uisPrimeMessages;
    if (((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : (_uisPrimeMessages_ = _uisPrimeMessages[0]) === null || _uisPrimeMessages_ === void 0 ? void 0 : _uisPrimeMessages_.schemaName) && uisPrimeMessages[0].messageContent) {
        return [
            {
                // we are parsing data here since additionalUisPrimeMicroMessages in intersection tracker takes message content as json object
                // mean while we are returning this data from the API as string.
                messageContent: JSON.parse(uisPrimeMessages[0].messageContent),
                schemaName: uisPrimeMessages[0].schemaName
            }
        ];
    }
};
var createAdaptExMicroMessage = function(campaignId, events) {
    var _events;
    var allEvents = (_events = events) === null || _events === void 0 ? void 0 : _events.reduce(function(acc, curr) {
        return _to_consumable_array(acc).concat([
            {
                payloadId: curr.payloadId,
                eventType: curr.eventType,
                eventTarget: curr.eventTarget,
                banditDisplayed: curr.banditDisplayed
            }
        ]);
    }, []);
    return {
        schemaName: "multiArmedBandit",
        messageContent: {
            campaignId: campaignId,
            events: allEvents
        }
    };
};
var adaptToAdaptExSuccessEventSchema = function(lodgingAdaptExAnalyticsEvent) {
    var mappedMessages = [];
    var campaignId = lodgingAdaptExAnalyticsEvent.campaignId, events = lodgingAdaptExAnalyticsEvent.events, clientSideAnalytics = lodgingAdaptExAnalyticsEvent.clientSideAnalytics;
    if (clientSideAnalytics) {
        var _eventType;
        var referrerId = clientSideAnalytics.referrerId, eventType = clientSideAnalytics.eventType, linkName = clientSideAnalytics.linkName;
        mappedMessages.push({
            messageContent: {
                referrerId: referrerId,
                eventType: ((_eventType = eventType) === null || _eventType === void 0 ? void 0 : _eventType.toLowerCase()) || "click",
                linkName: linkName
            },
            schemaName: "referrer"
        });
    }
    if (campaignId && events) {
        mappedMessages.push(createAdaptExMicroMessage(campaignId, events));
    }
    return mappedMessages;
};
// ../internal/src/components/lodging-card/lodging-card-utils.ts
import { ITrackType as ITrackType2 } from "@shared-ui/clickstream-analytics-context";
var isCompactView = function(view) {
    return view === "COMPACT" /* COMPACT */ ;
};
var isCompactHorizontalView = function(view) {
    return view === "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ;
};
function sendProductSchemaTracking(analytics, track) {
    var _analytics_uisPrimeMessages;
    var productSchema = ((_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : _analytics_uisPrimeMessages.length) > 0 ? analytics.uisPrimeMessages.map(function(param) {
        var schemaName = param.schemaName, messageContent = param.messageContent;
        return {
            schemaName: schemaName,
            messageContent: JSON.parse(messageContent)
        };
    }) : void 0;
    track(analytics.referrerId, analytics.linkName, true, productSchema);
}
function adaptProductEvent(productEvent) {
    return _object_spread_props(_object_spread({}, productEvent), {
        event: {
            event_name: productEvent.event.eventName,
            event_type: productEvent.event.eventType,
            event_version: productEvent.event.eventVersion
        }
    });
}
function consolidateOnclick(track, event, adaptexTrack, adaptexSuccessEvents, onClick) {
    return function() {
        if (onClick) {
            onClick();
        }
        if (event) {
            track(adaptProductEvent(event));
        }
        if (adaptexSuccessEvents.length) {
            adaptexSuccessEvents.forEach(function(adaptExEvent) {
                adaptexTrack(ITrackType2.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
}
var isAd = function(mediaSection) {
    var _mediaSection_badges_secondaryBadge, _mediaSection_badges;
    return ((_mediaSection_badges = mediaSection.badges) === null || _mediaSection_badges === void 0 ? void 0 : (_mediaSection_badges_secondaryBadge = _mediaSection_badges.secondaryBadge) === null || _mediaSection_badges_secondaryBadge === void 0 ? void 0 : _mediaSection_badges_secondaryBadge.theme) === "promoted";
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
import React7 from "react";
// ../internal/src/utils/adaptex-events-filter.ts
var filterAdaptExEventsByEventType = function(adaptexActionTracking, adaptExEvents) {
    var resultAdaptExEvents;
    if (adaptexActionTracking) {
        resultAdaptExEvents = adaptExEvents.reduce(function(results, adaptExEvent) {
            var foundTracking = adaptexActionTracking.find(function(tracking) {
                return tracking.campaignId === adaptExEvent.campaignId;
            });
            if (foundTracking) {
                var _filteredEvents;
                var filteredEvents;
                if (foundTracking.eventTarget) {
                    filteredEvents = adaptExEvent.events.filter(function(event) {
                        return foundTracking.eventTarget === event.eventTarget;
                    });
                } else {
                    filteredEvents = adaptExEvent.events;
                }
                if (((_filteredEvents = filteredEvents) === null || _filteredEvents === void 0 ? void 0 : _filteredEvents.length) > 0) {
                    results.push(_object_spread_props(_object_spread({}, adaptExEvent), {
                        events: filteredEvents
                    }));
                }
            }
            return results;
        }, []);
    } else {
        resultAdaptExEvents = adaptExEvents;
    }
    return resultAdaptExEvents;
};
// ../internal/src/components/common/adaptex/adaptex-analytics-events.tsx
var initialAdaptExEvents = {
    adaptExSuccessEvents: []
};
var AdaptExEventsContext = React7.createContext(initialAdaptExEvents);
var useAdaptExEvents = function() {
    var adaptexSuccessActionTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var allAdaptExEvents = React7.useContext(AdaptExEventsContext);
    var resultAdaptExSuccessEvents = filterAdaptExEventsByEventType(adaptexSuccessActionTracking, allAdaptExEvents.adaptExSuccessEvents);
    return {
        adaptExSuccessEvents: resultAdaptExSuccessEvents
    };
};
// ../internal/src/components/lodging-card/__private/lodging-card-content-section.tsx
import React49 from "react";
import { gql as gql47 } from "@apollo/client";
import { HeadingLevelProvider } from "@shared-ui/heading-level-context";
import { ViewMedium as ViewMedium4, Viewport as Viewport4 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid4, UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing15, UitkSpacingHr } from "uitk-react-spacing";
// ../internal/src/components/common/adaptex/adaptex-success-action-tracking-fragment.ts
import { gql as gql9 } from "@apollo/client";
var AdaptexTrackingFragment = gql9(_templateObject8());
// ../internal/src/components/common/pricing-fragments.ts
import { gql as gql10 } from "@apollo/client";
var PriceSummaryFragment = gql10(_templateObject9());
// ../internal/src/components/lodging-badge/lodging-badge.tsx
import React8 from "react";
import { gql as gql11 } from "@apollo/client";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkBadge, UitkBadgeLoyalty, UitkBadgeStandard, UitkBadgeStandardThemes } from "uitk-react-badge";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
// ../internal/src/components/uitk-badge-size-mapper.tsx
import { UitkBadgeSize } from "uitk-react-badge";
var _obj;
var UitkBadgeSizeMapper = (_obj = {}, _define_property(_obj, UitkBadgeSize.SMALL, "small"), _define_property(_obj, UitkBadgeSize.LARGE, "large"), _obj);
// ../internal/src/components/uitk-badge-theme-mapper.tsx
import { UitkBadgeLoyaltyThemes, UitkBadgeTheme } from "uitk-react-badge";
var LOYALTY_EXTRA_HIGH_TIER = "loyalty-extra-high-tier";
var _obj1;
var UitkBadgeThemeMapper = (_obj1 = {}, _define_property(_obj1, UitkBadgeTheme.DEAL_BUNDLED, "deal-bundled"), _define_property(_obj1, UitkBadgeTheme.DEAL_GENERIC, "deal-generic"), _define_property(_obj1, UitkBadgeTheme.DEAL_MEMBER, "deal-member"), _define_property(_obj1, UitkBadgeTheme.NOTIFICATION_1, "notification-1"), _define_property(_obj1, UitkBadgeTheme.NOTIFICATION_2, "notification-2"), _define_property(_obj1, UitkBadgeTheme.VIP, "vip"), _define_property(_obj1, UitkBadgeTheme.LOYALTY_HIGH_TIER, "loyalty-high-tier"), _define_property(_obj1, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, "loyalty-middle-tier"), _define_property(_obj1, UitkBadgeTheme.LOYALTY_LOW_TIER, "loyalty-low-tier"), _define_property(_obj1, UitkBadgeTheme.SPONSORED, "sponsored"), _define_property(_obj1, UitkBadgeTheme.VIEWED, "viewed"), _define_property(_obj1, UitkBadgeTheme.SAVED, "saved"), _define_property(_obj1, UitkBadgeTheme.FAMILY_FRIENDLY, "family-friendly"), _define_property(_obj1, UitkBadgeTheme.SUPPLIER_PROMO, "supplier-promo"), _define_property(_obj1, UitkBadgeTheme.PROMOTED, "promoted"), _obj1);
var _obj2;
var UitkBadgeLoyaltyThemeMapper = (_obj2 = {}, _define_property(_obj2, LOYALTY_EXTRA_HIGH_TIER, UitkBadgeLoyaltyThemes.EXTRAHIGH), _define_property(_obj2, UitkBadgeTheme.LOYALTY_HIGH_TIER, UitkBadgeLoyaltyThemes.HIGH), _define_property(_obj2, UitkBadgeTheme.LOYALTY_MIDDLE_TIER, UitkBadgeLoyaltyThemes.MID), _define_property(_obj2, UitkBadgeTheme.LOYALTY_LOW_TIER, UitkBadgeLoyaltyThemes.LOW), _obj2);
var UitkBadgeLoyaltyThemePerksMessageMapper = {
    LOYALTY_EXTRA_HIGH_TIER: UitkBadgeLoyaltyThemes.EXTRAHIGH,
    LOYALTY_HIGH_TIER: UitkBadgeLoyaltyThemes.HIGH,
    LOYALTY_MIDDLE_TIER: UitkBadgeLoyaltyThemes.MID,
    LOYALTY_LOW_TIER: UitkBadgeLoyaltyThemes.LOW,
    VIP: UitkBadgeLoyaltyThemes.VIP
};
// ../internal/src/components/lodging-badge/lodging-badge.tsx
var fragment = gql11(_templateObject10());
var LodgingBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, isSRPListingCard = param.isSRPListingCard, data = param.data;
    if (!data || !data.text && !data.graphic) {
        return null;
    }
    var text = data.text, theme = data.theme, graphic = data.graphic, size = data.size;
    var graphics = function() {
        var _graphic;
        switch((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React8.createElement(UitkIcon2, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    description: graphic.description,
                    size: UitkIconSize2.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React8.createElement(UitkMark, {
                    name: graphic.id,
                    description: graphic.description,
                    size: UitkMarkSize.SMALL
                });
            default:
                return null;
        }
    };
    var DefaultUitkBadge = /* @__PURE__ */ React8.createElement(UitkBadge, {
        className: className,
        text: text || void 0,
        theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
        size: size ? UitkBadgeSizeMapper[size] : void 0
    }, graphics());
    if (theme && UitkBadgeLoyaltyThemeMapper[theme]) {
        var _graphic;
        return /* @__PURE__ */ React8.createElement(UitkBadgeLoyalty, {
            className: className,
            text: text || void 0,
            theme: theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && graphics());
    }
    if (theme === UitkBadgeThemeMapper.promoted) {
        return isSRPListingCard ? /* @__PURE__ */ React8.createElement(Experiment, {
            name: "MeSo_TravelAd_Standard_Badge"
        }, /* @__PURE__ */ React8.createElement(ExperimentControl, null, DefaultUitkBadge), /* @__PURE__ */ React8.createElement(ExperimentVariant, {
            bucket: 1
        }, /* @__PURE__ */ React8.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        })), /* @__PURE__ */ React8.createElement(ExperimentVariant, {
            bucket: 2
        }, /* @__PURE__ */ React8.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0
        }))) : DefaultUitkBadge;
    }
    if (theme && UitkBadgeStandardThemes[theme]) {
        return /* @__PURE__ */ React8.createElement(UitkBadgeStandard, {
            className: className,
            text: text || void 0,
            size: size ? UitkBadgeSizeMapper[size] : void 0,
            theme: theme ? UitkBadgeStandardThemes[theme] : void 0
        });
    }
    return DefaultUitkBadge;
};
LodgingBadge.fragment = fragment;
LodgingBadge.displayName = "LodgingBadge";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
import React12 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
import React9 from "react";
import { gql as gql12 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink5 } from "uitk-react-link";
var _obj3;
// ../internal/src/components/__private/link-map.ts
var linkSizeMapper = (_obj3 = {}, _define_property(_obj3, "SMALL" /* SMALL */ , "small"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "LARGE" /* LARGE */ , "large"), _obj3);
var _obj4;
var UILinkTargetMap = (_obj4 = {}, _define_property(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/lodging-egds-text/lodging-egds-inline-link.tsx
var fragment2 = gql12(_templateObject11());
var LodgingEGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, disabled = _param_data.disabled, linkSize = _param_data.linkSize, text = _param_data.text;
    var clickTracker = useClickTracker5();
    var onClick = React9.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React9.createElement(UitkLink5, {
        className: className,
        size: linkSizeMapper[linkSize],
        onClickCapture: onClick,
        disabled: disabled,
        inline: true
    }, /* @__PURE__ */ React9.createElement("a", {
        href: resource.value,
        target: UILinkTargetMap[target]
    }, text, accessibility && /* @__PURE__ */ React9.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
LodgingEGDSInlineLink.fragment = fragment2;
LodgingEGDSInlineLink.displayName = "LodgingEGDSInlineLink";
// ../internal/src/components/lodging-egds-text/lodging-egds-paragraph.tsx
import React10 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var fragment3 = gql13(_templateObject12());
var LodgingEGDSParagraph = function(param) {
    var data = param.data, _param_size = param.size, size = _param_size === void 0 ? 2 : _param_size;
    return /* @__PURE__ */ React10.createElement(UitkParagraph, {
        size: size
    }, data.text);
};
LodgingEGDSParagraph.fragment = fragment3;
LodgingEGDSParagraph.displayName = "LodgingEGDSParagraph";
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
import React11 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var _obj5;
// ../internal/src/components/lodging-egds-text/__private/text-theme.ts
var textThemeMapper = (_obj5 = {}, _define_property(_obj5, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj5, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj5, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj5, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj5, "INVERSE" /* INVERSE */ , "inverse"), _obj5);
var _obj6;
// ../internal/src/components/lodging-egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */ , "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */ , "regular"), _obj6);
// ../internal/src/components/lodging-egds-text/lodging-egds-stylized-text.tsx
var fragment4 = gql14(_templateObject13());
var sizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var decorativeMap = {
    HIGHLIGHT: "mark",
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
};
var EGDSStylizedText = function(_param) {
    var data = _param.data, theme = _param.theme, weight = _param.weight, size = _param.size, props = _object_without_properties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    var decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _object_spread({
        theme: data.theme ? textThemeMapper[data.theme] : theme,
        weight: data.weight ? textWeightMapper[data.weight] : weight,
        size: data.size ? sizeMap[data.size] : size
    }, props);
    var Decorative = decorative && decorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React11.createElement(Decorative, null, data.text) : data.text;
    return /* @__PURE__ */ React11.createElement(UitkText4, _object_spread({}, textProps), content, accessibility && /* @__PURE__ */ React11.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/lodging-egds-text/lodging-egds-text.tsx
var fragment5 = gql15(_templateObject14(), LodgingEGDSParagraph.fragment, EGDSStylizedText.fragment, LodgingEGDSInlineLink.fragment);
var LodgingEGDSText = function(param) {
    var size = param.size, overflow = param.overflow, spacing = param.spacing, data = param.data, align = param.align, inline = param.inline, className = param.className;
    switch(data.__typename){
        case "EGDSPlainText":
            return /* @__PURE__ */ React12.createElement(UitkText5, {
                inline: inline,
                size: size
            }, data.text);
        case "EGDSParagraph":
            return /* @__PURE__ */ React12.createElement(LodgingEGDSParagraph, {
                data: data
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React12.createElement(EGDSStylizedText, {
                size: size,
                overflow: overflow,
                spacing: spacing,
                data: data,
                align: align,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React12.createElement(LodgingEGDSInlineLink, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSText.fragment = fragment5;
LodgingEGDSText.displayName = "LodgingEGDSText";
// ../internal/src/components/lodging-egds-text/lodging-egds-heading.tsx
import React13 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var fragment6 = gql16(_templateObject15());
var LodgingEGDSHeading = function(param) {
    var tag = param.tag, size = param.size, data = param.data;
    return /* @__PURE__ */ React13.createElement(UitkHeading2, {
        tag: tag,
        size: size
    }, data.text);
};
LodgingEGDSHeading.fragment = fragment6;
LodgingEGDSHeading.displayName = "LodgingEGDSHeading";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
import React17 from "react";
import { gql as gql20 } from "@apollo/client";
import { UitkText as UitkText8 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
import React16 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/lodging-egds-graphic-text/lodging-egds-graphic-text.tsx
import React14 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
var fragment7 = gql17(_templateObject16());
var LodgingEGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, customTextSize = param.customTextSize;
    var _graphic;
    var text = data.text, graphic = data.graphic;
    return /* @__PURE__ */ React14.createElement("div", null, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && graphic.id && /* @__PURE__ */ React14.createElement(UitkSpacing5, {
        padding: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React14.createElement(UitkIcon3, {
        name: graphic.id,
        size: graphic.size ? UitkIconSize3[graphic.size] : UitkIconSize3.EXTRA_SMALL
    })), /* @__PURE__ */ React14.createElement(UitkText6, _object_spread_props(_object_spread({
        size: customTextSize || 200
    }, textProps), {
        inline: !!graphic
    }), text));
};
LodgingEGDSGraphicText.fragment = fragment7;
LodgingEGDSGraphicText.displayName = "LodgingEGDSGraphicText";
// ../internal/src/components/lodging-egds-text/lodging-egds-plain-text.tsx
import React15 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkText as UitkText7 } from "uitk-react-text";
var fragment8 = gql18(_templateObject17());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React15.createElement(UitkText7, {
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment8;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/lodging-egds-text/egds-spannable-text-content.tsx
var fragment9 = gql19(_templateObject18(), EGDSStylizedText.fragment, EGDSPlainText.fragment, LodgingEGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, data = param.data;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React16.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React16.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React16.createElement(LodgingEGDSGraphicText, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/lodging-egds-text/egds-spannable-text.tsx
var fragment10 = gql20(_templateObject19(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_contents, _data, _data_inlineContent, _data1, _data_inlineContent1, _data2;
    var align = props.align, data = props.data, styleProps = _object_without_properties(props, [
        "align",
        "data"
    ]);
    if (((_data = data) === null || _data === void 0 ? void 0 : (_data_contents = _data.contents) === null || _data_contents === void 0 ? void 0 : _data_contents.length) === 0 && !((_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_inlineContent = _data1.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React17.createElement(UitkText8, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if ((_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_inlineContent1 = _data2.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React17.createElement(React17.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React17.createElement(React17.Fragment, null, /* @__PURE__ */ React17.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            })));
        }));
    }
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React17.createElement(React17.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React17.createElement(EGDSSpannableTextContent, _object_spread({
            data: item
        }, styleProps)));
    }));
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/lodging-egds-text/lodging-egds-localized-text-template.tsx
import React18 from "react";
import { gql as gql21 } from "@apollo/client";
var fragment11 = gql21(_templateObject20());
var LodgingEGDSLocalizedTextTemplate = function(param) {
    var data = param.data, value = param.value;
    return /* @__PURE__ */ React18.createElement(React18.Fragment, null, data.template.replace("{".concat(data.token, "}"), value));
};
LodgingEGDSLocalizedTextTemplate.fragment = fragment11;
LodgingEGDSLocalizedTextTemplate.displayName = "LodgingEGDSLocalizedTextTemplate";
// ../internal/src/components/lodging-standard-badge/lodging-standard-badge.tsx
import React19 from "react";
import { gql as gql22 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkBadge as UitkBadge2, UitkBadgeLoyalty as UitkBadgeLoyalty2 } from "uitk-react-badge";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkMark as UitkMark2, UitkMarkSize as UitkMarkSize2 } from "uitk-react-mark";
var fragment12 = gql22(_templateObject21());
var LodgingStandardBadge = function(param) {
    var propertyId = param.propertyId, className = param.className, data = param.data;
    var _graphic;
    if (!data || !data.standardBadge || !data.standardBadge.text && !data.standardBadge.graphic) {
        return null;
    }
    var standardBadge = data.standardBadge, impressionEventAnalytics = data.impressionEventAnalytics;
    var text = standardBadge.text, theme = standardBadge.theme, graphic = standardBadge.graphic, size = standardBadge.size;
    var _ref = impressionEventAnalytics !== null && impressionEventAnalytics !== void 0 ? impressionEventAnalytics : {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
    var graphics = function() {
        var _graphic;
        switch((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename){
            case "Icon":
                return graphic.id && /* @__PURE__ */ React19.createElement(UitkIcon4, {
                    name: graphic.id,
                    id: propertyId ? "mod-".concat(propertyId, "-title") : void 0,
                    description: graphic.description,
                    size: UitkIconSize4.SMALL
                });
            case "Mark":
                return graphic.id && /* @__PURE__ */ React19.createElement(UitkMark2, {
                    name: graphic.id,
                    description: graphic.description,
                    size: UitkMarkSize2.SMALL
                });
            default:
                return null;
        }
    };
    var badgeLoyalty = /* @__PURE__ */ React19.createElement(UitkBadgeLoyalty2, {
        className: className,
        text: text || void 0,
        theme: theme ? UitkBadgeLoyaltyThemeMapper[theme] : void 0,
        size: size ? UitkBadgeSizeMapper[size] : void 0
    }, ((_graphic = graphic) === null || _graphic === void 0 ? void 0 : _graphic.__typename) === "Icon" && graphics());
    var lodgingBadge = referrerId && linkName ? /* @__PURE__ */ React19.createElement(IntersectionTracker, {
        referrerId: referrerId,
        linkName: linkName,
        trackOnce: true
    }, badgeLoyalty) : badgeLoyalty;
    return theme && UitkBadgeLoyaltyThemeMapper[theme] ? lodgingBadge : /* @__PURE__ */ React19.createElement(UitkBadge2, {
        className: className,
        text: text || void 0,
        theme: theme ? UitkBadgeThemeMapper[theme] : void 0,
        size: size ? UitkBadgeSizeMapper[size] : void 0
    }, graphics());
};
LodgingStandardBadge.fragment = fragment12;
LodgingStandardBadge.displayName = "LodgingStandardBadge";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
import React22 from "react";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
import { UitkPriceLockupAlign as UitkPriceLockupAlign2 } from "uitk-react-price-lockup";
// ../internal/src/components/lodging-price-summary.tsx
import React21 from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
// ../internal/src/utils/use-dialog-id.ts
import React20 from "react";
var useDialogId = function() {
    return React20.useMemo(function() {
        return Math.random().toString(36).slice(2, 7);
    }, []);
};
// ../internal/src/components/lodging-price-summary.tsx
var fragment13 = gql23(_templateObject22());
var formatStrikeOutText = function(price, points, unit, leadingCaption, isPointsFirst) {
    if (!price && !points) {
        return void 0;
    }
    if (!points) {
        var _price;
        return (_price = price) === null || _price === void 0 ? void 0 : _price.formatted;
    }
    if (!price) {
        return "".concat(points.formatted, " ").concat(unit);
    }
    if (isPointsFirst) {
        return "".concat(points.formatted, " ").concat(unit, " ").concat(leadingCaption, " ").concat(price.formatted);
    }
    return "".concat(price.formatted, " ").concat(leadingCaption, " ").concat(points.formatted, " ").concat(unit);
};
var buildUitkPriceLockupProps = function(options) {
    var _displayPrice, _displayPrice1, _otherOption, _loyaltyPoints, _loyaltyPoints1, _otherOption1, _otherOption2, _loyaltyPoints_amount, _loyaltyPoints2, _loyaltyPoints3, _priceDisclaimer_trigger_icon, _priceDisclaimer_trigger, _priceDisclaimer;
    var _options = _sliced_to_array(options, 3), leadOption = _options[0], otherOption = _options[1], disclaimerForPoints = _options[2];
    var _ref = leadOption !== null && leadOption !== void 0 ? leadOption : {}, leadingCaption = _ref.leadingCaption, loyaltyPrice = _ref.loyaltyPrice, displayPrice = _ref.displayPrice, accessibilityLabel = _ref.accessibilityLabel, priceDisclaimer = _ref.priceDisclaimer, strikeOut = _ref.strikeOut;
    if (options.length === 1 && loyaltyPrice) {
        var _loyaltyPrice_totalStrikeOutPoints, _loyaltyPrice_amount;
        var strikeThroughPoints = loyaltyPrice.totalStrikeOutPoints ? "".concat((_loyaltyPrice_totalStrikeOutPoints = loyaltyPrice.totalStrikeOutPoints) === null || _loyaltyPrice_totalStrikeOutPoints === void 0 ? void 0 : _loyaltyPrice_totalStrikeOutPoints.formatted, " ").concat(loyaltyPrice.unit) : "";
        return {
            isStrikeThroughFirst: true,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount = loyaltyPrice.amount) === null || _loyaltyPrice_amount === void 0 ? void 0 : _loyaltyPrice_amount.formatted, " ").concat(loyaltyPrice.unit),
            strikeThroughPrice: strikeThroughPoints,
            a11yPrice: accessibilityLabel || ""
        };
    }
    if (loyaltyPrice) {
        var _otherOption3, _otherOption_displayPrice, _otherOption4, _loyaltyPrice_amount1, _otherOption5, _disclaimerForPoints, _otherOption6, _disclaimerForPoints_priceDisclaimer_trigger_icon, _disclaimerForPoints_priceDisclaimer_trigger, _disclaimerForPoints_priceDisclaimer, _disclaimerForPoints1;
        var moneyPrice = "".concat((_otherOption3 = otherOption) === null || _otherOption3 === void 0 ? void 0 : _otherOption3.leadingCaption, " ").concat((_otherOption4 = otherOption) === null || _otherOption4 === void 0 ? void 0 : (_otherOption_displayPrice = _otherOption4.displayPrice) === null || _otherOption_displayPrice === void 0 ? void 0 : _otherOption_displayPrice.formatted);
        var _disclaimerForPoints_strikeOut, _otherOption_leadingCaption;
        return {
            isStrikeThroughFirst: true,
            isPointsFirst: true,
            lockupPrice: moneyPrice,
            lockupFormattedPoints: "".concat((_loyaltyPrice_amount1 = loyaltyPrice.amount) === null || _loyaltyPrice_amount1 === void 0 ? void 0 : _loyaltyPrice_amount1.formatted, " ").concat(loyaltyPrice.unit),
            a11yPrice: ((_otherOption5 = otherOption) === null || _otherOption5 === void 0 ? void 0 : _otherOption5.accessibilityLabel) || "",
            strikeThroughPrice: formatStrikeOutText((_disclaimerForPoints_strikeOut = (_disclaimerForPoints = disclaimerForPoints) === null || _disclaimerForPoints === void 0 ? void 0 : _disclaimerForPoints.strikeOut) !== null && _disclaimerForPoints_strikeOut !== void 0 ? _disclaimerForPoints_strikeOut : null, loyaltyPrice.totalStrikeOutPoints, loyaltyPrice.unit, (_otherOption_leadingCaption = (_otherOption6 = otherOption) === null || _otherOption6 === void 0 ? void 0 : _otherOption6.leadingCaption) !== null && _otherOption_leadingCaption !== void 0 ? _otherOption_leadingCaption : null, true),
            a11yStrikeThroughDialogTrigger: (_disclaimerForPoints1 = disclaimerForPoints) === null || _disclaimerForPoints1 === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer = _disclaimerForPoints1.priceDisclaimer) === null || _disclaimerForPoints_priceDisclaimer === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger = _disclaimerForPoints_priceDisclaimer.trigger) === null || _disclaimerForPoints_priceDisclaimer_trigger === void 0 ? void 0 : (_disclaimerForPoints_priceDisclaimer_trigger_icon = _disclaimerForPoints_priceDisclaimer_trigger.icon) === null || _disclaimerForPoints_priceDisclaimer_trigger_icon === void 0 ? void 0 : _disclaimerForPoints_priceDisclaimer_trigger_icon.description
        };
    }
    var leadPrice = leadingCaption ? "".concat(leadingCaption, " ").concat((_displayPrice = displayPrice) === null || _displayPrice === void 0 ? void 0 : _displayPrice.formatted) : (_displayPrice1 = displayPrice) === null || _displayPrice1 === void 0 ? void 0 : _displayPrice1.formatted;
    if (options.length === 1) {
        var _strikeOut, _priceDisclaimer_trigger_icon1, _priceDisclaimer_trigger1, _priceDisclaimer1;
        return {
            lockupPrice: leadPrice,
            a11yPrice: accessibilityLabel || "",
            strikeThroughPrice: (_strikeOut = strikeOut) === null || _strikeOut === void 0 ? void 0 : _strikeOut.formatted,
            a11yStrikeThroughDialogTrigger: (_priceDisclaimer1 = priceDisclaimer) === null || _priceDisclaimer1 === void 0 ? void 0 : (_priceDisclaimer_trigger1 = _priceDisclaimer1.trigger) === null || _priceDisclaimer_trigger1 === void 0 ? void 0 : (_priceDisclaimer_trigger_icon1 = _priceDisclaimer_trigger1.icon) === null || _priceDisclaimer_trigger_icon1 === void 0 ? void 0 : _priceDisclaimer_trigger_icon1.description
        };
    }
    var loyaltyPoints = (_otherOption = otherOption) === null || _otherOption === void 0 ? void 0 : _otherOption.loyaltyPrice;
    var _otherOption_leadingCaption1;
    return {
        isStrikeThroughFirst: true,
        isPointsFirst: false,
        strikeThroughPrice: formatStrikeOutText(strikeOut !== null && strikeOut !== void 0 ? strikeOut : null, (_loyaltyPoints = loyaltyPoints) === null || _loyaltyPoints === void 0 ? void 0 : _loyaltyPoints.totalStrikeOutPoints, (_loyaltyPoints1 = loyaltyPoints) === null || _loyaltyPoints1 === void 0 ? void 0 : _loyaltyPoints1.unit, (_otherOption_leadingCaption1 = (_otherOption1 = otherOption) === null || _otherOption1 === void 0 ? void 0 : _otherOption1.leadingCaption) !== null && _otherOption_leadingCaption1 !== void 0 ? _otherOption_leadingCaption1 : null, false),
        lockupPrice: leadPrice,
        lockupFormattedPoints: "".concat((_otherOption2 = otherOption) === null || _otherOption2 === void 0 ? void 0 : _otherOption2.leadingCaption, " ").concat((_loyaltyPoints2 = loyaltyPoints) === null || _loyaltyPoints2 === void 0 ? void 0 : (_loyaltyPoints_amount = _loyaltyPoints2.amount) === null || _loyaltyPoints_amount === void 0 ? void 0 : _loyaltyPoints_amount.formatted, " ").concat((_loyaltyPoints3 = loyaltyPoints) === null || _loyaltyPoints3 === void 0 ? void 0 : _loyaltyPoints3.unit),
        a11yStrikeThroughDialogTrigger: (_priceDisclaimer = priceDisclaimer) === null || _priceDisclaimer === void 0 ? void 0 : (_priceDisclaimer_trigger = _priceDisclaimer.trigger) === null || _priceDisclaimer_trigger === void 0 ? void 0 : (_priceDisclaimer_trigger_icon = _priceDisclaimer_trigger.icon) === null || _priceDisclaimer_trigger_icon === void 0 ? void 0 : _priceDisclaimer_trigger_icon.description,
        a11yPrice: accessibilityLabel || ""
    };
};
var getPriceDisclaimer = function(options) {
    var _options_, _options_1;
    return ((_options_ = options[0]) === null || _options_ === void 0 ? void 0 : _options_.priceDisclaimer) || ((_options_1 = options[2]) === null || _options_1 === void 0 ? void 0 : _options_1.priceDisclaimer);
};
var LodgingPriceSummary = function(param) {
    var _param_showPriceDetails = param.showPriceDetails, showPriceDetails = _param_showPriceDetails === void 0 ? true : _param_showPriceDetails, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign.LEFT : _param_align, data = param.data;
    var _price, _priceMessaging, _priceMessaging1, _priceMessaging2, _priceSubtextStandardRawData, _priceMessaging_, _priceMessaging_priceSubtextBoldIndex, _priceDisclaimer_primaryButton;
    var price = data.price;
    var trackClick = useClickTracker6();
    var dialogPostfix = useDialogId();
    var _useDialog = _sliced_to_array(useDialog("property-price-messaging-dialog-".concat(dialogPostfix), "pwaDialogNested"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    if (!((_price = price) === null || _price === void 0 ? void 0 : _price.options) || price.options.length === 0) {
        return null;
    }
    var priceMessaging = price.priceMessaging, options = price.options;
    var priceSubtextBoldIndex = ((_priceMessaging = priceMessaging) === null || _priceMessaging === void 0 ? void 0 : _priceMessaging.findIndex(function(msg) {
        return msg.theme === "STRONG" /* STRONG */ ;
    })) || -1;
    var priceSubtextStandardRawData = priceSubtextBoldIndex === -1 ? (_priceMessaging1 = priceMessaging) === null || _priceMessaging1 === void 0 ? void 0 : _priceMessaging1.slice(1) : (_priceMessaging2 = priceMessaging) === null || _priceMessaging2 === void 0 ? void 0 : _priceMessaging2.slice(1).splice(priceSubtextBoldIndex, 1);
    var priceSubtextStandard = (_priceSubtextStandardRawData = priceSubtextStandardRawData) === null || _priceSubtextStandardRawData === void 0 ? void 0 : _priceSubtextStandardRawData.map(function(msg) {
        return msg.value;
    });
    var openStrikeThroughPriceDialog = function() {
        dialogActions.openDialog();
        trackClick("HOT.HIS.Price.DisclaimerDialog", "Price Disclaimer Dialog");
    };
    var priceProps = buildUitkPriceLockupProps(options);
    var priceDisclaimer = getPriceDisclaimer(options);
    return /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(UitkPriceLockup, _object_spread_props(_object_spread({}, priceProps), {
        align: align,
        priceSubtextFirst: showPriceDetails && priceMessaging ? (_priceMessaging_ = priceMessaging[0]) === null || _priceMessaging_ === void 0 ? void 0 : _priceMessaging_.value : "",
        priceSubtextStandard: showPriceDetails ? priceSubtextStandard : void 0,
        priceSubtextBold: showPriceDetails && priceMessaging && priceSubtextBoldIndex !== -1 ? (_priceMessaging_priceSubtextBoldIndex = priceMessaging[priceSubtextBoldIndex]) === null || _priceMessaging_priceSubtextBoldIndex === void 0 ? void 0 : _priceMessaging_priceSubtextBoldIndex.value : "",
        strikeThroughTrigger: !!priceDisclaimer && /* @__PURE__ */ React21.createElement("button", {
            onClick: openStrikeThroughPriceDialog,
            type: "button",
            className: "uitk-more-info-trigger"
        }),
        stids: {
            lockupId: "price-lockup-text",
            subtextBoldId: "price-lockup-bold-subtext",
            wrapperId: "price-lockup-wrapper"
        }
    })), !!priceDisclaimer && /* @__PURE__ */ React21.createElement(DialogComponent, null, /* @__PURE__ */ React21.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React21.createElement(UitkDialogContent, null, priceDisclaimer.content[0], /* @__PURE__ */ React21.createElement(UitkDialogFooter, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_priceDisclaimer_primaryButton = priceDisclaimer.primaryButton) === null || _priceDisclaimer_primaryButton === void 0 ? void 0 : _priceDisclaimer_primaryButton.text) || "",
            type: "tertiary"
        }
    })))));
};
LodgingPriceSummary.fragment = fragment13;
LodgingPriceSummary.displayName = "LodgingPriceSummary";
// ../internal/src/components/lodging-card/lodging-card-price-section-price-summary.tsx
var mapPriceSummary = function(priceSummary) {
    var price = {
        __typename: "Offer",
        price: priceSummary
    };
    return price;
};
var PriceSectionPriceSummary = function(param) {
    var priceSection = param.priceSection, flexAlignment = param.flexAlignment, _param_align = param.align, align = _param_align === void 0 ? UitkPriceLockupAlign2.RIGHT : _param_align, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink;
    var _priceSection_priceSummary_displayMessages, _priceSection_priceSummary;
    return ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : (_priceSection_priceSummary_displayMessages = _priceSection_priceSummary.displayMessages) === null || _priceSection_priceSummary_displayMessages === void 0 ? void 0 : _priceSection_priceSummary_displayMessages.length) ? /* @__PURE__ */ React22.createElement(PriceSummary, {
        data: priceSection.priceSummary,
        flexAlignment: flexAlignment,
        enableInlineLink: enableInlineLink
    }) : /* @__PURE__ */ React22.createElement(LodgingPriceSummary, {
        align: align,
        data: mapPriceSummary(priceSection.priceSummary)
    });
};
// ../internal/src/components/lodging-card/__private/lodging-card-compare-section.tsx
import React23, { useCallback as useCallback2, useContext } from "react";
import { gql as gql24 } from "@apollo/client";
import { useProvidedState } from "@shared-ui/provided-state-context";
import { CompareAdaptExContext } from "@shared-ui/retail-compare-providers";
import { UitkCheckbox } from "uitk-react-checkbox";
import { UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
// ../internal/src/components/lodging-compare/lodging-compare-state.tsx
var STATE_FIELD_NAME = "lodgingCompare";
var MAX_SELECTABLE = 5;
var defaultState = {
    searchResultsProperties: [],
    comparePropertyIds: [],
    isDialogOpen: false
};
var SET_PROPERTIES = "".concat(STATE_FIELD_NAME, ".setProperties");
var ADD_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".addCompareProperty");
var REMOVE_COMPARE_PROPERTY = "".concat(STATE_FIELD_NAME, ".removeCompareProperty");
var OPEN_DIALOG = "".concat(STATE_FIELD_NAME, ".openDialog");
var CLOSE_DIALOG = "".concat(STATE_FIELD_NAME, ".closeDialog");
var ADD_COMPARE_PROPERTIES = "".concat(STATE_FIELD_NAME, ".addCompareProperties");
var REMOVE_COMPARE_PROPERTIES = "".concat(STATE_FIELD_NAME, ".removeCompareProperties");
// ../internal/src/components/lodging-card/__private/lodging-card-compare-section.tsx
var fragment14 = gql24(_templateObject23(), clientSideAnalyticsFragment);
var LodgingCardCompareSection = function(param) {
    var propertyId = param.propertyId, isAd2 = param.isAd, data = param.data;
    var compareAction = data.compareAction;
    var _useProvidedState = _sliced_to_array(useProvidedState(), 2), state = _useProvidedState[0], dispatch = _useProvidedState[1];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var cardId = isAd2 ? propertyId.concat("-ad") : propertyId;
    var checked = comparePropertyIds.includes(cardId);
    var uniquePropertyIds = _to_consumable_array(new Set(comparePropertyIds.map(function(id2) {
        return id2.split("-")[0];
    })));
    var disabled = uniquePropertyIds.length >= MAX_SELECTABLE && !checked;
    var checkboxClickTrack = useTrackClientSideAnalytics(checked ? data.compareAction.uncheckedAnalytics : data.compareAction.checkedAnalytics);
    var setCheck = useCallback2(function() {
        checkboxClickTrack();
        dispatch({
            type: checked ? "lodgingCompare.removeCompareProperty" : "lodgingCompare.addCompareProperty",
            payload: {
                propertyId: cardId
            }
        });
    }, [
        checked
    ]);
    var id = "lodging-card-compare-checkbox-".concat(propertyId);
    var _useContext = _sliced_to_array(useContext(CompareAdaptExContext), 1), enabled = _useContext[0].enabled;
    if (!enabled) {
        return null;
    }
    return /* @__PURE__ */ React23.createElement(UitkLayoutPosition, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React23.createElement(UitkLayoutFlexItem2, {
        alignSelf: "end"
    }, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement(UitkCheckbox, {
        id: isAd2 ? id.concat("-ad") : id,
        checked: checked,
        onChange: setCheck,
        disabled: disabled
    }, /* @__PURE__ */ React23.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            bottom: "zero",
            right: "minus-two"
        }
    }, /* @__PURE__ */ React23.createElement("div", null)), compareAction.label.text))));
};
LodgingCardCompareSection.fragment = fragment14;
LodgingCardCompareSection.displayName = "LodgingCardCompareSection";
// ../internal/src/components/lodging-card/__private/lodging-card-date-section.tsx
import React24 from "react";
import { gql as gql25 } from "@apollo/client";
var fragment15 = gql25(_templateObject24(), EGDSStylizedText.fragment);
var LodgingCardDateSection = function(param) {
    var data = param.data;
    var date = data.date;
    return date ? /* @__PURE__ */ React24.createElement(LodgingEGDSText, {
        data: date,
        align: "right"
    }) : null;
};
LodgingCardDateSection.fragment = fragment15;
LodgingCardDateSection.displayName = "LodgingCardDateSection";
// ../internal/src/components/lodging-card/__private/lodging-card-heading-section.tsx
import React29 from "react";
import { gql as gql30 } from "@apollo/client";
import { useHeadingLevelContext } from "@shared-ui/heading-level-context";
import { UitkIcon as UitkIcon7, UitkIconSize as UitkIconSize7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText11 } from "uitk-react-text";
import { UitkToolbar, UitkToolbarButton } from "uitk-react-toolbar";
// ../internal/src/components/lodging-egds-rating/lodging-egds-rating.tsx
import React25 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var fragment16 = gql26(_templateObject25());
var LodgingEGDSRating = function(param) {
    var data = param.data;
    var _icon;
    var icon = data.icon;
    var _data_accessibility;
    return /* @__PURE__ */ React25.createElement(UitkRating, {
        icon: (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id,
        rating: String(data.rating),
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
LodgingEGDSRating.fragment = fragment16;
LodgingEGDSRating.displayName = "LodgingEGDSRating";
// ../internal/src/components/lodging-card/__private/lodging-card-featured-message.tsx
import React26 from "react";
import { gql as gql27 } from "@apollo/client";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
import { UitkText as UitkText9 } from "uitk-react-text";
var fragment17 = gql27(_templateObject26());
var LodgingCardFeaturedMessage = function(param) {
    var data = param.data, index = param.index;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, index > 0 && /* @__PURE__ */ React26.createElement(UitkText9, {
        "aria-hidden": "true",
        weight: "bold",
        size: 300
    }, "\xb7"), icon && /* @__PURE__ */ React26.createElement(UitkIcon5, {
        name: icon.id || "visibility",
        description: icon.description || "",
        size: icon.size ? UitkIconSize5[icon.size] : UitkIconSize5.SMALL,
        "data-stid": "uitk-icon"
    }), /* @__PURE__ */ React26.createElement(UitkText9, null, text));
};
LodgingCardFeaturedMessage.fragment = fragment17;
LodgingCardFeaturedMessage.displayName = "LodgingCardFeaturedMessage";
// ../internal/src/components/lodging-card/__private/lodging-product-amenity.tsx
import React28 from "react";
import { gql as gql29 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText10 } from "uitk-react-text";
// ../internal/src/components/lodging-egds-icon/lodging-egds-icon.tsx
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize6 } from "uitk-react-icons";
var fragment18 = gql28(_templateObject27());
var LodgingEGDSIcon = function(param) {
    var ariaHidden = param.ariaHidden, data = param.data;
    var description = data.description, id = data.id, size = data.size, theme = data.theme;
    var _ref;
    return /* @__PURE__ */ React27.createElement(UitkIcon6, {
        description: ariaHidden ? void 0 : description,
        title: ariaHidden ? void 0 : description,
        id: id,
        name: id,
        size: (_ref = size && UitkIconSize6[size]) !== null && _ref !== void 0 ? _ref : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
LodgingEGDSIcon.fragment = fragment18;
LodgingEGDSIcon.displayName = "LodgingEGDSIcon";
// ../internal/src/components/lodging-card/__private/lodging-product-amenity.tsx
var fragment19 = gql29(_templateObject28(), LodgingEGDSIcon.fragment);
var LodgingProductAmenity = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React28.createElement(UitkSpacing6, {
        margin: {
            inlineend: "three"
        },
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React28.createElement(UitkLayoutFlex3, {
        space: "two",
        alignItems: "center"
    }, /* @__PURE__ */ React28.createElement(LodgingEGDSIcon, {
        ariaHidden: true,
        data: data.icon
    }), /* @__PURE__ */ React28.createElement(UitkText10, {
        size: 200,
        overflow: "truncate"
    }, data.text)));
};
LodgingProductAmenity.fragment = fragment19;
LodgingProductAmenity.displayName = "LodgingProductAmenity";
// ../internal/src/components/lodging-card/__private/lodging-card-heading-section.tsx
var fragment20 = gql30(_templateObject29(), LodgingEGDSRating.fragment, LodgingCardFeaturedMessage.fragment, LodgingEGDSText.fragment, LodgingProductAmenity.fragment);
var LodgingCardHeadingSection = function(param) {
    var data = param.data, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 5 : _param_headingSize, wrapHeadingText = param.wrapHeadingText, showDismissButton = param.showDismissButton, // TODO: To remove this property when the test is a winner; and depend on the server response for the Icon
    onCardDismiss = param.onCardDismiss, isReview = param.isReview, isOptimizedView = param.isOptimizedView;
    var _messages;
    var heading = data.heading, productRating = data.productRating, featuredMessages = data.featuredMessages, messages = data.messages, amenities = data.amenities;
    var headingLevel = useHeadingLevelContext(1).headingLevel;
    var dismissButtonProps = {
        id: "close",
        name: "close",
        size: UitkIconSize7.MEDIUM,
        title: "close"
    };
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(UitkLayoutFlex4, {
        justifyContent: "space-between",
        space: "two"
    }, /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React29.createElement(UitkLayoutGrid3, {
        rows: [
            "min-content"
        ]
    }, /* @__PURE__ */ React29.createElement(UitkLayoutGridItem3, {
        rowSpan: 1
    }, featuredMessages.length > 0 && /* @__PURE__ */ React29.createElement(UitkLayoutFlex4, {
        space: "one",
        alignItems: "center"
    }, featuredMessages.map(function(featuredMessage, index) {
        return /* @__PURE__ */ React29.createElement(LodgingCardFeaturedMessage, {
            data: featuredMessage,
            key: "featuredMessage-".concat(index),
            index: index
        });
    }))), /* @__PURE__ */ React29.createElement(UitkLayoutGridItem3, {
        rowSpan: 1
    }, showDismissButton && /* @__PURE__ */ React29.createElement(UitkHeading3, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: headingSize,
        overflow: "truncate-2-lines"
    }, heading) || /* @__PURE__ */ React29.createElement(UitkHeading3, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: headingSize,
        overflow: wrapHeadingText ? "wrap" : "truncate"
    }, heading)))), /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem3, null, showDismissButton && onCardDismiss && /* @__PURE__ */ React29.createElement(UitkText11, null, /* @__PURE__ */ React29.createElement(UitkLayoutPosition2, {
        type: "absolute",
        position: {
            right: "minus-two",
            top: "zero"
        }
    }, /* @__PURE__ */ React29.createElement(UitkToolbar, {
        elevation: "flat",
        toolbarActionContent: /* @__PURE__ */ React29.createElement(UitkToolbarButton, {
            buttonId: "close-map-card",
            onClick: onCardDismiss
        }, /* @__PURE__ */ React29.createElement(UitkIcon7, _object_spread({}, dismissButtonProps)))
    }))))), productRating && /* @__PURE__ */ React29.createElement(LodgingEGDSRating, {
        data: productRating
    }), !isReview && ((_messages = messages) === null || _messages === void 0 ? void 0 : _messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React29.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: isOptimizedView ? void 0 : "half",
            size: 300,
            data: message
        });
    })), amenities.length > 0 && /* @__PURE__ */ React29.createElement(UitkSpacing7, {
        margin: {
            blockstart: isOptimizedView ? "half" : "one"
        }
    }, /* @__PURE__ */ React29.createElement(UitkLayoutFlex4, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem3, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React29.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    }))));
};
LodgingCardHeadingSection.fragment = fragment20;
LodgingCardHeadingSection.displayName = "LodgingCardHeadingSection";
// ../internal/src/components/lodging-card/__private/lodging-card-marketing-fee-detail.tsx
import React30 from "react";
import { gql as gql31 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkDialog as UitkDialog2, UitkDialogContent as UitkDialogContent2, UitkDialogFooter as UitkDialogFooter2 } from "uitk-react-dialog";
import { UitkIcon as UitkIcon8, UitkIconSize as UitkIconSize8 } from "uitk-react-icons";
import { UitkMark as UitkMark3, UitkMarkSize as UitkMarkSize3 } from "uitk-react-mark";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
var fragment21 = gql31(_templateObject30());
var LodgingCardMarketingFeeDetail = function(param) {
    var id = param.id, data = param.data;
    var _marketingFeeMessageDialog_dialog_footer_buttons_;
    var tierMessage = data.tierMessage, marketingFeeMessageDialog = data.marketingFeeMessageDialog;
    var marketingFeeDialogId = id ? "priceMarketingFeeDialog-".concat(id) : "priceMarketingFeeDialog";
    var _useDialog2 = _sliced_to_array(useDialog2(marketingFeeDialogId, "pwaDialog"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var track = useClickTracker7();
    var openDialog = function() {
        track("TAAP.MarketingFee.Details", "Open SRP Commission Information Dialog");
        dialogActions.openDialog();
    };
    if (!marketingFeeMessageDialog || !tierMessage) {
        return null;
    }
    return /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(UitkMoreInfoTrigger, {
        onClick: openDialog,
        "data-stid": "marketing-fee-info"
    }, /* @__PURE__ */ React30.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React30.createElement(UitkSpacing8, {
        padding: {
            inlineend: "two"
        }
    }, tierMessage.egdsMark && /* @__PURE__ */ React30.createElement(UitkMark3, {
        name: tierMessage.egdsMark.id,
        size: UitkMarkSize3.SMALL
    })), /* @__PURE__ */ React30.createElement(UitkText12, {
        overflow: "truncate",
        inline: true
    }, tierMessage.value), /* @__PURE__ */ React30.createElement(UitkIcon8, {
        name: "info_outline",
        size: UitkIconSize8.SMALL
    }))), /* @__PURE__ */ React30.createElement(DialogComponent, null, /* @__PURE__ */ React30.createElement(UitkDialog2, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React30.createElement(UitkDialogContent2, null, marketingFeeMessageDialog.content.map(function(content, index) {
        return /* @__PURE__ */ React30.createElement(UitkText12, {
            key: "marketing-fee-message-".concat(index)
        }, content);
    }), /* @__PURE__ */ React30.createElement(UitkDialogFooter2, {
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: ((_marketingFeeMessageDialog_dialog_footer_buttons_ = marketingFeeMessageDialog.dialog.footer.buttons[0]) === null || _marketingFeeMessageDialog_dialog_footer_buttons_ === void 0 ? void 0 : _marketingFeeMessageDialog_dialog_footer_buttons_.primary) || "",
            type: "tertiary"
        }
    })))));
};
LodgingCardMarketingFeeDetail.fragment = fragment21;
LodgingCardMarketingFeeDetail.displayName = "LodgingCardMarketingFeeDetail";
// ../internal/src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
import React47 from "react";
import { gql as gql46 } from "@apollo/client";
import { useHeadingLevelContext as useHeadingLevelContext2 } from "@shared-ui/heading-level-context";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
// ../internal/src/components/lodging-card/__private/lodging-card-badged-rating.tsx
import React32 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
// ../internal/src/components/egds/egds-badge/egds-badge.tsx
import React31 from "react";
import { gql as gql32 } from "@apollo/client";
import { UitkBadgeSize as UitkBadgeSize2, UitkBadgeStandard as UitkBadgeStandard2 } from "uitk-react-badge";
// ../internal/src/components/egds/egds-badge/__private/egds-standard-badge-theme.ts
var standardBadgeThemes = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// ../internal/src/components/egds/egds-badge/egds-badge.tsx
var fragment22 = gql32(_templateObject31());
var EGDSBadge = function(param) {
    var data = param.data;
    var _theme;
    var accessibility = data.accessibility, text = data.text, size = data.size, theme = data.theme;
    var _ref;
    var badgeSize = (_ref = size && UitkBadgeSize2[size.toUpperCase()]) !== null && _ref !== void 0 ? _ref : UitkBadgeSize2.LARGE;
    if (!text) {
        return null;
    }
    var _theme_toLowerCase;
    var selectedTheme = standardBadgeThemes[(_theme_toLowerCase = (_theme = theme) === null || _theme === void 0 ? void 0 : _theme.toLowerCase()) !== null && _theme_toLowerCase !== void 0 ? _theme_toLowerCase : "standard"];
    return /* @__PURE__ */ React31.createElement(UitkBadgeStandard2, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        text: text,
        size: badgeSize,
        theme: selectedTheme
    });
};
EGDSBadge.fragment = fragment22;
EGDSBadge.displayName = "EGDSBadge";
// ../internal/src/components/lodging-card/__private/lodging-card-badged-rating.tsx
var fragment23 = gql33(_templateObject32(), EGDSBadge.fragment, EGDSStylizedText.fragment);
var ReviewRating = function(param) {
    var part = param.part;
    var phraseParts = part.phraseParts;
    return /* @__PURE__ */ React32.createElement(UitkLayoutFlex5, {
        alignItems: "center",
        wrap: "wrap"
    }, phraseParts.filter(function(element) {
        return element.__typename === "EGDSStylizedText";
    }).map(function(phrasePart, index) {
        return(// eslint-disable-next-line react/jsx-key
        /* @__PURE__ */ React32.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React32.createElement(UitkSpacing9, {
            margin: index < phraseParts.length ? {
                inlineend: "two"
            } : void 0
        }, /* @__PURE__ */ React32.createElement("span", null, /* @__PURE__ */ React32.createElement(LodgingEGDSText, {
            data: phrasePart,
            overflow: "truncate-2-lines"
        })))));
    }));
};
var LodgingCardBadgedRating = function(param) {
    var data = param.data;
    var _phrases;
    var badge = data.badge, phrases = data.phrases;
    return /* @__PURE__ */ React32.createElement(UitkLayoutFlex5, {
        alignItems: "center",
        space: "one"
    }, badge.text && badge.theme && /* @__PURE__ */ React32.createElement(UitkLayoutFlex5, {
        alignItems: "center"
    }, /* @__PURE__ */ React32.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React32.createElement(EGDSBadge, {
        data: badge
    }))), /* @__PURE__ */ React32.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React32.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, (_phrases = phrases) === null || _phrases === void 0 ? void 0 : _phrases.map(function(part, index) {
        return /* @__PURE__ */ React32.createElement(UitkLayoutFlexItem4, {
            key: "guest-rate-line-".concat(index)
        }, /* @__PURE__ */ React32.createElement(ReviewRating, {
            key: "guest-rate-".concat(index),
            part: part
        }));
    }))));
};
LodgingCardBadgedRating.fragment = fragment23;
LodgingCardBadgedRating.displayName = "LodgingCardGuestRatingSection";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
import React36 from "react";
import { gql as gql36 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { usePackageOperations } from "@shared-ui/multi-item-operations-providers";
import { UitkDialogContent as UitkDialogContent3 } from "uitk-react-dialog";
import { UitkSheet } from "uitk-react-sheet";
// ../internal/src/components/egds/egds-toolbar/egds-dialog-toolbar.tsx
import React33 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var fragment24 = gql34(_templateObject33());
var EGDSDialogToolbar = function(param) {
    var data = param.data, toolbarType = param.toolbarType, toolbarAction = param.toolbarAction;
    var _data_closeText;
    return /* @__PURE__ */ React33.createElement(UitkToolbar2, {
        toolbarTitle: data.title,
        navigationContent: {
            onClick: toolbarAction,
            navType: toolbarType,
            navIconLabel: (_data_closeText = data.closeText) !== null && _data_closeText !== void 0 ? _data_closeText : void 0
        }
    });
};
EGDSDialogToolbar.fragment = fragment24;
EGDSDialogToolbar.displayName = "EGDSDialogToolbar";
// ../internal/src/components/lodging-card/lodging-card-content-provider.tsx
import React34 from "react";
var LodgingCardContentContext = React34.createContext(void 0);
var useLodgingCardContentContext = function() {
    var context = React34.useContext(LodgingCardContentContext);
    if (context === void 0) {
        throw new Error("useLodgingCardContentContext must be used with a ILodgingCardContentContext.Provider");
    }
    return context;
};
// ../internal/src/components/lodging-card/__private/lodging-card-more-details-trigger.tsx
import React35 from "react";
import { gql as gql35 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
var fragment25 = gql35(_templateObject34(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker8();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React35.createElement(UitkSecondaryButton, {
        onClick: onClick,
        "aria-label": accessibilityLabel,
        domRef: triggerRef
    }, /* @__PURE__ */ React35.createElement(React35.Fragment, null, label, icon && /* @__PURE__ */ React35.createElement(LodgingEGDSIcon, {
        data: icon
    })));
};
LodgingCardMoreDetailsTrigger.fragment = fragment25;
LodgingCardMoreDetailsTrigger.displayName = "LodgingCardMoreDetailsTrigger";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-dialog-action.tsx
var fragment26 = gql36(_templateObject35(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsTrigger.fragment);
var LodgingCardChangeUnitDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var track = useClickTracker9();
    var triggerRef = React36.useRef(null);
    var _useDialog3 = _sliced_to_array(useDialog3("LodgingCardChangeUnitDialog"), 3), lodgingCardChangeUnitDialogActions = _useDialog3[1], LodgingCardChangeUnitDialogComponent = _useDialog3[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardChangeUnitDialogActions.closeDialog();
    };
    var openDialogWithButton = function() {
        if (lodgingCardChangeUnitDialogActions) {
            lodgingCardChangeUnitDialogActions.openDialog();
        }
    };
    var state = usePackageOperations().state;
    React36.useEffect(function() {
        if (state.selectPackage.status === "IN_PROGRESS") {
            lodgingCardChangeUnitDialogActions.closeDialog();
        }
    }, [
        state.selectPackage.status
    ]);
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: openDialogWithButton,
        data: trigger,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React36.createElement(LodgingCardChangeUnitDialogComponent, null, /* @__PURE__ */ React36.createElement(UitkSheet, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React36.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React36.createElement(UitkDialogContent3, null, /* @__PURE__ */ React36.createElement(ChangeUnitContent, null)))));
};
LodgingCardChangeUnitDialogAction.fragment = fragment26;
LodgingCardChangeUnitDialogAction.displayName = "LodgingCardChangeUnitDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-change-unit-sheet-action.tsx
import React37 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { usePackageOperations as usePackageOperations2 } from "@shared-ui/multi-item-operations-providers";
import { ViewExtraLarge, ViewLarge, ViewMedium, Viewport } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet2, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
var fragment27 = gql37(_templateObject36(), LodgingCardMoreDetailsTrigger.fragment);
var SheetContent = function() {
    var ChangeUnitContent = useLodgingCardContentContext().ChangeUnitContent;
    return /* @__PURE__ */ React37.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React37.createElement(UitkSpacing10, {
        padding: "three"
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(ChangeUnitContent, null))));
};
var LodgingCardChangeUnitSheetAction = function(param) {
    var _param_data = param.data, sheet = _param_data.sheet, trigger = _param_data.trigger;
    var track = useClickTracker10();
    var _React37_useState = _sliced_to_array(React37.useState(false), 2), visible = _React37_useState[0], setVisible = _React37_useState[1];
    var toggleSideSheet = function() {
        setVisible(function(prevState) {
            return !prevState;
        });
    };
    var closeButtonAction = function() {
        var _sheet_closeAnalytics = sheet.closeAnalytics, referrerId = _sheet_closeAnalytics.referrerId, linkName = _sheet_closeAnalytics.linkName;
        track(referrerId, linkName);
        setVisible(false);
    };
    var state = usePackageOperations2().state;
    React37.useEffect(function() {
        if (state.selectPackage.status === "SUCCESS" || state.selectPackage.status === "FAILURE") {
            setVisible(false);
        }
    }, [
        state.selectPackage.status
    ]);
    var commonUitkSheetProps = {
        isVisible: visible,
        type: "side",
        triggerRef: null
    };
    var renderToolbar = function() {
        var _sheet_closeText;
        return /* @__PURE__ */ React37.createElement(UitkToolbar3, {
            navigationContent: {
                onClick: closeButtonAction,
                navIconLabel: (_sheet_closeText = sheet.closeText) !== null && _sheet_closeText !== void 0 ? _sheet_closeText : ""
            }
        });
    };
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(LodgingCardMoreDetailsTrigger, {
        onClickAction: toggleSideSheet,
        data: trigger
    }), /* @__PURE__ */ React37.createElement(Viewport, null, /* @__PURE__ */ React37.createElement(ViewMedium, null, /* @__PURE__ */ React37.createElement(UitkSheet2, _object_spread_props(_object_spread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 6
        }
    }), renderToolbar(), /* @__PURE__ */ React37.createElement(SheetContent, null))), /* @__PURE__ */ React37.createElement(ViewLarge, null, /* @__PURE__ */ React37.createElement(UitkSheet2, _object_spread_props(_object_spread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React37.createElement(SheetContent, null))), /* @__PURE__ */ React37.createElement(ViewExtraLarge, null, /* @__PURE__ */ React37.createElement(UitkSheet2, _object_spread_props(_object_spread({}, commonUitkSheetProps), {
        sideSheetLayout: {
            position: "trailing",
            columns: 4
        }
    }), renderToolbar(), /* @__PURE__ */ React37.createElement(SheetContent, null)))));
};
LodgingCardChangeUnitSheetAction.fragment = fragment27;
LodgingCardChangeUnitSheetAction.displayName = "LodgingCardChangeUnitSheetAction";
// ../internal/src/components/lodging-card/__private/lodging-card-guest-rating.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize9 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var fragment28 = gql38(_templateObject37(), LodgingEGDSText.fragment, EGDSStylizedText.fragment);
var GuestReviewRating = function(param) {
    var part = param.part, index = param.index, isReview = param.isReview, size = param.size;
    return /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem5, null, isReview ? /* @__PURE__ */ React38.createElement(UitkSpacing11, {
        margin: index === 1 ? {
            inlineend: "two"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React38.createElement("span", null, /* @__PURE__ */ React38.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))) : /* @__PURE__ */ React38.createElement(UitkSpacing11, {
        padding: index === 0 ? {
            inlineend: "half"
        } : {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React38.createElement("span", null, /* @__PURE__ */ React38.createElement(LodgingEGDSText, {
        data: part,
        inline: true,
        size: size
    }))));
};
var LodgingCardGuestRating = function(param) {
    var data = param.data, size = param.size, isReview = param.isReview;
    var _phraseParts;
    var parts = data.parts, accessibilityLabel = data.accessibilityLabel, phraseParts = data.phraseParts;
    var ratingPart = (_phraseParts = phraseParts) === null || _phraseParts === void 0 ? void 0 : _phraseParts.find(function(part) {
        return part.__typename === "EGDSIconRating";
    });
    var Parts = React38.useMemo(function() {
        if (parts.length) {
            return parts.map(function(part, index) {
                return /* @__PURE__ */ React38.createElement(GuestReviewRating, {
                    key: "guest-rate-parts-".concat(index),
                    part: part,
                    index: index,
                    isReview: isReview,
                    size: size
                });
            });
        }
        return phraseParts.filter(function(phrasePart) {
            return phrasePart !== ratingPart;
        }).map(function(part, index) {
            return /* @__PURE__ */ React38.createElement(GuestReviewRating, {
                key: "guest-rate-phrase-parts-".concat(index),
                part: part,
                index: index,
                isReview: isReview,
                size: size
            });
        });
    }, [
        isReview,
        parts,
        phraseParts,
        ratingPart,
        size
    ]);
    return /* @__PURE__ */ React38.createElement(UitkLayoutFlex6, {
        alignItems: "start"
    }, ratingPart && /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem5, {
        alignSelf: "center"
    }, /* @__PURE__ */ React38.createElement(UitkIcon9, {
        name: ratingPart.icon.token || "star",
        theme: ratingPart.icon.theme || "default",
        size: ratingPart.icon.size ? UitkIconSize9[ratingPart.icon.size] : UitkIconSize9.EXTRA_SMALL
    })), /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React38.createElement("div", {
        "aria-hidden": !!accessibilityLabel
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex6, {
        wrap: "wrap"
    }, Parts))), accessibilityLabel && /* @__PURE__ */ React38.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel));
};
LodgingCardGuestRating.fragment = fragment28;
LodgingCardGuestRating.displayName = "LodgingCardGuestRating";
// ../internal/src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
import React43 from "react";
import { gql as gql42 } from "@apollo/client";
// ../internal/src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
import React40 from "react";
import { gql as gql40 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
// ../internal/src/components/lodging-card/__private/lodging-card-more-details-link-trigger.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink6 } from "uitk-react-link";
var fragment29 = gql39(_templateObject38(), LodgingEGDSIcon.fragment);
var LodgingCardMoreDetailsLinkTrigger = function(param) {
    var onClickAction = param.onClickAction, triggerRef = param.triggerRef, _param_data = param.data, accessibilityLabel = _param_data.accessibilityLabel, analytics = _param_data.analytics, icon = _param_data.icon, label = _param_data.label;
    var track = useClickTracker11();
    var onClick = function() {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        track(referrerId, linkName);
        onClickAction();
    };
    return /* @__PURE__ */ React39.createElement(UitkLink6, {
        onClick: onClick,
        "aria-label": accessibilityLabel
    }, /* @__PURE__ */ React39.createElement("button", {
        type: "button",
        ref: triggerRef
    }, /* @__PURE__ */ React39.createElement("div", null, label, icon && /* @__PURE__ */ React39.createElement(LodgingEGDSIcon, {
        data: icon
    }))));
};
LodgingCardMoreDetailsLinkTrigger.fragment = fragment29;
LodgingCardMoreDetailsLinkTrigger.displayName = "LodgingCardMoreDetailsLinkTrigger";
// ../internal/src/components/lodging-card/__private/lodging-card-property-details-dialog-action.tsx
var fragment30 = gql40(_templateObject39(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardPropertyDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var PropertyDetailsContent = useLodgingCardContentContext().PropertyDetailsContent;
    var track = useClickTracker12();
    var triggerRef = React40.useRef(null);
    var _useDialog4 = _sliced_to_array(useDialog4("LodgingCardPropertyDetailsDialog"), 3), lodgingCardPropertyDetailsDialogActions = _useDialog4[1], LodgingCardPropertyDetailsDialogComponent = _useDialog4[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyDetailsDialogActions.closeDialog();
    };
    return /* @__PURE__ */ React40.createElement(React40.Fragment, null, /* @__PURE__ */ React40.createElement(UitkLayoutFlex7, null, /* @__PURE__ */ React40.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React40.createElement(LodgingCardPropertyDetailsDialogComponent, null, /* @__PURE__ */ React40.createElement(UitkSheet3, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React40.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React40.createElement(UitkDialogContent4, null, /* @__PURE__ */ React40.createElement(PropertyDetailsContent, null)))));
};
LodgingCardPropertyDetailsDialogAction.fragment = fragment30;
LodgingCardPropertyDetailsDialogAction.displayName = "LodgingCardPropertyDetailsDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-unit-details-dialog-action.tsx
import React42 from "react";
import { gql as gql41 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet4, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
// ../internal/src/components/dialog-context.tsx
import React41 from "react";
var DialogContext = React41.createContext(false);
var dialog_context_default = DialogContext;
// ../internal/src/components/lodging-card/__private/lodging-card-unit-details-dialog-action.tsx
var fragment31 = gql41(_templateObject40(), EGDSDialogToolbar.fragment, LodgingCardMoreDetailsLinkTrigger.fragment);
var LodgingCardUnitDetailsDialogAction = function(param) {
    var _param_data = param.data, dialog = _param_data.dialog, trigger = _param_data.trigger;
    var closeAnalytics = dialog.closeAnalytics, toolbar = dialog.toolbar;
    var RoomDetailsContent = useLodgingCardContentContext().RoomDetailsContent;
    var track = useClickTracker13();
    var triggerRef = React42.useRef(null);
    var _useDialog5 = _sliced_to_array(useDialog5("LodgingCardPropertyRoomDetailsDialog"), 3), isDialogOpen = _useDialog5[0], lodgingCardPropertyRoomDetailsDialogActions = _useDialog5[1], LodgingCardPropertyRoomDetailsDialogComponent = _useDialog5[2];
    var toolbarAction = function() {
        if (closeAnalytics) {
            track(closeAnalytics.referrerId, closeAnalytics.linkName);
        }
        lodgingCardPropertyRoomDetailsDialogActions.closeDialog();
    };
    var dialogContent = /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement(EGDSDialogToolbar, {
        data: toolbar,
        toolbarAction: toolbarAction,
        toolbarType: "close"
    }), /* @__PURE__ */ React42.createElement(UitkSheetContent2, {
        padded: false
    }, /* @__PURE__ */ React42.createElement(dialog_context_default.Provider, {
        value: true
    }, /* @__PURE__ */ React42.createElement(RoomDetailsContent, null))));
    var sheetProps = {
        isVisible: isDialogOpen,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement(UitkLayoutFlex8, null, /* @__PURE__ */ React42.createElement(LodgingCardMoreDetailsLinkTrigger, {
        onClickAction: lodgingCardPropertyRoomDetailsDialogActions.openDialog,
        data: trigger,
        triggerRef: triggerRef
    })), /* @__PURE__ */ React42.createElement(LodgingCardPropertyRoomDetailsDialogComponent, null, /* @__PURE__ */ React42.createElement(Viewport2, null, /* @__PURE__ */ React42.createElement(ViewSmall, null, /* @__PURE__ */ React42.createElement(UitkSheet4, _object_spread_props(_object_spread({}, sheetProps), {
        type: "full"
    }), dialogContent)), /* @__PURE__ */ React42.createElement(ViewMedium2, null, /* @__PURE__ */ React42.createElement(UitkSheet4, _object_spread_props(_object_spread({}, sheetProps), {
        type: "centered"
    }), dialogContent)))));
};
LodgingCardUnitDetailsDialogAction.fragment = fragment31;
LodgingCardUnitDetailsDialogAction.displayName = "LodgingCardUnitDetailsDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-card-property-dialog-action.tsx
var fragment32 = gql42(_templateObject41(), LodgingCardPropertyDetailsDialogAction.fragment, LodgingCardUnitDetailsDialogAction.fragment);
var LodgingCardPropertyDialogAction = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "LodgingCardPropertyDetailsDialog":
            return /* @__PURE__ */ React43.createElement(LodgingCardPropertyDetailsDialogAction, {
                data: data
            });
        case "LodgingCardUnitDetailsDialog":
            return /* @__PURE__ */ React43.createElement(LodgingCardUnitDetailsDialogAction, {
                data: data
            });
        default:
            return null;
    }
};
LodgingCardPropertyDialogAction.fragment = fragment32;
LodgingCardPropertyDialogAction.displayName = "LodgingCardPropertyDialogAction";
// ../internal/src/components/lodging-card/__private/lodging-product-description.tsx
import React44 from "react";
import { gql as gql43 } from "@apollo/client";
import { UitkText as UitkText13 } from "uitk-react-text";
var fragment33 = gql43(_templateObject42());
var LodgingCardPropertyDescriptionSection = function(param) {
    var data = param.data, isReview = param.isReview;
    var heading = data.heading, description = data.description;
    return /* @__PURE__ */ React44.createElement(React44.Fragment, null, heading && /* @__PURE__ */ React44.createElement(UitkText13, {
        size: 200,
        weight: "bold"
    }, heading.text), description && /* @__PURE__ */ React44.createElement(UitkText13, {
        size: 200,
        overflow: isReview ? "truncate-4-lines" : void 0
    }, description.text));
};
LodgingCardPropertyDescriptionSection.fragment = fragment33;
LodgingCardPropertyDescriptionSection.displayName = "LodgingCardPropertyDescriptionSection";
// ../internal/src/components/lodging-card/__private/lodging-product-footer-messages.tsx
import React45 from "react";
import { gql as gql44 } from "@apollo/client";
import { UitkAvatar } from "uitk-react-avatar";
import { UitkLayoutFlex as UitkLayoutFlex9 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark4, UitkMarkSize as UitkMarkSize4 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
import { UitkUnformattedHtml } from "uitk-react-unformatted-html";
var _obj7;
// ../internal/src/components/lodging-card/__private/uitk-text-theme-mapper.tsx
var UitkTextThemeMapper = (_obj7 = {}, _define_property(_obj7, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj7, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj7, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj7, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj7, "DEFAULT" /* DEFAULT */ , "default"), _obj7);
// ../internal/src/components/lodging-card/__private/lodging-product-footer-messages.tsx
var fragment34 = gql44(_templateObject43());
var LodgingProductFooterMessages = function(param) {
    var data = param.data, isReview = param.isReview;
    var _mark, _mark_url, _mark1, _mark2;
    var style = data.style, text = data.text, mark = data.mark, egdsElementId = data.egdsElementId;
    var hasGraphic = mark && mark.id.length > 0;
    var theme = style ? UitkTextThemeMapper[style] : void 0;
    var plainTextElement = function(props) {
        return /* @__PURE__ */ React45.createElement("span", null, props.children || null);
    };
    var message = /* @__PURE__ */ React45.createElement(UitkText14, {
        inline: !!hasGraphic,
        theme: theme
    }, /* @__PURE__ */ React45.createElement(UitkUnformattedHtml, {
        plainTextElement: plainTextElement,
        htmlToParse: text
    }));
    var stayedDate = "stayed_date";
    var reviewAuthor = "review_author";
    if (isReview) {
        switch(egdsElementId){
            case stayedDate:
                return /* @__PURE__ */ React45.createElement(UitkSpacing12, {
                    padding: {
                        blockstart: "one"
                    }
                }, /* @__PURE__ */ React45.createElement(UitkLayoutFlex9, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React45.createElement(UitkText14, {
                    size: 200
                }, text)));
            case reviewAuthor:
                return /* @__PURE__ */ React45.createElement(UitkSpacing12, {
                    padding: {
                        blockstart: "four"
                    }
                }, /* @__PURE__ */ React45.createElement(UitkLayoutFlex9, {
                    wrap: "wrap",
                    direction: "row",
                    alignItems: "center"
                }, /* @__PURE__ */ React45.createElement(UitkAvatar, {
                    size: "small"
                }), /* @__PURE__ */ React45.createElement(UitkSpacing12, {
                    padding: {
                        inlinestart: "one"
                    }
                }, /* @__PURE__ */ React45.createElement(UitkText14, {
                    weight: "bold"
                }, text))));
            default:
                return null;
        }
    }
    return hasGraphic ? /* @__PURE__ */ React45.createElement(UitkSpacing12, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React45.createElement("div", null, /* @__PURE__ */ React45.createElement(UitkSpacing12, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React45.createElement(UitkMark4, {
        name: (_mark = mark) === null || _mark === void 0 ? void 0 : _mark.id,
        url: (_mark1 = mark) === null || _mark1 === void 0 ? void 0 : (_mark_url = _mark1.url) === null || _mark_url === void 0 ? void 0 : _mark_url.value,
        description: (_mark2 = mark) === null || _mark2 === void 0 ? void 0 : _mark2.description,
        size: UitkMarkSize4.SMALL
    })), message)) : message;
};
LodgingProductFooterMessages.fragment = fragment34;
LodgingProductFooterMessages.displayName = "LodgingProductFooterMessages";
// ../internal/src/components/lodging-card/__private/lodging-product-spannable-footer-messages.tsx
import React46 from "react";
import { gql as gql45 } from "@apollo/client";
import { UitkMark as UitkMark5, UitkMarkSize as UitkMarkSize5 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkText as UitkText15 } from "uitk-react-text";
var fragment35 = gql45(_templateObject44(), EGDSSpannableText.fragment);
var LodgingProductSpannableFooterMessages = function(param) {
    var data = param.data;
    var _graphic_url;
    var style = data.style, text = data.text, graphic = data.graphic, stylizedText = data.stylizedText;
    var hasMark = graphic && graphic.id.length > 0 && graphic.__typename === "Mark";
    var theme = style ? UitkTextThemeMapper[style] : void 0;
    var hasSpannableData = stylizedText && stylizedText.__typename === "EGDSSpannableText";
    return hasMark && hasSpannableData ? /* @__PURE__ */ React46.createElement(UitkSpacing13, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React46.createElement("div", null, /* @__PURE__ */ React46.createElement(UitkSpacing13, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React46.createElement(UitkMark5, {
        name: graphic.id,
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        description: graphic.description,
        size: UitkMarkSize5.SMALL
    })), /* @__PURE__ */ React46.createElement(EGDSSpannableText, {
        data: stylizedText
    }))) : /* @__PURE__ */ React46.createElement(UitkText15, {
        theme: theme
    }, text);
};
LodgingProductSpannableFooterMessages.fragment = fragment35;
LodgingProductSpannableFooterMessages.displayName = "LodgingProductFooterMessages";
// ../internal/src/components/lodging-card/__private/lodging-card-product-summary-section.tsx
var fragment36 = gql46(_templateObject45(), LodgingEGDSHeading.fragment, LodgingProductAmenity.fragment, LodgingEGDSText.fragment, LodgingCardPropertyDescriptionSection.fragment, LodgingCardChangeUnitDialogAction.fragment, LodgingCardChangeUnitSheetAction.fragment, LodgingCardPropertyDialogAction.fragment, LodgingCardGuestRating.fragment, LodgingCardBadgedRating.fragment, LodgingProductFooterMessages.fragment, LodgingProductSpannableFooterMessages.fragment);
var LodgingCardProductSummarySection = function(param) {
    var data = param.data, view = param.view, isReview = param.isReview, isOptimizedView = param.isOptimizedView;
    var renderFooterMessage = function renderFooterMessage(footerMessage, footerMessageIndex) {
        switch(footerMessage.__typename){
            case "EGDSTextWithMarkListItem":
                return /* @__PURE__ */ React47.createElement(LodgingProductFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex),
                    isReview: isReview
                });
            case "EarnMessageContainerListItem":
                return /* @__PURE__ */ React47.createElement(LodgingProductSpannableFooterMessages, {
                    data: footerMessage,
                    key: "message-".concat(footerMessageIndex)
                });
            default:
                return null;
        }
    };
    var _footerMessages_listItems;
    var heading = data.heading, messages = data.messages, descriptionSection = data.descriptionSection, amenities = data.amenities, changeActionDialog = data.changeActionDialog, changeActionSheet = data.changeActionSheet, detailsAction = data.detailsAction, guestRating = data.guestRating, guestRatingSection = data.guestRatingSection, footerMessages = data.footerMessages;
    var isResponsiveView = !isCompactView(view);
    var headingLevel = useHeadingLevelContext2(2).headingLevel;
    var GuestRating = React47.useMemo(function() {
        var _guestRatingSection;
        var isBadgedRating = (_guestRatingSection = guestRatingSection) === null || _guestRatingSection === void 0 ? void 0 : _guestRatingSection.__typename.match("LodgingCardBadgedRating");
        if (guestRatingSection) {
            if (isBadgedRating) {
                return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(LodgingCardBadgedRating, {
                    data: guestRatingSection
                }));
            }
            return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(LodgingCardGuestRating, {
                data: guestRatingSection,
                isReview: isReview
            }));
        }
        if (guestRating) {
            return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(LodgingCardGuestRating, {
                data: guestRating,
                isReview: isReview
            }));
        }
    }, [
        guestRating,
        guestRatingSection,
        isReview
    ]);
    return /* @__PURE__ */ React47.createElement(UitkLayoutFlex10, {
        direction: "column",
        space: isOptimizedView ? "half" : "three"
    }, heading && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(LodgingEGDSHeading, {
        size: 7,
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h3",
        data: heading
    })), messages.length > 0 && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement("div", null, messages.map(function(message, messageIndex) {
        return /* @__PURE__ */ React47.createElement(LodgingEGDSText, {
            overflow: "truncate-2-lines",
            key: "message-".concat(messageIndex),
            spacing: "half",
            size: 300,
            data: message
        });
    }))), amenities.length > 0 && /* @__PURE__ */ React47.createElement(UitkLayoutFlex10, {
        wrap: "wrap"
    }, amenities.map(function(amenity, i) {
        return /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, {
            key: "amenity-".concat(i)
        }, /* @__PURE__ */ React47.createElement(LodgingProductAmenity, {
            data: amenity
        }));
    })), isReview && GuestRating, isResponsiveView && descriptionSection && /* @__PURE__ */ React47.createElement(Viewport3, null, /* @__PURE__ */ React47.createElement(ViewLarge2, null, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, {
        minWidth: "16x"
    }, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))))), isReview && descriptionSection && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, {
        minWidth: "16x"
    }, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(LodgingCardPropertyDescriptionSection, {
        data: descriptionSection,
        isReview: isReview
    }))), footerMessages && ((_footerMessages_listItems = footerMessages.listItems) === null || _footerMessages_listItems === void 0 ? void 0 : _footerMessages_listItems.length) > 0 && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement("div", null, footerMessages.listItems.map(function(footerMessage, footerMessageIndex) {
        return /* @__PURE__ */ React47.createElement("div", {
            key: "footer-message-".concat(footerMessageIndex)
        }, renderFooterMessage(footerMessage, footerMessageIndex));
    }))), !isReview && GuestRating, detailsAction && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(LodgingCardPropertyDialogAction, {
        data: detailsAction
    })), changeActionDialog && changeActionSheet && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React47.createElement(UitkSpacing14, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(Viewport3, null, /* @__PURE__ */ React47.createElement(ViewSmall2, null, /* @__PURE__ */ React47.createElement(LodgingCardChangeUnitDialogAction, {
        data: changeActionDialog
    })), /* @__PURE__ */ React47.createElement(ViewMedium3, null, /* @__PURE__ */ React47.createElement(LodgingCardChangeUnitSheetAction, {
        data: changeActionSheet
    })))))));
};
LodgingCardProductSummarySection.fragment = fragment36;
LodgingCardProductSummarySection.displayName = "LodgingCardProductSummarySection";
// ../internal/src/components/lodging-card/__private/lodging-mod-sign-in-button.tsx
import React48, { useEffect } from "react";
import { IntersectionTracker as IntersectionTracker2, ITrackType as ITrackType3, useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { useInView } from "react-intersection-observer";
import { UitkButtonSize, UitkPrimaryAltButton } from "uitk-react-button";
import { UitkIcon as UitkIcon10 } from "uitk-react-icons";
import { UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
var LodgingMODSignInButton = function(param) {
    var action = param.action, analytics = param.analytics, attemptEvents = param.attemptEvents, icon = param.icon, primary = param.primary, successEvents = param.successEvents, adaptexSuccessActionTracking = param.adaptexSuccessActionTracking;
    var _action, _action1, _icon, _componentAnalytics_impressed, _componentAnalytics_impressed1;
    var _useAdaptExEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []), propertyListingAdaptExSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var trackClick = useClickTracker14();
    var _useInView = useInView({
        triggerOnce: true,
        threshold: 0.8
    }), ref = _useInView.ref, inView = _useInView.inView;
    var track = useClickstreamAnalytics2().track;
    var componentAnalytics = {
        click: (_action = action) === null || _action === void 0 ? void 0 : _action.analytics,
        impressed: analytics
    };
    useEffect(function() {
        if (inView && attemptEvents.length) {
            var _attemptEvent;
            var attemptEvent = attemptEvents[0];
            var events = (_attemptEvent = attemptEvent) === null || _attemptEvent === void 0 ? void 0 : _attemptEvent.events[0];
            track(ITrackType3.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, attemptEvent), {
                    events: events ? [
                        events
                    ] : []
                }))
            });
        }
    }, [
        attemptEvents,
        inView,
        track
    ]);
    var handleOnClick = function() {
        var _componentAnalytics_click, _componentAnalytics_click1;
        if (((_componentAnalytics_click = componentAnalytics.click) === null || _componentAnalytics_click === void 0 ? void 0 : _componentAnalytics_click.referrerId) && ((_componentAnalytics_click1 = componentAnalytics.click) === null || _componentAnalytics_click1 === void 0 ? void 0 : _componentAnalytics_click1.linkName)) {
            trackClick(componentAnalytics.click.referrerId, componentAnalytics.click.linkName);
        }
        if (successEvents.length) {
            var _successEvent;
            var successEvent = successEvents[0];
            var events = (_successEvent = successEvent) === null || _successEvent === void 0 ? void 0 : _successEvent.events[0];
            track(ITrackType3.EVENT, {
                data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, successEvent), {
                    events: events ? [
                        events
                    ] : []
                }))
            });
        }
        if (propertyListingAdaptExSuccessEvents.length) {
            propertyListingAdaptExSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType3.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    };
    var content = /* @__PURE__ */ React48.createElement(UitkLayoutFlexItem7, {
        alignSelf: "end"
    }, /* @__PURE__ */ React48.createElement(UitkPrimaryAltButton, {
        domRef: ref,
        onClick: handleOnClick,
        type: "button",
        tag: "a",
        href: (_action1 = action) === null || _action1 === void 0 ? void 0 : _action1.resource.value,
        size: UitkButtonSize.SMALL
    }, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React48.createElement(UitkIcon10, {
        name: icon.id
    }), primary));
    var MODSignInButtonWithImpressionTracking = ((_componentAnalytics_impressed = componentAnalytics.impressed) === null || _componentAnalytics_impressed === void 0 ? void 0 : _componentAnalytics_impressed.referrerId) && ((_componentAnalytics_impressed1 = componentAnalytics.impressed) === null || _componentAnalytics_impressed1 === void 0 ? void 0 : _componentAnalytics_impressed1.linkName) ? /* @__PURE__ */ React48.createElement(IntersectionTracker2, {
        referrerId: componentAnalytics.impressed.referrerId,
        linkName: componentAnalytics.impressed.linkName,
        trackOnce: true
    }, content) : content;
    return MODSignInButtonWithImpressionTracking;
};
LodgingMODSignInButton.displayName = "LodgingMODSignInButton";
// ../internal/src/components/lodging-card/__private/lodging-card-content-section.tsx
var fragment37 = gql47(_templateObject46(), AdaptExAnalyticsEventFragment, LodgingCardHeadingSection.fragment, LodgingCardProductSummarySection.fragment, PriceSummaryFragment, LodgingCardMarketingFeeDetail.fragment, LodgingCardCompareSection.fragment, LodgingCardDateSection.fragment, LodgingBadge.fragment, LodgingStandardBadge.fragment, LodgingEGDSText.fragment, AdaptexTrackingFragment);
var LodgingCardContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 5 : _param_headingSize, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, wrapHeadingText = param.wrapHeadingText, isReview = param.isReview, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView;
    var _priceSection_priceSummary, _priceSection, _dateSection;
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var hasRightColumn = callOut || priceSection || dateSection;
    var isCompact = isCompactView(view);
    var columns;
    if (!isReview) {
        columns = {
            small: [
                "1fr",
                "2fr",
                "2fr"
            ],
            medium: [
                "1fr",
                "2fr",
                "2fr"
            ],
            large: [
                "1fr",
                "max-content",
                "max-content"
            ]
        };
    }
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, headingSection && /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React49.createElement(UitkSpacing15, {
        padding: {
            blockend: isOptimizedView ? void 0 : "three"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(HeadingLevelProvider, {
        topHeadingLevel: 4
    }, /* @__PURE__ */ React49.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        headingSize: headingSize,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        isOptimizedView: isOptimizedView
    }))))), /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React49.createElement(UitkLayoutGrid4, {
        space: "one",
        columns: columns
    }, /* @__PURE__ */ React49.createElement(UitkLayoutGridItem4, {
        colSpan: hasRightColumn ? 2 : 3,
        alignSelf: "end"
    }, /* @__PURE__ */ React49.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React49.createElement(React49.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React49.createElement(UitkSpacingHr, {
            blockMargin: "three"
        }), /* @__PURE__ */ React49.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview,
            isOptimizedView: isOptimizedView
        }));
    }))), hasRightColumn && /* @__PURE__ */ React49.createElement(UitkLayoutGridItem4, {
        colSpan: 1,
        justifySelf: "end",
        alignSelf: "end"
    }, callOut && /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(LodgingEGDSText, {
        data: callOut,
        align: "right"
    })), !isReview && priceSection && /* @__PURE__ */ React49.createElement(UitkLayoutFlex11, {
        direction: "column"
    }, !isCompact && /* @__PURE__ */ React49.createElement(Viewport4, null, /* @__PURE__ */ React49.createElement(ViewMedium4, null, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React49.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id
    }), " "))), /* @__PURE__ */ React49.createElement(PriceSectionPriceSummary, {
        priceSection: priceSection,
        enableInlineLink: enableInlineLink
    }), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React49.createElement(UitkSpacing15, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), ((_priceSection = priceSection) === null || _priceSection === void 0 ? void 0 : _priceSection.button) && /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutPosition3, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React49.createElement(UitkSpacing15, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(LodgingMODSignInButton, _object_spread({}, priceSection.button)))))), ((_dateSection = dateSection) === null || _dateSection === void 0 ? void 0 : _dateSection.date) && /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem8, {
        alignSelf: "end"
    }, /* @__PURE__ */ React49.createElement(UitkSpacing15, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && /* @__PURE__ */ React49.createElement(LodgingCardCompareSection, {
        isAd: isAd2,
        propertyId: id,
        data: compareSection
    }))))));
};
LodgingCardContentSection.fragment = fragment37;
LodgingCardContentSection.displayName = "LodgingCardContentSection";
// ../internal/src/components/lodging-card/__private/lodging-card-link.tsx
import React50 from "react";
import { Link } from "react-router-dom";
import { gql as gql48 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
import { UitkCardLink } from "uitk-react-cards";
var _obj8;
// ../internal/src/components/uitk-link-target-mapper.tsx
var UILinkTargetMap2 = (_obj8 = {}, _define_property(_obj8, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj8, "INTERNAL" /* INTERNAL */ , "_self"), _obj8);
// ../internal/src/components/lodging-card/__private/lodging-card-link.tsx
var fragment38 = gql48(_templateObject47());
var LINK_REL = "noopener";
var LINK_DATA_STID = "open-hotel-information";
var LodgingCardLink = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback;
    var resource = data.resource, useRelativePath = data.useRelativePath, analytics = data.analytics, target = data.target, accessibility = data.accessibility;
    var track = useClickTracker15();
    var _useProvidedState2 = _sliced_to_array(useProvidedState2(), 1), state = _useProvidedState2[0];
    var _state_STATE_FIELD_NAME;
    var comparePropertyIds = ((_state_STATE_FIELD_NAME = state[STATE_FIELD_NAME]) !== null && _state_STATE_FIELD_NAME !== void 0 ? _state_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    var path;
    if (resource.__typename === "HttpURI") {
        path = useRelativePath ? resource.relativePath : resource.value;
        if (comparePropertyIds.length) {
            path = path.concat("&comparePropertyIds=".concat(comparePropertyIds.toString()));
        }
    }
    var onClick = function() {
        if (analytics) {
            sendProductSchemaTracking(_object_spread_props(_object_spread({}, analytics), {
                uisPrimeMessages: analytics.uisPrimeMessages
            }), track);
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var linkProps = {
        rel: LINK_REL,
        "data-stid": LINK_DATA_STID,
        target: target && UILinkTargetMap2[target],
        onClickCapture: onClick
    };
    return /* @__PURE__ */ React50.createElement(UitkCardLink, null, target === "INTERNAL" /* INTERNAL */  && useRelativePath ? /* @__PURE__ */ React50.createElement(Link, _object_spread_props(_object_spread({}, linkProps), {
        to: path || ""
    }), accessibility) : /* @__PURE__ */ React50.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
        href: path
    }), accessibility));
};
LodgingCardLink.fragment = fragment38;
LodgingCardLink.displayName = "LodgingCardLink";
// ../internal/src/components/lodging-card/__private/lodging-card-link-action.tsx
import React51 from "react";
import { gql as gql49 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon11 } from "uitk-react-icons";
import { UitkLink as UitkLink7 } from "uitk-react-link";
var fragment39 = gql49(_templateObject48());
var LodgingCardLinkAction = function(param) {
    var data = param.data;
    var _icon, _icon1;
    var link = data.link;
    var action = link.action, icon = link.icon;
    var analytics = action.analytics, resource = action.resource;
    var track = useClickTracker16();
    if (!link || resource.__typename !== "HttpURI") {
        return null;
    }
    var path = action.useRelativePath ? resource.relativePath : resource.value;
    var analyticsData = analytics ? {
        id: analytics.referrerId,
        description: analytics.linkName,
        callback: function(id, description) {
            return track(id, description, true);
        }
    } : void 0;
    var linkContent = /* @__PURE__ */ React51.createElement(UitkLink7, {
        align: "right",
        analytics: analyticsData
    }, /* @__PURE__ */ React51.createElement("a", {
        href: path,
        target: UILinkTargetMap2[action.target]
    }, link.text, ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.id) && /* @__PURE__ */ React51.createElement(UitkIcon11, {
        name: (_icon1 = icon) === null || _icon1 === void 0 ? void 0 : _icon1.id
    })));
    var isSignInFooterLink = !!analytics.linkName.match(/sign in/gi);
    return isSignInFooterLink ? /* @__PURE__ */ React51.createElement(IntersectionTracker3, {
        referrerId: "Impression".concat(analytics.referrerId),
        linkName: analytics.linkName,
        trackOnce: true
    }, linkContent) : linkContent;
};
LodgingCardLinkAction.fragment = fragment39;
LodgingCardLinkAction.displayName = "LodgingCardLinkAction";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
import React57 from "react";
import { gql as gql55 } from "@apollo/client";
import { ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkFigure as UitkFigure3, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex12 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition5 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
import React54 from "react";
import { useHistory } from "react-router-dom";
import { gql as gql52 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useProvidedState as useProvidedState3 } from "@shared-ui/provided-state-context";
import { UitkButtonTheme } from "uitk-react-button";
import { UitkGalleryCarousel } from "uitk-react-gallery-carousel";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-gallery-carousel/lodging-media-item-to-uitk-media-mapper.tsx
var lodgingMediaItemToUitkMediaMapper = function(mediaItem) {
    switch(mediaItem.media.__typename){
        case "Image":
            return {
                src: mediaItem.media.url,
                alt: mediaItem.media.description
            };
        default:
            return {};
    }
};
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
import React53 from "react";
import { gql as gql51 } from "@apollo/client";
// ../internal/src/components/lodging-egds-image/lodging-egds-image.tsx
import React52 from "react";
import { gql as gql50 } from "@apollo/client";
import { UitkFigure, UitkImage } from "uitk-react-images";
var fragment40 = gql50(_templateObject49());
var LodgingEGDSImage = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio, placeholderImage = param.placeholderImage, lazyLoad = param.lazyLoad;
    var figureProps = {};
    if (ratio) {
        figureProps.ratio = ratio;
    }
    if (imageFit) {
        figureProps.imageFit = imageFit;
    }
    return /* @__PURE__ */ React52.createElement(UitkFigure, _object_spread({}, figureProps), /* @__PURE__ */ React52.createElement(UitkImage, {
        placeholderImage: placeholderImage,
        src: data.url,
        alt: data.description,
        lazyLoading: lazyLoad
    }));
};
LodgingEGDSImage.fragment = fragment40;
LodgingEGDSImage.displayName = "LodgingEGDSImage";
// ../internal/src/components/lodging-media-item/lodging-media-item.tsx
var fragment41 = gql51(_templateObject50(), LodgingEGDSImage.fragment);
var LodgingMediaItem = function(param) {
    var imageFit = param.imageFit, ratio = param.ratio, data = param.data, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg;
    switch(data.media.__typename){
        case "Image":
            return /* @__PURE__ */ React53.createElement(LodgingEGDSImage, {
                imageFit: imageFit,
                ratio: ratio,
                placeholderImage: true,
                data: data.media,
                lazyLoad: lazyLoadImg ? "lazy" : "off"
            });
        default:
            return null;
    }
};
LodgingMediaItem.fragment = fragment41;
LodgingMediaItem.displayName = "LodgingProductMediaItem";
// ../internal/src/components/lodging-gallery-carousel/lodging-gallery-carousel.tsx
var fragment42 = gql52(_templateObject51(), LodgingMediaItem.fragment);
var LodgingGalleryCarousel = function(param) {
    var data = param.data, carouselId = param.carouselId, allyHeadingLevel = param.allyHeadingLevel, cardLink = param.cardLink, propertyId = param.propertyId, _param_imageRatio = param.imageRatio, imageRatio = _param_imageRatio === void 0 ? UitkFigureAspectRatioType2.R21_9 : _param_imageRatio, onClickCallback = param.onClickCallback, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg, propertySortIndex = param.propertySortIndex;
    var media = data.media, accessibilityHeadingText = data.accessibilityHeadingText, navClickAnalytics = data.navClickAnalytics, intersectionAnalytics = data.intersectionAnalytics;
    var track = useClickTracker17();
    var _React54_useState = _sliced_to_array(React54.useState(0), 2), currentMediaIndex = _React54_useState[0], setCurrentMediaIndex = _React54_useState[1];
    var _useProvidedState3 = _sliced_to_array(useProvidedState3(), 1), lodgingCompareState = _useProvidedState3[0];
    var _lodgingCompareState_STATE_FIELD_NAME;
    var comparePropertyIds = ((_lodgingCompareState_STATE_FIELD_NAME = lodgingCompareState[STATE_FIELD_NAME]) !== null && _lodgingCompareState_STATE_FIELD_NAME !== void 0 ? _lodgingCompareState_STATE_FIELD_NAME : defaultState).comparePropertyIds;
    React54.useEffect(function() {
        setCurrentMediaIndex(0);
    }, [
        carouselId
    ]);
    var additionalUisPrimeMicroMessages = function(mdiaIndex) {
        var _media_mdiaIndex, _intersectionAnalytics_uisPrimeMessages_, _intersectionAnalytics_uisPrimeMessages, _intersectionAnalytics, _messageContent, _messageContent1, _media_mdiaIndex1, _media;
        var iId = (_media_mdiaIndex = media[mdiaIndex]) === null || _media_mdiaIndex === void 0 ? void 0 : _media_mdiaIndex.id;
        var imageId = iId && parseInt(iId, 10);
        var productId = propertyId && parseInt(propertyId, 10);
        var messageContent = ((_intersectionAnalytics = intersectionAnalytics) === null || _intersectionAnalytics === void 0 ? void 0 : (_intersectionAnalytics_uisPrimeMessages = _intersectionAnalytics.uisPrimeMessages) === null || _intersectionAnalytics_uisPrimeMessages === void 0 ? void 0 : (_intersectionAnalytics_uisPrimeMessages_ = _intersectionAnalytics_uisPrimeMessages[0]) === null || _intersectionAnalytics_uisPrimeMessages_ === void 0 ? void 0 : _intersectionAnalytics_uisPrimeMessages_.messageContent) ? JSON.parse(intersectionAnalytics.uisPrimeMessages[0].messageContent) : void 0;
        var badges = (_messageContent = messageContent) === null || _messageContent === void 0 ? void 0 : _messageContent.badges;
        var sponsored = !!((_messageContent1 = messageContent) === null || _messageContent1 === void 0 ? void 0 : _messageContent1.sponsored);
        var algoMediaGuid = (_media_mdiaIndex1 = media[mdiaIndex]) === null || _media_mdiaIndex1 === void 0 ? void 0 : _media_mdiaIndex1.trackingId;
        var galleryMaxPosition = (_media = media) === null || _media === void 0 ? void 0 : _media.length;
        var galleryPosition = mdiaIndex;
        var timestamp = Date.now();
        return [
            {
                schemaName: "allHotelProducts",
                messageContent: {
                    numOfProducts: 1,
                    hotelProducts: [
                        {
                            productId: productId,
                            imageId: imageId,
                            imageGalleryAlgorithm: {
                                name: "heroaesthetics.v20190411-hsc.v20190223"
                            },
                            badges: badges,
                            algoMediaGuid: algoMediaGuid,
                            sortPosition: propertySortIndex,
                            sponsored: sponsored
                        }
                    ]
                }
            },
            {
                schemaName: "imageTracking",
                messageContent: {
                    galleryName: "SRP_PROPERTY_CARD_CAROUSEL",
                    galleryType: "GALLERY_TYPE_SINGLE",
                    galleryMaxPosition: galleryMaxPosition,
                    galleryPosition: galleryPosition,
                    repeatedGalleryIndex: null,
                    imageGalleryMetaTags: [
                        {
                            imageGalleryMetaTagType: "DEVICE_TIME_STAMP",
                            imageGalleryMetaTagValue: timestamp
                        }
                    ]
                }
            }
        ];
    };
    var history = useHistory();
    var onImageClick = function() {
        var _cardLink, _media_currentMediaIndex, _currentMedia;
        var comparePropertyIdsStringToAppend = comparePropertyIds.length ? "&comparePropertyIds=".concat(comparePropertyIds.toString()) : "";
        if (((_cardLink = cardLink) === null || _cardLink === void 0 ? void 0 : _cardLink.resource.__typename) === "HttpURI") {
            var _cardLink1;
            if (cardLink.target === "INTERNAL" /* INTERNAL */  && ((_cardLink1 = cardLink) === null || _cardLink1 === void 0 ? void 0 : _cardLink1.useRelativePath)) {
                history.push(cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend));
            } else {
                var path = cardLink.useRelativePath ? cardLink.resource.relativePath.concat(comparePropertyIdsStringToAppend) : cardLink.resource.value.concat(comparePropertyIdsStringToAppend);
                window.open(path, UILinkTargetMap2[cardLink.target]);
            }
            if (cardLink.analytics) {
                sendProductSchemaTracking(cardLink.analytics, track);
            }
        }
        var currentMedia = (_media_currentMediaIndex = media[currentMediaIndex]) === null || _media_currentMediaIndex === void 0 ? void 0 : _media_currentMediaIndex.media;
        if (((_currentMedia = currentMedia) === null || _currentMedia === void 0 ? void 0 : _currentMedia.__typename) === "Image" && currentMedia.thumbnailClickAnalytics) {
            track(currentMedia.thumbnailClickAnalytics.referrerId, currentMedia.thumbnailClickAnalytics.linkName, true, additionalUisPrimeMicroMessages(currentMediaIndex));
        }
        if (onClickCallback) {
            onClickCallback();
        }
    };
    var getCarouselNextIndex = function(currentIndex, mediaLength, carouselActionId) {
        if (carouselActionId.includes("clickRight")) {
            return currentIndex < mediaLength - 1 ? currentIndex + 1 : 0;
        }
        if (carouselActionId.includes("clickLeft")) {
            return currentIndex > 0 ? currentIndex - 1 : mediaLength - 1;
        }
        return currentIndex;
    };
    var navButtonAnalytics = navClickAnalytics ? {
        id: navClickAnalytics.referrerId,
        description: navClickAnalytics.linkName,
        callback: function(id, description) {
            return track(id, description, true, additionalUisPrimeMicroMessages(getCarouselNextIndex(currentMediaIndex, media.length, id)));
        }
    } : void 0;
    var galleryCarouselButtonText = data.nextButtonText && data.previousButtonText ? {
        nextButton: data.nextButtonText,
        prevButton: data.previousButtonText
    } : void 0;
    var galleryCarousel = media.length > 0 && /* @__PURE__ */ React54.createElement(UitkGalleryCarousel, {
        allyHeadingText: accessibilityHeadingText,
        allyHeadingLevel: allyHeadingLevel !== null && allyHeadingLevel !== void 0 ? allyHeadingLevel : void 0,
        carouselId: carouselId,
        carouselName: carouselId,
        currentIndex: currentMediaIndex,
        buttonText: galleryCarouselButtonText,
        images: media.map(function(mediaItem) {
            return lodgingMediaItemToUitkMediaMapper(mediaItem);
        }),
        onImageClick: cardLink ? onImageClick : void 0,
        onIndexChange: setCurrentMediaIndex,
        ratio: imageRatio,
        navTheme: UitkButtonTheme.TRANSPARENT,
        showGalleryButton: false,
        analytics: navButtonAnalytics,
        enablePreload: true,
        placeholderImage: true
    });
    switch(media.length){
        case 0:
            return /* @__PURE__ */ React54.createElement(UitkLayoutPosition4, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React54.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, /* @__PURE__ */ React54.createElement(UitkImage2, {
                placeholderImage: true,
                alt: ""
            })));
        default:
            return /* @__PURE__ */ React54.createElement(UitkLayoutPosition4, {
                position: {
                    zindex: "layer2"
                },
                cloneElement: true
            }, /* @__PURE__ */ React54.createElement(UitkFigure2, {
                imageFit: "cover",
                ratio: imageRatio
            }, intersectionAnalytics ? /* @__PURE__ */ React54.createElement(IntersectionTracker4, {
                tag: "span",
                referrerId: intersectionAnalytics.referrerId,
                linkName: intersectionAnalytics.linkName,
                additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages(currentMediaIndex)
            }, galleryCarousel) : galleryCarousel));
    }
};
LodgingGalleryCarousel.fragment = fragment42;
LodgingGalleryCarousel.displayName = "LodgingGalleryCarousel";
// ../internal/src/components/lodging-trips-save-item/lodging-trips-save-item-adapter.tsx
import React55 from "react";
import { gql as gql53 } from "@apollo/client";
import { ITrackType as ITrackType4, useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
var fragment43 = gql53(_templateObject52(), AdaptexTrackingFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var LodgingTripsSaveItemAdapter = function(param) {
    var data = param.data;
    var save = data.save, remove = data.remove;
    var track = useClickstreamAnalytics3().track;
    var _save_adaptexSuccessCampaignIds;
    var _useAdaptExEvents = useAdaptExEvents((_save_adaptexSuccessCampaignIds = save.adaptexSuccessCampaignIds) !== null && _save_adaptexSuccessCampaignIds !== void 0 ? _save_adaptexSuccessCampaignIds : []), saveAdaptexSuccessEvents = _useAdaptExEvents.adaptExSuccessEvents;
    var _remove_adaptexSuccessCampaignIds;
    var _useAdaptExEvents1 = useAdaptExEvents((_remove_adaptexSuccessCampaignIds = remove.adaptexSuccessCampaignIds) !== null && _remove_adaptexSuccessCampaignIds !== void 0 ? _remove_adaptexSuccessCampaignIds : []), removeAdaptexSuccessEvents = _useAdaptExEvents1.adaptExSuccessEvents;
    var saveItemAdaptexTracking = React55.useCallback(function() {
        if (saveAdaptexSuccessEvents.length) {
            saveAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType4.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        saveAdaptexSuccessEvents,
        track
    ]);
    var removeItemAdaptexTracking = React55.useCallback(function() {
        if (removeAdaptexSuccessEvents.length) {
            removeAdaptexSuccessEvents.forEach(function(adaptExEvent) {
                track(ITrackType4.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(adaptExEvent)
                });
            });
        }
    }, [
        removeAdaptexSuccessEvents,
        track
    ]);
    return data && /* @__PURE__ */ React55.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React55.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer2"
            }
        },
        saveItemCallback: saveItemAdaptexTracking,
        removeItemCallback: removeItemAdaptexTracking
    }));
};
LodgingTripsSaveItemAdapter.fragment = fragment43;
LodgingTripsSaveItemAdapter.displayName = "LodgingTripsSaveItemAdapter";
// ../internal/src/components/lodging-card/__private/lodging-card-save-item.tsx
import React56 from "react";
import { gql as gql54 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { ProductType, ShortlistToggle } from "@shared-ui/trip-planning-travelpulse";
var fragment44 = gql54(_templateObject53());
var LodgingCardSaveItem = function(param) {
    var data = param.data;
    var _labels, _labels1, _items_;
    var trackClick = useClickTracker18();
    var _React56_useState = _sliced_to_array(React56.useState(data.initialChecked), 2), isChecked = _React56_useState[0], setIsChecked = _React56_useState[1];
    var items = data.items, labels = data.labels, messages = data.messages, initialChecked = data.initialChecked, analytics = data.analytics;
    var label = isChecked ? (_labels = labels) === null || _labels === void 0 ? void 0 : _labels.removeLabel : (_labels1 = labels) === null || _labels1 === void 0 ? void 0 : _labels1.saveLabel;
    var _items__itemId;
    var inputs = {
        productId: (_items__itemId = (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.itemId) !== null && _items__itemId !== void 0 ? _items__itemId : "",
        productType: ProductType.PROPERTY_DETAILS
    };
    var handleChange = function(_previousChecked, currentChecked, dispatch) {
        var _analytics, _analytics1, _analytics2, _analytics3, _messages, _messages1;
        setIsChecked(currentChecked);
        var referrerId = currentChecked ? "".concat((_analytics = analytics) === null || _analytics === void 0 ? void 0 : _analytics.linkName, ".Add to favorite lists") : "".concat((_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.linkName, ".Remove from favorite lists");
        var linkName = currentChecked ? "".concat((_analytics2 = analytics) === null || _analytics2 === void 0 ? void 0 : _analytics2.referrerId, ".SaveFavorite") : "".concat((_analytics3 = analytics) === null || _analytics3 === void 0 ? void 0 : _analytics3.referrerId, ".RemoveFavorite");
        trackClick(linkName, referrerId);
        var message = currentChecked ? (_messages = messages) === null || _messages === void 0 ? void 0 : _messages.saveMessage : (_messages1 = messages) === null || _messages1 === void 0 ? void 0 : _messages1.removeMessage;
        if (message) {
            dispatch({
                message: message
            });
        }
    };
    return /* @__PURE__ */ React56.createElement(ShortlistToggle, {
        inputs: inputs,
        initialChecked: initialChecked,
        label: label || void 0,
        onChange: handleChange
    });
};
LodgingCardSaveItem.fragment = fragment44;
LodgingCardSaveItem.displayName = "LodgingCardSaveItem";
// ../internal/src/components/lodging-card/__private/lodging-card-media-section.tsx
var fragment45 = gql55(_templateObject54(), LodgingBadge.fragment, LodgingGalleryCarousel.fragment, LodgingCardSaveItem.fragment, LodgingTripsSaveItemAdapter.fragment);
var LodgingCardMediaSection = function(param) {
    var cardLink = param.cardLink, propertyId = param.propertyId, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, data = param.data, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, index = param.index, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? false : _param_lazyLoadImg, isSRPListingCard = param.isSRPListingCard;
    var _badges, _badges1, _badges2;
    var badges = data.badges, gallery = data.gallery, saveItem = data.saveItem, saveTripItem = data.saveTripItem;
    var carouselFigure = gallery ? /* @__PURE__ */ React57.createElement(LodgingGalleryCarousel, {
        data: gallery,
        carouselId: "lodging-card-gallery-carousel-".concat(propertyId, "-").concat(index),
        allyHeadingLevel: "h3",
        cardLink: cardLink,
        propertyId: propertyId,
        imageRatio: imageRatio,
        onClickCallback: onClickCallback,
        lazyLoadImg: lazyLoadImg,
        propertySortIndex: index
    }) : /* @__PURE__ */ React57.createElement(UitkFigure3, {
        additionalProps: {
            "data-stid": "lodging-card-media-section-placeholder-image"
        }
    }, /* @__PURE__ */ React57.createElement(UitkImage3, {
        placeholderImage: true,
        alt: ""
    }));
    var tertiaryLodgingBadge;
    if ((_badges = badges) === null || _badges === void 0 ? void 0 : _badges.tertiaryBadge) {
        var tertiaryBadgeContent = /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
            type: "absolute",
            position: {
                right: "three",
                bottom: "minus-three",
                zindex: "layer2"
            },
            cloneElement: true
        }, /* @__PURE__ */ React57.createElement(LodgingBadge, {
            data: badges.tertiaryBadge,
            propertyId: propertyId
        }));
        if (!isCompactHorizontalView(view)) {
            tertiaryLodgingBadge = isCompactView(view) ? tertiaryBadgeContent : /* @__PURE__ */ React57.createElement(Viewport5, null, /* @__PURE__ */ React57.createElement(ViewSmall3, null, tertiaryBadgeContent), /* @__PURE__ */ React57.createElement(ViewMedium5, null));
        }
    }
    var shortlistToggle = saveItem && !isCompactHorizontalView(view) && /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            top: "zero",
            right: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React57.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var compactViewShortlistToggle = saveItem && isCompactHorizontalView(view) && /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            top: "zero",
            left: "zero",
            zindex: "layer2"
        }
    }, /* @__PURE__ */ React57.createElement(LodgingCardSaveItem, {
        data: saveItem
    }));
    var saveTripItemHeart = saveTripItem && /* @__PURE__ */ React57.createElement(LodgingTripsSaveItemAdapter, {
        data: saveTripItem
    });
    var primaryLodgingBadge = ((_badges1 = badges) === null || _badges1 === void 0 ? void 0 : _badges1.primaryBadge) && /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            left: "three",
            top: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React57.createElement(LodgingBadge, {
        data: badges.primaryBadge
    }));
    var secondaryLodgingBadge = ((_badges2 = badges) === null || _badges2 === void 0 ? void 0 : _badges2.secondaryBadge) && /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
        type: "absolute",
        position: {
            bottom: "three",
            left: "three",
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React57.createElement(LodgingBadge, {
        isSRPListingCard: isSRPListingCard,
        data: badges.secondaryBadge
    }));
    return /* @__PURE__ */ React57.createElement(UitkLayoutPosition5, {
        type: "relative",
        position: {
            top: "zero",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React57.createElement(UitkLayoutFlex12, {
        blockSize: "full_size"
    }, carouselFigure, shortlistToggle, compactViewShortlistToggle, saveTripItemHeart, primaryLodgingBadge, secondaryLodgingBadge, tertiaryLodgingBadge));
};
LodgingCardMediaSection.fragment = fragment45;
LodgingCardMediaSection.displayName = "LodgingCardMediaSection";
// ../internal/src/components/lodging-card/lodging-card-compact.tsx
import React58 from "react";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection2, UitkCardFeaturedHeader } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex13 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
var LodgingCardCompact = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT" /* COMPACT */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClick = param.onClick, onHoverChanged = param.onHoverChanged, wrapHeadingText = param.wrapHeadingText, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, footerActions = data.footerActions, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React58.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index,
        lazyLoadImg: lazyLoadImg
    });
    return /* @__PURE__ */ React58.createElement(UitkCard5, {
        border: border,
        className: className,
        "data-stid": "lodging-card-compact",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React58.createElement(UitkCardFeaturedHeader, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React58.createElement(UitkLayoutGrid5, {
        columns: 1
    }, /* @__PURE__ */ React58.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React58.createElement("div", null, lodgingCardMediaSection)), /* @__PURE__ */ React58.createElement(UitkLayoutGridItem5, null, /* @__PURE__ */ React58.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React58.createElement(UitkLayoutFlex13, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React58.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: isAd(mediaSection),
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isOptimizedView: isOptimizedView
    }))))), footerActions.length > 0 && /* @__PURE__ */ React58.createElement(UitkCardContentSection2, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React58.createElement(UitkLayoutFlex13, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React58.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React58.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }));
};
LodgingCardCompact.displayName = "LodgingCardCompact";
// ../internal/src/components/lodging-card/lodging-card-compact-horizontal.tsx
import React60 from "react";
import Lazyload from "react-lazy-load";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection3, UitkCardFeaturedHeader as UitkCardFeaturedHeader2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex15 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid7, UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition7 } from "uitk-react-layout-position";
// ../internal/src/components/lodging-card/__private/lodging-card-compact-horizontal-content-section.tsx
import React59 from "react";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition6 } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing16, UitkSpacingHr as UitkSpacingHr2 } from "uitk-react-spacing";
var LodgingCardCompactHorizontalContentSection = function(param) {
    var data = param.data, isAd2 = param.isAd, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, wrapHeadingText = param.wrapHeadingText, isReview = param.isReview, showDismissButton = param.showDismissButton, onCardDismiss = param.onCardDismiss, _param_headingSize = param.headingSize, headingSize = _param_headingSize === void 0 ? 6 : _param_headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView;
    var _priceSection_priceSummary, _priceSection;
    var headingSection = data.headingSection, priceSection = data.priceSection, callOut = data.callOut, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection, id = data.id;
    var hasRightColumn = callOut || priceSection;
    return /* @__PURE__ */ React59.createElement(React59.Fragment, null, headingSection && /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React59.createElement(UitkSpacing16, {
        padding: {
            blockend: isOptimizedView ? void 0 : "three"
        }
    }, /* @__PURE__ */ React59.createElement(LodgingCardHeadingSection, {
        data: headingSection,
        headingSize: headingSize,
        wrapHeadingText: wrapHeadingText,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        isOptimizedView: isOptimizedView
    }))), /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem9, {
        grow: 1
    }, /* @__PURE__ */ React59.createElement(UitkLayoutGrid6, {
        columns: 1,
        space: isOptimizedView ? "one" : "two"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutGridItem6, {
        colSpan: hasRightColumn ? 2 : 3,
        alignSelf: "end"
    }, /* @__PURE__ */ React59.createElement("div", null, summarySections.map(function(summarySection, index) {
        return /* @__PURE__ */ React59.createElement(React59.Fragment, {
            key: "summary-section-".concat(index)
        }, index > 0 && /* @__PURE__ */ React59.createElement(UitkSpacingHr2, {
            blockMargin: "three"
        }), /* @__PURE__ */ React59.createElement(LodgingCardProductSummarySection, {
            data: summarySection,
            view: view,
            isReview: isReview,
            isOptimizedView: isOptimizedView
        }));
    }))), hasRightColumn && /* @__PURE__ */ React59.createElement(UitkLayoutGridItem6, {
        colSpan: 2,
        justifySelf: "end",
        alignSelf: "end"
    }, callOut && /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(LodgingEGDSText, {
        data: callOut,
        align: "right"
    })), priceSection && /* @__PURE__ */ React59.createElement(UitkLayoutFlex14, {
        direction: "column"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem9, {
        alignSelf: "end"
    }, /* @__PURE__ */ React59.createElement(UitkLayoutPosition6, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React59.createElement(LodgingStandardBadge, {
        data: priceSection.standardBadge,
        propertyId: id
    }), " ")), /* @__PURE__ */ React59.createElement(PriceSectionPriceSummary, {
        priceSection: priceSection,
        enableInlineLink: enableInlineLink
    }), ((_priceSection_priceSummary = priceSection.priceSummary) === null || _priceSection_priceSummary === void 0 ? void 0 : _priceSection_priceSummary.marketingFeeDetails) && /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem9, {
        alignSelf: "end"
    }, /* @__PURE__ */ React59.createElement(UitkSpacing16, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(LodgingCardMarketingFeeDetail, {
        data: priceSection.priceSummary.marketingFeeDetails,
        id: id
    })))), ((_priceSection = priceSection) === null || _priceSection === void 0 ? void 0 : _priceSection.button) && /* @__PURE__ */ React59.createElement(UitkLayoutPosition6, {
        position: {
            zindex: "layer2"
        },
        cloneElement: true
    }, /* @__PURE__ */ React59.createElement(UitkSpacing16, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(LodgingMODSignInButton, _object_spread({}, priceSection.button))))), dateSection && /* @__PURE__ */ React59.createElement(UitkLayoutFlexItem9, {
        alignSelf: "end"
    }, /* @__PURE__ */ React59.createElement(UitkSpacing16, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React59.createElement("div", null, /* @__PURE__ */ React59.createElement(LodgingCardDateSection, {
        data: dateSection
    })))), compareSection && /* @__PURE__ */ React59.createElement(LodgingCardCompareSection, {
        propertyId: id,
        data: compareSection,
        isAd: isAd2
    }))))));
};
LodgingCardCompactHorizontalContentSection.displayName = "LodgingCardCompactHorizontalContentSection";
// ../internal/src/components/lodging-card/lodging-card-compact-horizontal.tsx
var LodgingCardCompactHorizontal = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClick = param.onClick, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, showDismissButton = param.showDismissButton, wrapHeadingText = param.wrapHeadingText, index = param.index, isReview = param.isReview, border = param.border, headingSize = param.headingSize, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isOptimizedView = param.isOptimizedView;
    var featuredHeader = data.featuredHeader, summarySections = data.summarySections, compareSection = data.compareSection, footerActions = data.footerActions, mediaSection = data.mediaSection, cardLink = data.cardLink, callOut = data.callOut, priceSection = data.priceSection, headingSection = data.headingSection, dateSection = data.dateSection, id = data.id, __typename = data.__typename;
    var lodgingCardCompactHorizontalContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React60.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React60.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index
    }));
    return /* @__PURE__ */ React60.createElement(UitkCard6, {
        border: border,
        className: className,
        "data-stid": "lodging-card-compact-horizontal",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React60.createElement(UitkCardFeaturedHeader2, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React60.createElement(UitkLayoutGrid7, {
        columns: 3
    }, !lazyLoadImg && lodgingCardMediaSection, lazyLoadImg && /* @__PURE__ */ React60.createElement(Lazyload, {
        offset: 100
    }, lodgingCardMediaSection), /* @__PURE__ */ React60.createElement(UitkLayoutGridItem7, {
        colSpan: 2
    }, /* @__PURE__ */ React60.createElement(UitkLayoutPosition7, {
        type: "relative"
    }, /* @__PURE__ */ React60.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React60.createElement(UitkLayoutFlex15, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React60.createElement(LodgingCardCompactHorizontalContentSection, {
        data: lodgingCardCompactHorizontalContentSectionData,
        isAd: isAd(mediaSection),
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink,
        isOptimizedView: isOptimizedView
    })))))), footerActions.length > 0 && /* @__PURE__ */ React60.createElement(UitkCardContentSection3, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React60.createElement(UitkLayoutFlex15, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React60.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React60.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }));
};
LodgingCardCompactHorizontal.displayName = "LodgingCardCompactHorizontal";
// ../internal/src/components/lodging-card/lodging-card-responsive.tsx
import React61 from "react";
import Lazyload2 from "react-lazy-load";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection4, UitkCardFeaturedHeader as UitkCardFeaturedHeader3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex16 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid8, UitkLayoutGridItem as UitkLayoutGridItem8 } from "uitk-react-layout-grid";
var LodgingCardResponsive = function(props) {
    var className = props.className, data = props.data, imageRatio = props.imageRatio, lazyLoadImg = props.lazyLoadImg, onClick = props.onClick, onHoverChanged = props.onHoverChanged, view = props.view, wrapHeadingText = props.wrapHeadingText, index = props.index, isReview = props.isReview, border = props.border, headingSize = props.headingSize, isSRPListingCard = props.isSRPListingCard, _props_enableInlineLink = props.enableInlineLink, enableInlineLink = _props_enableInlineLink === void 0 ? false : _props_enableInlineLink, isOptimizedView = props.isOptimizedView;
    var __typename = data.__typename, callOut = data.callOut, cardLink = data.cardLink, headingSection = data.headingSection, featuredHeader = data.featuredHeader, footerActions = data.footerActions, id = data.id, mediaSection = data.mediaSection, priceSection = data.priceSection, summarySections = data.summarySections, compareSection = data.compareSection, dateSection = data.dateSection;
    var lodgingCardContentSectionData = {
        __typename: __typename,
        callOut: callOut,
        headingSection: headingSection,
        id: id,
        priceSection: priceSection,
        summarySections: summarySections,
        compareSection: compareSection,
        dateSection: dateSection
    };
    var lodgingCardMediaSection = /* @__PURE__ */ React61.createElement(UitkLayoutGridItem8, null, /* @__PURE__ */ React61.createElement(LodgingCardMediaSection, {
        data: mediaSection,
        cardLink: cardLink,
        propertyId: id,
        view: view,
        imageRatio: imageRatio,
        onClickCallback: onClick,
        index: index,
        isSRPListingCard: isSRPListingCard
    }));
    var _isAd = isAd(mediaSection);
    return /* @__PURE__ */ React61.createElement(Viewport6, null, /* @__PURE__ */ React61.createElement(ViewSmall4, null, /* @__PURE__ */ React61.createElement(LodgingCardCompact, _object_spread_props(_object_spread({}, props), {
        isOptimizedView: isOptimizedView
    }))), /* @__PURE__ */ React61.createElement(ViewMedium6, null, /* @__PURE__ */ React61.createElement(UitkCard7, {
        border: border,
        className: className,
        "data-stid": "lodging-card-responsive",
        onMouseEnter: function() {
            return onHoverChanged(true);
        },
        onMouseLeave: function() {
            return onHoverChanged(false);
        }
    }, featuredHeader && /* @__PURE__ */ React61.createElement(UitkCardFeaturedHeader3, {
        title: {
            tag: "h3",
            text: featuredHeader.header.text
        }
    }), /* @__PURE__ */ React61.createElement(UitkLayoutGrid8, {
        columns: {
            medium: 3
        }
    }, lazyLoadImg ? /* @__PURE__ */ React61.createElement(Lazyload2, {
        offset: 100
    }, lodgingCardMediaSection) : lodgingCardMediaSection, /* @__PURE__ */ React61.createElement(UitkLayoutGridItem8, {
        colSpan: {
            medium: 2
        }
    }, /* @__PURE__ */ React61.createElement(UitkCardContentSection4, null, /* @__PURE__ */ React61.createElement(Viewport6, null, /* @__PURE__ */ React61.createElement(ViewMedium6, null, /* @__PURE__ */ React61.createElement(UitkLayoutFlex16, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 111
        }
    }, /* @__PURE__ */ React61.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))), /* @__PURE__ */ React61.createElement(ViewLarge3, null, /* @__PURE__ */ React61.createElement(UitkLayoutFlex16, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        style: {
            minHeight: 143
        }
    }, /* @__PURE__ */ React61.createElement(LodgingCardContentSection, {
        data: lodgingCardContentSectionData,
        isAd: _isAd,
        view: view,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        headingSize: headingSize,
        enableInlineLink: enableInlineLink
    }))))))), footerActions.length > 0 && /* @__PURE__ */ React61.createElement(UitkCardContentSection4, {
        tag: "footer",
        border: "top"
    }, /* @__PURE__ */ React61.createElement(UitkLayoutFlex16, {
        space: "two",
        direction: "column"
    }, footerActions.map(function(footerAction, i) {
        return /* @__PURE__ */ React61.createElement(LodgingCardLinkAction, {
            data: footerAction,
            key: "footerAction-".concat(i)
        });
    }))), cardLink && /* @__PURE__ */ React61.createElement(LodgingCardLink, {
        data: cardLink,
        onClickCallback: onClick
    }))));
};
LodgingCardResponsive.displayName = "LodgingCardResponsive";
// ../internal/src/components/lodging-card/lodging-card.tsx
var fragment46 = gql56(_templateObject55(), AdaptExAnalyticsEventFragment, LodgingCardLinkAction.fragment, LodgingCardMediaSection.fragment, LodgingCardHeadingSection.fragment, LodgingCardContentSection.fragment, LodgingCardLink.fragment);
var lodgingCardBy = function(view, props, index, isOptimizedView) {
    switch(view){
        case "COMPACT" /* COMPACT */ :
            return {
                lodgingCard: /* @__PURE__ */ React62.createElement(LodgingCardCompact, _object_spread_props(_object_spread({}, props), {
                    index: index,
                    isOptimizedView: isOptimizedView
                })),
                trackerClassName: "uitk-card-roundcorner-all uitk-card-has-primary-theme"
            };
        case "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ :
            return {
                lodgingCard: /* @__PURE__ */ React62.createElement(LodgingCardCompactHorizontal, _object_spread_props(_object_spread({}, props), {
                    index: index,
                    isOptimizedView: isOptimizedView
                }))
            };
        default:
            return {
                lodgingCard: /* @__PURE__ */ React62.createElement(LodgingCardResponsive, _object_spread_props(_object_spread({}, props), {
                    index: index,
                    isOptimizedView: isOptimizedView
                }))
            };
    }
};
var LodgingCard = function(param) {
    var data = param.data, className = param.className, _param_view = param.view, view = _param_view === void 0 ? "RESPONSIVE" /* RESPONSIVE */  : _param_view, _param_lazyLoadImg = param.lazyLoadImg, lazyLoadImg = _param_lazyLoadImg === void 0 ? true : _param_lazyLoadImg, imageRatio = param.imageRatio, onClickCallback = param.onClickCallback, onHoverChanged = param.onHoverChanged, onCardDismiss = param.onCardDismiss, showDismissButton = param.showDismissButton, _param_wrapHeadingText = param.wrapHeadingText, wrapHeadingText = _param_wrapHeadingText === void 0 ? true : _param_wrapHeadingText, index = param.index, _param_fireCardImpression = param.fireCardImpression, fireCardImpression = _param_fireCardImpression === void 0 ? true : _param_fireCardImpression, isReview = param.isReview, _param_border = param.border, border = _param_border === void 0 ? false : _param_border, headingSize = param.headingSize, _param_isSRPListingCard = param.isSRPListingCard, isSRPListingCard = _param_isSRPListingCard === void 0 ? false : _param_isSRPListingCard, _param_fireImpressionByViewability = param.fireImpressionByViewability, fireImpressionByViewability = _param_fireImpressionByViewability === void 0 ? false : _param_fireImpressionByViewability, _param_enableInlineLink = param.enableInlineLink, enableInlineLink = _param_enableInlineLink === void 0 ? false : _param_enableInlineLink, isFirstModIndex = param.isFirstModIndex;
    var _context_device, _context;
    var context = useBexApi2().context;
    var track = useEgClickstream();
    var _useClickstreamAnalytics4 = useClickstreamAnalytics4(), adaptexTrack = _useClickstreamAnalytics4.track;
    var clickstreamEvents = data.clickstreamEvents, id = data.id, impressionAnalytics = data.impressionAnalytics, adaptexSuccessActionTracking = data.adaptexSuccessActionTracking;
    var adaptExSuccessEvents = useAdaptExEvents(adaptexSuccessActionTracking !== null && adaptexSuccessActionTracking !== void 0 ? adaptexSuccessActionTracking : []).adaptExSuccessEvents;
    var onClick = consolidateOnclick(track, clickstreamEvents.productSelected, adaptexTrack, adaptExSuccessEvents, onClickCallback);
    var _ref = impressionAnalytics !== null && impressionAnalytics !== void 0 ? impressionAnalytics : {}, url = _ref.url, referrerId = _ref.referrerId, linkName = _ref.linkName, uisPrimeMessages = _ref.uisPrimeMessages;
    var additionalUisPrimeMicroMessages = parseLodgingCardImpressionSchema(uisPrimeMessages);
    var shouldUseViewability = url && fireImpressionByViewability;
    var componentRef = useMesoViewabilityWrapper({
        viewabilityBeacon: url
    }).componentRef;
    var _useExperiment = useExperiment("Optimizing_compact_cards_by_removing_extra_space"), optimizeCompactCardExposure = _useExperiment.exposure, logExperiment = _useExperiment.logExperiment;
    var isMobileDevice = ((_context = context) === null || _context === void 0 ? void 0 : (_context_device = _context.device) === null || _context_device === void 0 ? void 0 : _context_device.type) === "MOBILE_PHONE";
    var isOptimizedView = isMobileDevice && optimizeCompactCardExposure.bucket === 1;
    var MOD_AND_DRR_TRACKING = {
        referrerId: "ModAvailableStackedWithDRR.propertyRankonSRPnumber_",
        linkName: "first MOD & DRR stacked property impression"
    };
    var onHoverChangedWithId = React62.useCallback(function(hovered) {
        var _onHoverChanged;
        (_onHoverChanged = onHoverChanged) === null || _onHoverChanged === void 0 ? void 0 : _onHoverChanged(id, hovered);
    }, [
        onHoverChanged
    ]);
    useEffect2(function() {
        if (url && fireCardImpression && !fireImpressionByViewability) {
            fetch(url).then(function(response) {
                return response;
            });
        }
    }, [
        impressionAnalytics
    ]);
    useEffect2(function() {
        if (isMobileDevice) {
            logExperiment(optimizeCompactCardExposure);
        }
    }, [
        isMobileDevice,
        logExperiment,
        optimizeCompactCardExposure
    ]);
    var props = {
        className: className,
        data: data,
        lazyLoadImg: lazyLoadImg,
        imageRatio: imageRatio,
        onClick: onClick,
        onCardDismiss: onCardDismiss,
        onHoverChanged: onHoverChangedWithId,
        showDismissButton: showDismissButton,
        wrapHeadingText: wrapHeadingText,
        isReview: isReview,
        border: border,
        headingSize: headingSize,
        isSRPListingCard: isSRPListingCard,
        enableInlineLink: enableInlineLink
    };
    var lodgingCardWrapper = lodgingCardBy(view, props, index, isOptimizedView);
    var lodgingCardComponent = function() {
        return referrerId && linkName ? /* @__PURE__ */ React62.createElement(IntersectionTracker5, {
            className: lodgingCardWrapper.trackerClassName,
            referrerId: referrerId,
            linkName: linkName,
            additionalUisPrimeMicroMessages: additionalUisPrimeMicroMessages
        }, lodgingCardWrapper.lodgingCard) : lodgingCardWrapper.lodgingCard;
    };
    var lodgingCardComponentWithModDRRTracking = function() {
        return isFirstModIndex ? /* @__PURE__ */ React62.createElement(IntersectionTracker5, {
            referrerId: MOD_AND_DRR_TRACKING.referrerId + index,
            linkName: MOD_AND_DRR_TRACKING.linkName,
            trackOnce: true
        }, lodgingCardComponent()) : lodgingCardComponent();
    };
    return shouldUseViewability ? /* @__PURE__ */ React62.createElement("div", {
        ref: componentRef
    }, lodgingCardComponentWithModDRRTracking()) : lodgingCardComponentWithModDRRTracking();
};
LodgingCard.fragment = fragment46;
LodgingCard.displayName = "LodgingCard";
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
import React63 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton as UitkSecondaryButton2, UitkTertiaryButton } from "uitk-react-button";
// ../internal/src/components/lodging-ui-link-action/lodging-ui-link-action.ts
import { gql as gql57 } from "@apollo/client";
var fragment47 = gql57(_templateObject56());
var getLodgingUILinkActionPath = function(action) {
    if (action.resource.__typename !== "HttpURI") {
        return null;
    }
    return action.useRelativePath ? action.resource.relativePath : action.resource.value;
};
var getLodgingUILinkActionTarget = function(action) {
    return UILinkTargetMap2[action.target];
};
// ../internal/src/components/lodging-egds-button/lodging-egds-button.tsx
var fragment48 = gql58(_templateObject57(), clientSideAnalyticsFragment, fragment47, LodgingEGDSIcon.fragment);
var deriveLinkProps = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var buttonComponents = {
    UIPrimaryButton: UitkPrimaryButton,
    UISecondaryButton: UitkSecondaryButton2,
    UITertiaryButton: UitkTertiaryButton
};
var LodgingEGDSButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, __typename = _param_data.__typename, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, dataStid = _param.dataStid, props = _object_without_properties(_param, [
        "onClick",
        "data",
        "dataStid"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps(action);
    var handleClick = React63.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    var Button = buttonComponents[__typename];
    if (Button) {
        return /* @__PURE__ */ React63.createElement(Button, _object_spread_props(_object_spread({}, buttonProps), {
            "data-stid": dataStid
        }), icon ? /* @__PURE__ */ React63.createElement(LodgingEGDSIcon, {
            data: icon
        }) : null, primary);
    }
    return null;
};
LodgingEGDSButton.fragment = fragment48;
LodgingEGDSButton.displayName = "EGDSButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-action-button.tsx
import React64 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkFloatingActionButton } from "uitk-react-button";
var fragment49 = gql59(_templateObject58());
var deriveLinkProps2 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingActionButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps2(action);
    var handleClick = React64.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return icon ? /* @__PURE__ */ React64.createElement(UitkFloatingActionButton, _object_spread({}, buttonProps), /* @__PURE__ */ React64.createElement(LodgingEGDSIcon, {
        data: icon
    })) : null;
};
LodgingEGDSFloatingActionButton.fragment = fragment49;
LodgingEGDSFloatingActionButton.displayName = "EGDSFloatingActionButton";
// ../internal/src/components/lodging-egds-button/lodging-egds-floating-button.tsx
import React65 from "react";
import { gql as gql60 } from "@apollo/client";
import { UitkFloatingButton } from "uitk-react-button";
var fragment50 = gql60(_templateObject59());
var deriveLinkProps3 = function(action) {
    var _action;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "UILinkAction") {
        return {};
    }
    var path = getLodgingUILinkActionPath(action);
    if (!path) {
        return {};
    }
    return {
        href: path,
        target: getLodgingUILinkActionTarget(action),
        tag: "a"
    };
};
var LodgingEGDSFloatingButton = function(_param) {
    var onClick = _param.onClick, _param_data = _param.data, accessibility = _param_data.accessibility, analytics = _param_data.analytics, disabled = _param_data.disabled, primary = _param_data.primary, action = _param_data.action, icon = _param_data.icon, props = _object_without_properties(_param, [
        "onClick",
        "data"
    ]);
    var trackClick = useTrackClientSideAnalytics(analytics);
    var linkProps = deriveLinkProps3(action);
    var handleClick = React65.useCallback(function(event) {
        var _onClick;
        trackClick();
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick(event);
    }, [
        onClick,
        trackClick
    ]);
    var buttonProps = _object_spread({
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        disabled: disabled,
        onClick: handleClick
    }, linkProps, props);
    return /* @__PURE__ */ React65.createElement(UitkFloatingButton, _object_spread({}, buttonProps), icon ? /* @__PURE__ */ React65.createElement(LodgingEGDSIcon, {
        data: icon
    }) : null, primary);
};
LodgingEGDSFloatingButton.fragment = fragment50;
LodgingEGDSFloatingButton.displayName = "EGDSFloatingButton";
// ../internal/src/components/lodging-egds-checkbox/lodging-egds-checkbox.tsx
import React67 from "react";
import { gql as gql62 } from "@apollo/client";
// ../internal/src/components/lodging-egds-checkbox/lodging-egds-basic-checkbox.tsx
import React66 from "react";
import { gql as gql61 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox as UitkCheckbox2 } from "uitk-react-checkbox";
var __Fragment = gql61(_templateObject60());
var LodgingEGDSBasicCheckBox = function(_param) {
    var data = _param.data, checked = _param.checked, onChange = _param.onChange, props = _object_without_properties(_param, [
        "data",
        "checked",
        "onChange"
    ]);
    var _label;
    var egdsElementId = data.egdsElementId, description = data.description, enabled = data.enabled, name = data.name, required = data.required, label = data.label, checkedAnalytics = data.checkedAnalytics, uncheckedAnalytics = data.uncheckedAnalytics, state = data.state;
    var _React66_useState = _sliced_to_array(React66.useState(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ ), 2), isChecked = _React66_useState[0], setIsChecked = _React66_useState[1];
    React66.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ );
    }, [
        checked,
        state
    ]);
    var track = useClickTracker19();
    var handleChange = React66.useCallback(function(event) {
        var _onChange;
        setIsChecked(event.currentTarget.checked);
        if (checkedAnalytics && !isChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && isChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        (_onChange = onChange) === null || _onChange === void 0 ? void 0 : _onChange(event);
    }, [
        checkedAnalytics,
        isChecked,
        onChange,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React66.createElement(UitkCheckbox2, _object_spread({
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
        checked: isChecked,
        description: description !== null && description !== void 0 ? description : void 0,
        disabled: !enabled,
        name: name !== null && name !== void 0 ? name : void 0,
        onChange: handleChange,
        required: required
    }, props), (_label = label) === null || _label === void 0 ? void 0 : _label.text);
};
LodgingEGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
LodgingEGDSBasicCheckBox.fragment = __Fragment;
// ../internal/src/components/lodging-egds-checkbox/lodging-egds-checkbox.tsx
var __Fragment2 = gql62(_templateObject61(), LodgingEGDSBasicCheckBox.fragment);
var LodgingEGDSCheckbox = function(param) {
    var data = param.data, onChange = param.onChange, checked = param.checked;
    switch(data.__typename){
        case "EGDSBasicCheckBox":
            return /* @__PURE__ */ React67.createElement(LodgingEGDSBasicCheckBox, {
                onChange: onChange,
                checked: checked,
                data: data
            });
        default:
            return null;
    }
};
LodgingEGDSCheckbox.displayName = "EGDSCheckBox";
LodgingEGDSCheckbox.fragment = __Fragment2;
// ../internal/src/components/map/dynamic-map.tsx
import React68 from "react";
import { gql as gql63 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { UitkLayoutPosition as UitkLayoutPosition8 } from "uitk-react-layout-position";
import { UitkPageLoader } from "uitk-react-loader";
import { UitkEGMaps, UitkEGMapsType } from "uitk-react-map";
// ../internal/src/components/map/geometry-utils.ts
var roundCoordinate = function(num) {
    var ONE_MILLION = 1e6;
    return Math.round((num + Number.EPSILON) * ONE_MILLION) / ONE_MILLION;
};
var boundingBoxToString = function(southwest, northeast) {
    var roundedSouthwest = southwest.map(roundCoordinate);
    var roundedNortheast = northeast.map(roundCoordinate);
    return "".concat(roundedSouthwest, ", ").concat(roundedNortheast);
};
var egBoundsToString = function(bounds) {
    var _bounds_sw_, _bounds_sw_1, _bounds_ne_, _bounds_ne_1;
    var boundingBox = [
        [
            (_bounds_sw_ = bounds.sw[0]) !== null && _bounds_sw_ !== void 0 ? _bounds_sw_ : 0,
            (_bounds_sw_1 = bounds.sw[1]) !== null && _bounds_sw_1 !== void 0 ? _bounds_sw_1 : 0
        ],
        [
            (_bounds_ne_ = bounds.ne[0]) !== null && _bounds_ne_ !== void 0 ? _bounds_ne_ : 0,
            (_bounds_ne_1 = bounds.ne[1]) !== null && _bounds_ne_1 !== void 0 ? _bounds_ne_1 : 0
        ]
    ];
    var emptyNumberList = [];
    var _boundingBox_, _boundingBox_1;
    return boundingBoxToString((_boundingBox_ = boundingBox[0]) !== null && _boundingBox_ !== void 0 ? _boundingBox_ : emptyNumberList, (_boundingBox_1 = boundingBox[1]) !== null && _boundingBox_1 !== void 0 ? _boundingBox_1 : emptyNumberList);
};
// ../internal/src/components/map/analytics/eg-clickstream-events.tsx
import { useClickTracker as useClickTracker20, useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var INTERACTION = "Interaction";
var IMPRESSION = "Impression";
var EVENT_CATEGORY = "maps";
var buildEvent = function(eventName, eventType, eventVersion) {
    return {
        event_name: eventName,
        event_type: eventType,
        event_version: eventVersion,
        event_category: EVENT_CATEGORY
    };
};
var buildData = function(event, attributes) {
    return _object_spread_props(_object_spread({}, attributes), {
        event: event
    });
};
function useEgMapClickstream() {
    var clickstreamTrack = useEgClickstream2();
    var track = function(data) {
        if (clickstreamTrack) {
            clickstreamTrack(data);
        }
    };
    var trackMapInit = function(mapType, selectionId) {
        var event = buildEvent("map.initiated", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        var attributes = {
            map_obj: {
                map_provider: mapType,
                map_selection_type: "property",
                map_selection_id: selectionId
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPresented = function(boundingBox, mapId, viewMode) {
        var event = buildEvent("map.presented", IMPRESSION, "2.4.0" /* TWO_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                map_identifier: mapId,
                visible_bounding_box: boundingBox,
                view_mode: viewMode
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapViewportMoved = function(boundingBox, movementType, zoomLevel) {
        var event = buildEvent("map_viewport.viewed", INTERACTION, "3.2.0" /* THREE_TWO_ZERO */ );
        var attributes = {
            map_obj: {
                visible_bounding_box: boundingBox,
                movement_type: movementType,
                zoom_level: zoomLevel
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapContentPresented = function(options) {
        var event = buildEvent("map_content.presented", IMPRESSION, "3.4.0" /* THREE_FOUR_ZERO */ );
        var attributes = {
            map_obj: {
                tile_sets: options.tileSets,
                content_origin: options.origin
            },
            destination: {
                places_of_interest_count: options.placesOfInterestCount,
                restaurant_count: options.restaurantCount,
                grocery_count: options.groceryCount,
                transportation_count: options.transportationCount
            },
            map_product_detail: {
                product_cluster_count: options.productClusterCount,
                property_count: options.propertyCount
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlaceSelected = function(selectionId, geometryType, qualifiers, selectionType) {
        var event = buildEvent("map_place.selected", INTERACTION, "3.10.1" /* THREE_TEN_ONE */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType,
                geometry_type_name: geometryType,
                qualifiers: qualifiers
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPropertySelected = function(selectionId, selectionType) {
        var event = buildEvent("map_product.selected", INTERACTION, "1.0.1" /* ONE_ZERO_ONE */ );
        var attributes = {
            map_obj: {
                map_selection_id: selectionId,
                map_selection_type: selectionType
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceAdded = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.added", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapCustomPlaceRemoved = function(searchType, searchDetail, featureId) {
        var event = buildEvent("map_place.removed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        var attributes = {
            map_obj: {
                map_feature_id: featureId,
                map_search_type: searchType,
                map_search_detail: searchDetail
            }
        };
        track(buildData(event, attributes));
    };
    var trackMapPlacesDialogOpened = function() {
        var event = buildEvent("map_dialog.opened", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapPlacesDialogClosed = function() {
        var event = buildEvent("map_dialog.closed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */ );
        track(buildData(event, {}));
    };
    var trackMapHidden = function() {
        var event = buildEvent("map.hidden", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */ );
        track(buildData(event, {}));
    };
    var clickTracker = useClickTracker20();
    var trackMapFilterChanged = function(id, desc) {
        clickTracker(id, desc);
    };
    return {
        trackMapInit: trackMapInit,
        trackMapPresented: trackMapPresented,
        trackMapViewportMoved: trackMapViewportMoved,
        trackMapContentPresented: trackMapContentPresented,
        trackMapPlaceSelected: trackMapPlaceSelected,
        trackMapPropertySelected: trackMapPropertySelected,
        trackMapHidden: trackMapHidden,
        trackMapFilterChanged: trackMapFilterChanged,
        trackMapCustomPlaceAdded: trackMapCustomPlaceAdded,
        trackMapCustomPlaceRemoved: trackMapCustomPlaceRemoved,
        trackMapPlacesDialogOpened: trackMapPlacesDialogOpened,
        trackMapPlacesDialogClosed: trackMapPlacesDialogClosed
    };
}
// ../internal/src/components/map/analytics/event-helper.ts
import { UitkEGMapsQualifier } from "uitk-react-map";
var getVisibleFeatureCount = function(mapObj, featureFilter) {
    var combinedFilter = function(feature) {
        return featureFilter(feature) && feature.visible;
    };
    return mapObj.listFeatures(combinedFilter, mapObj.getBounds()).length;
};
var filterTransport = function(feature) {
    var _feature_qualifiers, _feature_qualifiers1, _feature_qualifiers2, _feature_qualifiers3, _feature_qualifiers4;
    return ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.AIRPORT)) || ((_feature_qualifiers1 = feature.qualifiers) === null || _feature_qualifiers1 === void 0 ? void 0 : _feature_qualifiers1.includes(UitkEGMapsQualifier.TRANSPORTATION)) || ((_feature_qualifiers2 = feature.qualifiers) === null || _feature_qualifiers2 === void 0 ? void 0 : _feature_qualifiers2.includes(UitkEGMapsQualifier.BUS_STATION)) || ((_feature_qualifiers3 = feature.qualifiers) === null || _feature_qualifiers3 === void 0 ? void 0 : _feature_qualifiers3.includes(UitkEGMapsQualifier.TRANSIT)) || ((_feature_qualifiers4 = feature.qualifiers) === null || _feature_qualifiers4 === void 0 ? void 0 : _feature_qualifiers4.includes(UitkEGMapsQualifier.METRO_STATION));
};
var getContentPresentedOptions = function(mapObj, origin) {
    var _mapObj;
    var enabledTilesets = (_mapObj = mapObj) === null || _mapObj === void 0 ? void 0 : _mapObj.getActiveTilesets();
    var clusterCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "cluster";
    });
    var propertyCount = getVisibleFeatureCount(mapObj, function(feature) {
        return feature.type === "property";
    });
    var transportationCount = getVisibleFeatureCount(mapObj, filterTransport);
    var poiCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.POINT_OF_INTEREST);
    });
    var groceryCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.GROCERY);
    });
    var restaurantCount = getVisibleFeatureCount(mapObj, function(feature) {
        var _feature_qualifiers;
        return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(UitkEGMapsQualifier.RESTAURANT);
    });
    return {
        transportationCount: transportationCount,
        groceryCount: groceryCount,
        restaurantCount: restaurantCount,
        placesOfInterestCount: poiCount,
        tileSets: enabledTilesets,
        productClusterCount: clusterCount,
        propertyCount: propertyCount,
        origin: origin
    };
};
var CONTENT_PRESENTED_DELAY = 200;
// ../internal/src/components/map/map-markers.tsx
var convertMarkers = function(mapMarkers) {
    return (mapMarkers !== null && mapMarkers !== void 0 ? mapMarkers : []).map(function(marker, index) {
        var type = (marker.type || "place").toString().toLowerCase();
        var status = (marker.markerStatus || "unknown").toString().toLowerCase();
        var ariaLabels;
        if (marker.onSelectAccessibilityMessage || marker.onEnterAccessibilityMessage) {
            ariaLabels = {
                default: marker.onEnterAccessibilityMessage || "",
                onSelect: marker.onSelectAccessibilityMessage || ""
            };
        }
        var _marker_text;
        return {
            id: marker.id || "index-".concat(index),
            name: (_marker_text = marker.text) !== null && _marker_text !== void 0 ? _marker_text : void 0,
            lat: marker.markerPosition.latitude,
            lng: marker.markerPosition.longitude,
            type: type,
            status: status,
            qualifiers: _to_consumable_array(marker.qualifiers),
            text: type === "place" ? marker.text || void 0 : void 0,
            price: type === "property" ? marker.text : void 0,
            ariaLabels: ariaLabels
        };
    });
};
// ../internal/src/components/map/dynamic-map.tsx
var trackMapViewportBoundChangedId = "trackMapViewportBoundChangedCb";
var trackMarkerSelectionId = "trackMarkerSelectionId";
var trackMapContentPresentedId = "trackMapContentPresentedId";
var __Fragment3 = gql63(_templateObject62());
var DynamicMap = function(param) {
    var children = param.children, className = param.className, data = param.data, beforeInit = param.beforeInit, onInit = param.onInit, supplementalFeatures = param.supplementalFeatures, onFeaturesPushed = param.onFeaturesPushed, egMapsConfig = param.egMapsConfig, selectedFeatureId = param.selectedFeatureId, viewMode = param.viewMode, _param_egDistancesEnabled = param.egDistancesEnabled, egDistancesEnabled = _param_egDistancesEnabled === void 0 ? false : _param_egDistancesEnabled, clientPadding = param.clientPadding, _param_height = param.height, height = _param_height === void 0 ? "100vh" : _param_height, _param_updateViewport = param.updateViewport, updateViewport = _param_updateViewport === void 0 ? true : _param_updateViewport;
    var _dynamicMapConfig, _dynamicMapConfig1;
    var _ref = data || {}, initialViewport = _ref.initialViewport, center = _ref.center, zoom = _ref.zoom, bounds = _ref.bounds, computedBoundsOptions = _ref.computedBoundsOptions, config = _ref.config, markers = _ref.markers;
    var mapRef = React68.useRef();
    var initDone = React68.useRef(false);
    var backupMapFragment = React68.useRef();
    var _useEgMapClickstream = useEgMapClickstream(), trackMapInit = _useEgMapClickstream.trackMapInit, trackMapPresented = _useEgMapClickstream.trackMapPresented, trackMapViewportMoved = _useEgMapClickstream.trackMapViewportMoved, trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented, trackMapPlaceSelected = _useEgMapClickstream.trackMapPlaceSelected, trackMapPropertySelected = _useEgMapClickstream.trackMapPropertySelected, trackMapHidden = _useEgMapClickstream.trackMapHidden;
    var _useBexApi3 = useBexApi3(), _useBexApi3_context = _useBexApi3.context, locale = _useBexApi3_context.locale, currency = _useBexApi3_context.currency;
    React68.useEffect(function() {
        if (data) {
            backupMapFragment.current = data;
        }
    }, [
        data
    ]);
    var dynamicMapConfig = React68.useMemo(function() {
        var _backupMapFragment_current;
        return config || ((_backupMapFragment_current = backupMapFragment.current) === null || _backupMapFragment_current === void 0 ? void 0 : _backupMapFragment_current.config);
    }, [
        config
    ]);
    React68.useEffect(function() {
        return trackMapHidden;
    }, []);
    React68.useEffect(function() {
        var _dynamicMapConfig;
        if ((_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider) {
            var _dynamicMapConfig1;
            var provider = ((_dynamicMapConfig1 = dynamicMapConfig) === null || _dynamicMapConfig1 === void 0 ? void 0 : _dynamicMapConfig1.egdsMapProvider) === "MAPBOX" /* MAPBOX */  ? "mapbox" : "google-maps";
            trackMapInit(provider, selectedFeatureId);
        }
    }, [
        (_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider
    ]);
    var cfg = React68.useMemo(function() {
        if (dynamicMapConfig) {
            var _dynamicMapConfig_externalConfigEndpoint;
            var ret = egMapsConfig ? _object_spread({}, egMapsConfig) : {};
            if (className) {
                ret.additionalCssClass = className;
            }
            if (locale) {
                ret.locale = locale;
            }
            if (currency) {
                ret.iso4217CurrencyCode = currency;
            }
            if ((_dynamicMapConfig_externalConfigEndpoint = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint.value) {
                var _dynamicMapConfig_externalConfigEndpoint1;
                ret.externalConfigEndpoint = (_dynamicMapConfig_externalConfigEndpoint1 = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint1 === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint1.value;
            }
            if (dynamicMapConfig.mapId) {
                switch(dynamicMapConfig.egdsMapProvider){
                    case "MAPBOX" /* MAPBOX */ :
                        if (!ret.mapbox) {
                            ret.mapbox = {};
                        }
                        if (!ret.mapbox.mapboxAddConf) {
                            ret.mapbox.mapboxAddConf = {};
                        }
                        ret.mapbox.mapboxAddConf.style = dynamicMapConfig.mapId;
                        break;
                    case "GOOGLE" /* GOOGLE */ :
                    default:
                        if (!ret.googleMaps) {
                            ret.googleMaps = {};
                        }
                        if (!ret.googleMaps.gmapsAddConfig) {
                            ret.googleMaps.gmapsAddConfig = {};
                        }
                        ret.googleMaps.gmapsAddConfig.mapId = dynamicMapConfig.mapId;
                        break;
                }
            }
            return ret;
        }
    }, [
        dynamicMapConfig,
        locale,
        currency,
        egMapsConfig
    ]);
    var accessToken = (_dynamicMapConfig1 = dynamicMapConfig) === null || _dynamicMapConfig1 === void 0 ? void 0 : _dynamicMapConfig1.accessToken;
    var identifyMapType = function() {
        var _dynamicMapConfig;
        switch((_dynamicMapConfig = dynamicMapConfig) === null || _dynamicMapConfig === void 0 ? void 0 : _dynamicMapConfig.egdsMapProvider){
            case "MAPBOX" /* MAPBOX */ :
                return UitkEGMapsType.MAPBOX;
            case "GOOGLE" /* GOOGLE */ :
            default:
                return UitkEGMapsType.GOOGLE;
        }
    };
    var mapType = identifyMapType();
    var features = React68.useMemo(function() {
        var _markers;
        return _to_consumable_array(convertMarkers((_markers = markers) === null || _markers === void 0 ? void 0 : _markers.map(function(m) {
            return m;
        }))).concat(_to_consumable_array(supplementalFeatures || []));
    }, [
        markers,
        supplementalFeatures
    ]);
    var featureCoordinates = React68.useMemo(function() {
        var _features;
        return (_features = features) === null || _features === void 0 ? void 0 : _features.map(function(f) {
            return [
                f.lat,
                f.lng
            ];
        });
    }, [
        features
    ]);
    var computeBoundsViewport = function(b) {
        var _b, _b1, _b2, _b3;
        return {
            sw: [
                (_b = b) === null || _b === void 0 ? void 0 : _b.southwest.latitude,
                (_b1 = b) === null || _b1 === void 0 ? void 0 : _b1.southwest.longitude
            ],
            ne: [
                (_b2 = b) === null || _b2 === void 0 ? void 0 : _b2.northeast.latitude,
                (_b3 = b) === null || _b3 === void 0 ? void 0 : _b3.northeast.longitude
            ]
        };
    };
    var computeCenterAndZoomViewport = function(c, z) {
        var _c, _c1;
        return {
            center: [
                (_c = c) === null || _c === void 0 ? void 0 : _c.latitude,
                (_c1 = c) === null || _c1 === void 0 ? void 0 : _c1.longitude
            ],
            zoom: z
        };
    };
    var computeBoundsComputedViewport = function(coordinates, options) {
        var _options, _options1, _options2, _options3, _options4, _options5, _options6, _options7, _options8;
        return {
            useBoundsComputation: true,
            options: {
                gaiaId: ((_options = options) === null || _options === void 0 ? void 0 : _options.gaiaId) && !Number.isNaN(Number((_options1 = options) === null || _options1 === void 0 ? void 0 : _options1.gaiaId)) ? Number((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.gaiaId) : void 0,
                lowerQuantile: (_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.lowerQuantile,
                upperQuantile: (_options4 = options) === null || _options4 === void 0 ? void 0 : _options4.upperQuantile,
                marginMultiplier: (_options5 = options) === null || _options5 === void 0 ? void 0 : _options5.marginMultiplier,
                minMargin: (_options6 = options) === null || _options6 === void 0 ? void 0 : _options6.minMargin,
                minimumPins: (_options7 = options) === null || _options7 === void 0 ? void 0 : _options7.minimumPins,
                interpolationRatio: (_options8 = options) === null || _options8 === void 0 ? void 0 : _options8.interpolationRatio
            },
            coordinates: options.coordinates.length > 0 ? options.coordinates.map(function(c) {
                return [
                    c.latitude,
                    c.longitude
                ];
            }) : coordinates
        };
    };
    React68.useEffect(function() {
        var map = mapRef.current;
        if (initDone.current && map && updateViewport) {
            var _featureCoordinates;
            if (bounds) {
                var _computeBoundsViewport = computeBoundsViewport(bounds), sw = _computeBoundsViewport.sw, ne = _computeBoundsViewport.ne;
                map.fitBounds(sw, ne, void 0, clientPadding);
            } else if (center !== null && zoom !== null) {
                var _computeCenterAndZoomViewport = computeCenterAndZoomViewport(center, zoom), c = _computeCenterAndZoomViewport.center, z = _computeCenterAndZoomViewport.zoom;
                map.centerAndZoomMap(c, z, clientPadding);
            } else if (computedBoundsOptions) {
                var _computeBoundsComputedViewport = computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions), useBoundsComputation = _computeBoundsComputedViewport.useBoundsComputation, options = _computeBoundsComputedViewport.options, coordinates = _computeBoundsComputedViewport.coordinates;
                map.boundsContaining(coordinates, useBoundsComputation, options).then(function(boundsWithCenter) {
                    var sw = boundsWithCenter.sw, ne = boundsWithCenter.ne;
                    map.fitBounds(sw, ne, void 0, clientPadding);
                });
            } else if (((_featureCoordinates = featureCoordinates) === null || _featureCoordinates === void 0 ? void 0 : _featureCoordinates.length) > 0) {
                map.fitLatLongs(featureCoordinates, void 0, clientPadding);
            }
        }
    }, [
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates,
        updateViewport,
        clientPadding
    ]);
    var initialViewportObject = React68.useMemo(function() {
        switch(initialViewport){
            case "BOUNDS" /* BOUNDS */ :
                return bounds ? computeBoundsViewport(bounds) : void 0;
            case "CENTER_AND_ZOOM" /* CENTER_AND_ZOOM */ :
                return center && zoom !== null ? computeCenterAndZoomViewport(center, zoom) : void 0;
            case "COMPUTED_BOUNDS" /* COMPUTED_BOUNDS */ :
                return computedBoundsOptions ? computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions) : void 0;
            case "FIT_MARKERS" /* FIT_MARKERS */ :
            default:
                return featureCoordinates;
        }
    }, [
        initialViewport,
        center,
        zoom,
        bounds,
        computedBoundsOptions,
        featureCoordinates
    ]);
    var trackMapViewportBoundChangedCb = React68.useCallback(function(event) {
        var _event;
        var boundChangeMovementMapping = {
            zoomIn: "zoom_in" /* ZOOM_IN */ ,
            zoomOut: "zoom_out" /* ZOOM_OUT */ ,
            drag: "pan" /* PAN */ ,
            zoomInKeyboard: "zoom_in" /* ZOOM_IN */ ,
            zoomOutKeyboard: "zoom_out" /* ZOOM_OUT */ ,
            pitch: "pan" /* PAN */ ,
            rotate: "pan" /* PAN */ ,
            touch: "pan" /* PAN */ ,
            moveKeyboard: "pan" /* PAN */ ,
            clusterExtent: "zoom_in" /* ZOOM_IN */ 
        };
        var boundsChangeType = (_event = event) === null || _event === void 0 ? void 0 : _event.originalEvent;
        var movementType = boundChangeMovementMapping[boundsChangeType];
        if (movementType !== void 0) {
            trackMapViewportMoved(egBoundsToString(event.bounds), movementType, event.zoom);
        }
    }, [
        trackMapViewportMoved
    ]);
    var trackMarkerClick = React68.useCallback(function(feature) {
        if (feature) {
            var type = feature.type, _feature_id = feature.id, id = _feature_id === void 0 ? null : _feature_id;
            if (type && id !== null) {
                switch(type){
                    case "place":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , feature.qualifiers || [], "destination" /* DESTINATION */ );
                        break;
                    case "property":
                        trackMapPropertySelected(id.toString(), "property" /* PROPERTY */ );
                        break;
                    case "cluster":
                        trackMapPlaceSelected(id.toString(), "Point" /* POINT */ , [], "cluster" /* CLUSTER */ );
                        break;
                    default:
                        break;
                }
            }
        }
    }, [
        trackMapPlaceSelected,
        trackMapPropertySelected
    ]);
    var tilesContentLoadedCallback = React68.useCallback(function() {
        setTimeout(function() {
            var options = getContentPresentedOptions(mapRef.current, "tile" /* TILE */ );
            trackMapContentPresented(options);
        }, CONTENT_PRESENTED_DELAY);
    }, [
        trackMapContentPresented
    ]);
    var trackMarkerSelectionCb = React68.useCallback(function(event) {
        if (event.action === "select") {
            trackMarkerClick(event.feature);
        }
    }, [
        trackMarkerClick
    ]);
    React68.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        }
    }, [
        trackMapViewportBoundChangedCb
    ]);
    React68.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        }
    }, [
        trackMarkerSelectionCb
    ]);
    React68.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        }
    }, [
        tilesContentLoadedCallback
    ]);
    var internalBeforeInit = React68.useCallback(function(map) {
        mapRef.current = map;
        map.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
        map.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
        map.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
        if (beforeInit) {
            beforeInit(map);
        }
    }, []);
    var onInitInternal = React68.useCallback(function(map) {
        initDone.current = true;
        if (map) {
            var mapId = "";
            switch(mapType){
                case UitkEGMapsType.MAPBOX:
                    mapId = map.readConfigParam("mapbox,mapboxAddConf,style");
                    break;
                case UitkEGMapsType.GOOGLE:
                default:
                    mapId = map.readConfigParam("googleMaps,gmapsAddConfig,mapId");
                    break;
            }
            var bbox = map.getBounds();
            if (bbox) {
                var bboxString = boundingBoxToString(bbox.sw, bbox.ne);
                trackMapPresented(bboxString, mapId, viewMode);
            }
        }
        if (onInit) {
            onInit(map);
        }
    }, [
        onInit,
        trackMapPresented,
        viewMode,
        mapType
    ]);
    var onFeaturesPushedInternal = React68.useCallback(function(map, b) {
        if (b) {
            setTimeout(function() {
                var options = getContentPresentedOptions(map, "user" /* USER */ );
                trackMapContentPresented(options);
            }, CONTENT_PRESENTED_DELAY);
            if (onFeaturesPushed) {
                onFeaturesPushed(map, b);
            }
        }
    }, [
        onFeaturesPushed,
        trackMapContentPresented
    ]);
    if (!data && !initDone.current) {
        return /* @__PURE__ */ React68.createElement("div", {
            style: {
                height: height
            }
        }, /* @__PURE__ */ React68.createElement(UitkLayoutPosition8, {
            type: "relative",
            position: {
                top: "center",
                left: "center"
            }
        }, /* @__PURE__ */ React68.createElement(UitkPageLoader, {
            visible: true
        })));
    }
    return /* @__PURE__ */ React68.createElement(UitkEGMaps, {
        accessToken: accessToken,
        mapType: mapType,
        initialViewport: initialViewportObject,
        beforeInit: internalBeforeInit,
        onInit: onInitInternal,
        height: height,
        mapConfig: cfg,
        features: features,
        onFeaturesPushed: onFeaturesPushedInternal,
        egDistancesEnabled: egDistancesEnabled,
        clientPadding: clientPadding
    }, children);
};
DynamicMap.displayName = "DynamicMap";
DynamicMap.fragment = __Fragment3;
// src/components/dynamic-search-map/dynamic-search-map.tsx
import { FloatingPlaceCard, PlaceCardSize } from "@shared-ui/retail-places-place-details";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { SaveItemSignals } from "@shared-ui/trips-save-item";
import { defaultViewSizes, useMediaQueries, ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard8, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid9, UitkLayoutGridItem as UitkLayoutGridItem9 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition10 } from "uitk-react-layout-position";
import { UitkPageLoader as UitkPageLoader2 } from "uitk-react-loader";
import { UitkEGMapsQualifier as UitkEGMapsQualifier2 } from "uitk-react-map";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSheet as UitkSheet5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
// src/components/dynamic-search-map/floating-lodging-card.tsx
import React69 from "react";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition9 } from "uitk-react-layout-position";
var FloatingLodgingCard = function(props) {
    var data = props.data, onClickCallback = props.onClickCallback, onCardDismiss = props.onCardDismiss, showDismissButton = props.showDismissButton;
    return data ? /* @__PURE__ */ React69.createElement(UitkLayoutPosition9, {
        type: "absolute",
        tag: "div",
        position: {
            bottom: "one"
        },
        pointerEvents: "none",
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React69.createElement(UitkLayoutFlex17, {
        justifyContent: "center"
    }, /* @__PURE__ */ React69.createElement(UitkLayoutFlexItem10, {
        grow: 1,
        maxWidth: "180x"
    }, /* @__PURE__ */ React69.createElement("div", {
        style: {
            pointerEvents: "all"
        }
    }, /* @__PURE__ */ React69.createElement(LodgingCard, {
        data: data,
        onClickCallback: onClickCallback,
        view: "COMPACT_HORIZONTAL" /* COMPACT_HORIZONTAL */ ,
        wrapHeadingText: true,
        onCardDismiss: onCardDismiss,
        showDismissButton: showDismissButton,
        enableInlineLink: true
    }))))) : null;
};
FloatingLodgingCard.displayName = "FloatingLodgingCard";
// src/components/dynamic-search-map/map-toolbar.tsx
import React70 from "react";
import { gql as gql64 } from "@apollo/client";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
var fragment51 = gql64(_templateObject63());
var MapToolbar = function(param) {
    var onClose = param.onClose, filterComponent = param.filterComponent, data = param.data;
    var title = data.title, subtitle = data.subtitle;
    var navigationContent;
    if (onClose) {
        navigationContent = {
            onClick: onClose,
            navType: "close",
            navIconLabel: "close"
        };
    }
    return /* @__PURE__ */ React70.createElement(UitkToolbar4, {
        navigationContent: navigationContent,
        toolbarTitle: title || "",
        toolbarSubtitle: subtitle,
        toolbarActionContent: filterComponent
    });
};
MapToolbar.displayName = "MapToolbar";
MapToolbar.fragment = fragment51;
// src/components/dynamic-search-map/overfiltered-card.tsx
import React71 from "react";
import { gql as gql65 } from "@apollo/client";
import { UitkText as UitkText16 } from "uitk-react-text";
import { UitkToast } from "uitk-react-toast";
var fragment52 = gql65(_templateObject64());
var OverfilteredCard = function(param) {
    var data = param.data;
    var _ref = data.content || {}, heading = _ref.heading, message = _ref.message;
    return heading || message ? /* @__PURE__ */ React71.createElement(UitkToast, {
        autoHide: false,
        show: true
    }, heading && /* @__PURE__ */ React71.createElement(UitkText16, {
        theme: "light"
    }, heading), message && /* @__PURE__ */ React71.createElement(UitkText16, {
        theme: "light"
    }, message)) : /* @__PURE__ */ React71.createElement(React71.Fragment, null);
};
OverfilteredCard.displayName = "OverfilteredCard";
OverfilteredCard.fragment = fragment52;
// src/components/dynamic-search-map/dynamic-search-map.tsx
var __Query = gql66(_templateObject65(), AdaptExAnalyticsEventFragment, MapToolbar.fragment, clientSideAnalyticsFragment, LodgingEGDSIcon.fragment, clientSideAnalyticsFragment, fragment47, LodgingEGDSFloatingButton.fragment, LodgingEGDSCheckbox.fragment, DynamicMap.fragment, LodgingCard.fragment, OverfilteredCard.fragment);
var forcePriceForHotelAndVacationRental = function(config) {
    var cfg = _object_spread({}, config);
    if (!cfg.markers) {
        cfg.markers = {};
    }
    if (!cfg.markers.property) {
        cfg.markers.property = {};
    }
    if (!cfg.markers.property.markerType) {
        cfg.markers.property.markerType = {};
    }
    var markerType = cfg.markers.property.markerType;
    var _obj;
    cfg.markers.property.markerType = _object_spread_props(_object_spread({}, markerType), (_obj = {}, _define_property(_obj, UitkEGMapsQualifier2.HOTEL, null), _define_property(_obj, UitkEGMapsQualifier2.VACATION_RENTAL, null), _obj));
    return cfg;
};
var disableLodgingCardCloseOnMapClick = function(config) {
    var cfg = _object_spread({}, config);
    if (!cfg.map) {
        cfg.map = {};
    }
    if (!cfg.map.onMapClick) {
        cfg.map.onMapClick = [];
    }
    if (!cfg.map.onMapDrag) {
        cfg.map.onMapDrag = [];
    }
    return cfg;
};
var addFilterPlacementTopOverride = function(config) {
    var cfg = _object_spread({}, config);
    if (!cfg.style) {
        cfg.style = {};
    }
    cfg.style[".gm-bundled-control"] = {
        marginTop: "75px !important"
    };
    return cfg;
};
var triggerCanSearchId = "triggerCanSearchId";
var showCardId = "showCardId";
var DynamicSearchMap = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var _propertySearchResult, _data_propertySearch, _data, _data_propertySearch1, _data1, _propertySearchResult1, _propertySearchListingsData_filter, _propertySearchListingsData, _autoSearchOnMapMove;
    var batchKey = props.batchKey, inputs = props.inputs, fullscreenOptions = props.fullscreenOptions, onInit = props.onInit, beforeInit = props.beforeInit, onDestinationChanged = props.onDestinationChanged, onLodgingCardDisplayCallback = props.onLodgingCardDisplayCallback, onLodgingCardClickCallback = props.onLodgingCardClickCallback, egMapsConfig = props.egMapsConfig, clientPadding = props.clientPadding, height = props.height, filterComponent = props.filterComponent, skipSsr = props.skipSsr, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, fetchPolicy = props.fetchPolicy, className = props.className, selectedFeatureId = props.selectedFeatureId, propertySearchResult = props.propertySearchResult;
    var hasPropertySearchResult = Boolean(propertySearchResult);
    var context = useBexApi4().context;
    var mapRef = React72.useRef();
    var _React72_useState = _sliced_to_array(React72.useState(false), 2), initDone = _React72_useState[0], setInitDone = _React72_useState[1];
    var _React72_useState1 = _sliced_to_array(React72.useState(false), 2), viewportChanged = _React72_useState1[0], setViewportChanged = _React72_useState1[1];
    var autoSearch = React72.useRef();
    var _React72_useState2 = _sliced_to_array(React72.useState(void 0), 2), searchTriggeredFromDestination = _React72_useState2[0], setSearchTriggeredFromDestination = _React72_useState2[1];
    var _React72_useState3 = _sliced_to_array(React72.useState(true), 2), showLoading = _React72_useState3[0], setShowLoading = _React72_useState3[1];
    var _React72_useState4 = _sliced_to_array(React72.useState(), 2), selectedPropertyData = _React72_useState4[0], setSelectedPropertyData = _React72_useState4[1];
    var _React72_useState5 = _sliced_to_array(React72.useState(false), 2), showDismissButton = _React72_useState5[0], setShowDismissButton = _React72_useState5[1];
    var _useExperiment2 = useExperiment2("Preload_Winning_Travel_Ad_on_SRP_map_Web"), preloadTravelAdExposure = _useExperiment2.exposure, preloadTravelAdLogExperiment = _useExperiment2.logExperiment;
    var _useExperiment21 = useExperiment2("Dismiss_property_card_on_map_view_web"), dismissPropertyExposure = _useExperiment21.exposure, dismissPropertyLogExposure = _useExperiment21.logExperiment;
    var isSmallViewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    }) === defaultViewSizes.SMALL;
    var propertiesData = React72.useRef([]);
    var _React72_useState6 = _sliced_to_array(React72.useState(), 2), placeCardId = _React72_useState6[0], setPlaceCardId = _React72_useState6[1];
    var _useClickstreamAnalytics5 = useClickstreamAnalytics5(), clickStreamTrack = _useClickstreamAnalytics5.track;
    var trackClick = useClickTracker21();
    var positionOfAcceptedTA = 5;
    var variables = React72.useMemo(function() {
        return _object_spread_props(_object_spread({}, inputs), {
            context: context
        });
    }, [
        inputs,
        context
    ]);
    var internalOnClose = React72.useCallback(function() {
        var _fullscreenOptions;
        if ((_fullscreenOptions = fullscreenOptions) === null || _fullscreenOptions === void 0 ? void 0 : _fullscreenOptions.onClose) {
            fullscreenOptions.onClose();
        }
    }, [
        fullscreenOptions
    ]);
    var findLodgingCardData = function(featureId) {
        if (featureId) {
            return propertiesData.current.find(function(d) {
                return d.__typename === "LodgingCard" && d.id === featureId;
            });
        }
        return void 0;
    };
    var selectPropertyCard = React72.useCallback(function(featureId) {
        var isTravelAd = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (isTravelAd || dismissPropertyExposure.bucket === 1) {
            setShowDismissButton(true);
        } else {
            setShowDismissButton(false);
        }
        var lodgingCardData = findLodgingCardData(featureId);
        setSelectedPropertyData(lodgingCardData);
        if (onLodgingCardDisplayCallback) {
            var _lodgingCardData;
            onLodgingCardDisplayCallback((_lodgingCardData = lodgingCardData) === null || _lodgingCardData === void 0 ? void 0 : _lodgingCardData.id);
        }
    }, [
        onLodgingCardDisplayCallback
    ]);
    var clearSelectedProperty = React72.useCallback(function() {
        var _mapRef_current;
        (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.clearSelectedFeature();
        selectPropertyCard();
        if (preloadTravelAdExposure.bucket === 1) {
            trackClick("HOT.SRP.Module.Map.PreloadedHotelCard.Closed", "Hotel card closed on SRP Map", false);
        }
        if (dismissPropertyExposure.bucket === 1) {
            trackClick("HOT.SR.Module.Map.HotelCard.Closed", "Hotel card closed on SRP Map", false);
        }
    }, [
        selectPropertyCard
    ]);
    var showCardOnMarkerSelection = React72.useCallback(function(event) {
        var selectMarker = function(markerFeature) {
            if (markerFeature.type === "property") {
                setPlaceCardId(void 0);
                selectPropertyCard(markerFeature.id);
            } else if (markerFeature.type === "place") {
                selectPropertyCard();
                setPlaceCardId(markerFeature.id);
            }
        };
        var feature = event.feature, action2 = event.action;
        switch(action2){
            case "select":
                selectMarker(feature);
                break;
            case "clearSelection":
                selectPropertyCard();
                setPlaceCardId(void 0);
                trackClick("HOT.SR.Module.Map.HotelCard.ClosedByMapClick", "Hotel card closed on HSR Map by map click", false);
                break;
            default:
                selectPropertyCard();
                setPlaceCardId(void 0);
                break;
        }
    }, [
        selectPropertyCard
    ]);
    var queryOptions = _object_spread({
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery || hasPropertySearchResult,
        notifyOnNetworkStatusChange: true
    }, fetchPolicy ? {
        fetchPolicy: fetchPolicy
    } : {});
    var _useQuery2 = useQuery2(__Query, queryOptions), currentData = _useQuery2.data, loading = _useQuery2.loading, error = _useQuery2.error, previousData = _useQuery2.previousData;
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    var dynamicMap = hasPropertySearchResult ? (_propertySearchResult = propertySearchResult) === null || _propertySearchResult === void 0 ? void 0 : _propertySearchResult.dynamicMap : (_data = data) === null || _data === void 0 ? void 0 : (_data_propertySearch = _data.propertySearch) === null || _data_propertySearch === void 0 ? void 0 : _data_propertySearch.dynamicMap;
    var _ref = dynamicMap || {}, action = _ref.action, mapData = _ref.map, mapToolbar = _ref.mapToolbar, autoSearchOnMapMove = _ref.autoSearchOnMapMove, adaptExSuccessEvents = _ref.adaptExSuccessEvents, filterPlacement = _ref.filterPlacement;
    var propertySearchListingsData = React72.useMemo(function() {
        var _propertySearchResult, _propertySearchResult_propertySearchListings, _propertySearchResult1, _data_propertySearch, _data;
        if (((_propertySearchResult = propertySearchResult) === null || _propertySearchResult === void 0 ? void 0 : _propertySearchResult.propertySearchListings) && ((_propertySearchResult1 = propertySearchResult) === null || _propertySearchResult1 === void 0 ? void 0 : (_propertySearchResult_propertySearchListings = _propertySearchResult1.propertySearchListings) === null || _propertySearchResult_propertySearchListings === void 0 ? void 0 : _propertySearchResult_propertySearchListings.length) > 0) {
            var _propertySearchResult2;
            return (_propertySearchResult2 = propertySearchResult) === null || _propertySearchResult2 === void 0 ? void 0 : _propertySearchResult2.propertySearchListings;
        }
        return ((_data = data) === null || _data === void 0 ? void 0 : (_data_propertySearch = _data.propertySearch) === null || _data_propertySearch === void 0 ? void 0 : _data_propertySearch.propertySearchListings) || [];
    }, [
        (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_propertySearch1 = _data1.propertySearch) === null || _data_propertySearch1 === void 0 ? void 0 : _data_propertySearch1.propertySearchListings,
        (_propertySearchResult1 = propertySearchResult) === null || _propertySearchResult1 === void 0 ? void 0 : _propertySearchResult1.propertySearchListings
    ]);
    React72.useEffect(function() {
        propertiesData.current = propertySearchListingsData;
    }, [
        propertySearchListingsData
    ]);
    var overfilteredCardData = (_propertySearchListingsData = propertySearchListingsData) === null || _propertySearchListingsData === void 0 ? void 0 : (_propertySearchListingsData_filter = _propertySearchListingsData.filter(function(card) {
        return card.__typename === "PropertySearchListingsOverfilteredCard";
    })) === null || _propertySearchListingsData_filter === void 0 ? void 0 : _propertySearchListingsData_filter[0];
    var dynamicMapConfig = React72.useMemo(function() {
        var cfg = egMapsConfig ? _object_spread({}, egMapsConfig) : {};
        cfg = forcePriceForHotelAndVacationRental(cfg);
        if (filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */ ) {
            cfg = addFilterPlacementTopOverride(cfg);
        }
        if (dismissPropertyExposure.bucket === 0) {
            cfg = disableLodgingCardCloseOnMapClick(cfg);
        }
        return cfg;
    }, [
        egMapsConfig,
        filterPlacement,
        dismissPropertyExposure
    ]);
    React72.useEffect(function() {
        var wasLoading = showLoading;
        setShowLoading(loading);
        if (!loading && initDone) {
            if (wasLoading) {
                var map = mapRef.current;
                if (map) {
                    var feature = map.getFeatureSelected();
                    var _ref = feature ? [
                        feature
                    ].filter(filterFeatureObject)[0] : {}, _ref_id = _ref.id, id = _ref_id === void 0 ? void 0 : _ref_id, _ref_type = _ref.type, type = _ref_type === void 0 ? void 0 : _ref_type;
                    if (id && type && map.listFeatures(function(f) {
                        return f.id === id && f.type === type;
                    }).length > 0) {
                        setSelectedPropertyData(findLodgingCardData(id));
                    } else {
                        map.clearSelectedFeature();
                        setSelectedPropertyData(void 0);
                    }
                }
            }
            if (searchTriggeredFromDestination) {
                setSearchTriggeredFromDestination(void 0);
                setViewportChanged(false);
            }
        }
    }, [
        loading,
        searchTriggeredFromDestination,
        setSearchTriggeredFromDestination,
        setShowLoading,
        data
    ]);
    React72.useEffect(function() {
        selectExternalFeatureId();
    }, [
        selectedFeatureId
    ]);
    var getDestinationInput = React72.useCallback(function() {
        var _mapRef_current;
        var egMapsBounds = (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.getBounds();
        if (egMapsBounds) {
            var _egMapsBounds_center_, _egMapsBounds_center_1, _egMapsBounds_sw_, _egMapsBounds_sw_1, _egMapsBounds_ne_, _egMapsBounds_ne_1;
            return {
                coordinates: {
                    latitude: (_egMapsBounds_center_ = egMapsBounds.center[0]) !== null && _egMapsBounds_center_ !== void 0 ? _egMapsBounds_center_ : 0,
                    longitude: (_egMapsBounds_center_1 = egMapsBounds.center[1]) !== null && _egMapsBounds_center_1 !== void 0 ? _egMapsBounds_center_1 : 0
                },
                mapBounds: [
                    {
                        latitude: (_egMapsBounds_sw_ = egMapsBounds.sw[0]) !== null && _egMapsBounds_sw_ !== void 0 ? _egMapsBounds_sw_ : 0,
                        longitude: (_egMapsBounds_sw_1 = egMapsBounds.sw[1]) !== null && _egMapsBounds_sw_1 !== void 0 ? _egMapsBounds_sw_1 : 0
                    },
                    {
                        latitude: (_egMapsBounds_ne_ = egMapsBounds.ne[0]) !== null && _egMapsBounds_ne_ !== void 0 ? _egMapsBounds_ne_ : 0,
                        longitude: (_egMapsBounds_ne_1 = egMapsBounds.ne[1]) !== null && _egMapsBounds_ne_1 !== void 0 ? _egMapsBounds_ne_1 : 0
                    }
                ]
            };
        }
    }, []);
    var destinationAsString = React72.useCallback(function(dest) {
        var _dest_mapBounds;
        return "".concat((_dest_mapBounds = dest.mapBounds) === null || _dest_mapBounds === void 0 ? void 0 : _dest_mapBounds.map(function(c) {
            return "".concat(c.latitude, ",").concat(c.longitude);
        }).join(";"));
    }, []);
    React72.useEffect(function() {
        setShowLoading(loading);
        if (!loading && searchTriggeredFromDestination) {
            var dest = getDestinationInput();
            if (!dest || destinationAsString(dest) === searchTriggeredFromDestination) {
                setSearchTriggeredFromDestination(void 0);
                setViewportChanged(false);
            }
        }
    }, [
        loading,
        searchTriggeredFromDestination,
        setSearchTriggeredFromDestination,
        setShowLoading,
        setViewportChanged,
        data,
        getDestinationInput,
        destinationAsString
    ]);
    var updateSearch = React72.useCallback(function() {
        if (onDestinationChanged) {
            var dest = getDestinationInput();
            if (dest) {
                setSearchTriggeredFromDestination(destinationAsString(dest));
                onDestinationChanged(dest);
            }
        }
    }, [
        onDestinationChanged,
        getDestinationInput,
        destinationAsString
    ]);
    var onAutoSearchChecked = React72.useCallback(function(event) {
        autoSearch.current = event.target.checked;
        if (autoSearch.current && viewportChanged) {
            updateSearch();
        }
    }, [
        updateSearch,
        viewportChanged
    ]);
    var updateCanSearch = React72.useCallback(function() {
        setViewportChanged(true);
        if (autoSearch.current) {
            updateSearch();
        }
    }, [
        updateSearch
    ]);
    var selectExternalFeatureId = React72.useCallback(function() {
        if (mapRef.current && initDone) {
            mapRef.current.clearSelectedFeature();
            if (selectedFeatureId) {
                mapRef.current.selectFeature(selectedFeatureId, "property");
                return true;
            }
        }
        return false;
    }, [
        selectedFeatureId
    ]);
    React72.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addBoundChangeListener(updateCanSearch, triggerCanSearchId);
        }
    }, [
        updateCanSearch
    ]);
    React72.useEffect(function() {
        if (mapRef.current) {
            mapRef.current.addSelectionChangeListener(showCardOnMarkerSelection, showCardId);
        }
    }, [
        showCardOnMarkerSelection
    ]);
    var internalOnInit = React72.useCallback(function(map) {
        if (onInit) {
            onInit(map);
            setInitDone(true);
        }
    }, []);
    var internalBeforeInit = React72.useCallback(function(map) {
        mapRef.current = map;
        map.addBoundChangeListener(updateCanSearch, triggerCanSearchId);
        map.addSelectionChangeListener(showCardOnMarkerSelection, showCardId);
        if (beforeInit) {
            beforeInit(map);
        }
        dismissPropertyLogExposure(dismissPropertyExposure);
    }, []);
    var internalLodgingCardClickCallback = React72.useCallback(function() {
        if (onLodgingCardClickCallback) {
            var _selectedPropertyData;
            var id = (_selectedPropertyData = selectedPropertyData) === null || _selectedPropertyData === void 0 ? void 0 : _selectedPropertyData.id;
            if (id) {
                onLodgingCardClickCallback(id);
            }
        }
        if (adaptExSuccessEvents) {
            adaptExSuccessEvents.forEach(function(adaptExEvent) {
                var events = adaptExEvent.events[0];
                clickStreamTrack(ITrackType5.EVENT, {
                    data: adaptToAdaptExSuccessEventSchema(_object_spread_props(_object_spread({}, adaptExEvent), {
                        events: events ? [
                            events
                        ] : void 0
                    }))
                });
            });
        }
    }, [
        selectedPropertyData,
        adaptExSuccessEvents,
        onLodgingCardClickCallback
    ]);
    var filterFeatureObject = function(f) {
        return true;
    };
    var addPreloadedTravelAdHotel = React72.useCallback(function() {
        var _propertiesData;
        var winningTravelAdHotel = (_propertiesData = propertiesData) === null || _propertiesData === void 0 ? void 0 : _propertiesData.current.find(function(propertySearchListing, index) {
            var _propertySearchListing_mediaSection_badges_secondaryBadge, _propertySearchListing_mediaSection_badges;
            return propertySearchListing.__typename === "LodgingCard" && ((_propertySearchListing_mediaSection_badges = propertySearchListing.mediaSection.badges) === null || _propertySearchListing_mediaSection_badges === void 0 ? void 0 : (_propertySearchListing_mediaSection_badges_secondaryBadge = _propertySearchListing_mediaSection_badges.secondaryBadge) === null || _propertySearchListing_mediaSection_badges_secondaryBadge === void 0 ? void 0 : _propertySearchListing_mediaSection_badges_secondaryBadge.theme) === "promoted" && index < positionOfAcceptedTA;
        });
        if (winningTravelAdHotel) {
            var _mapRef_current, _preloadTravelAdExposure;
            var _ref = _sliced_to_array(((_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.listFeatures(function(feature) {
                return feature.id === winningTravelAdHotel.id && feature.type === "property";
            }).filter(filterFeatureObject)) || [], 1), winningTAFeature = _ref[0];
            if (!winningTAFeature) {
                return;
            }
            preloadTravelAdLogExperiment(preloadTravelAdExposure);
            if (((_preloadTravelAdExposure = preloadTravelAdExposure) === null || _preloadTravelAdExposure === void 0 ? void 0 : _preloadTravelAdExposure.bucket) === 1) {
                var _mapRef_current1, _mapRef_current2;
                var id = winningTAFeature.id, type = winningTAFeature.type;
                (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.addQualifierToFeature(id, type, UitkEGMapsQualifier2.NOT_CLUSTERED);
                (_mapRef_current2 = mapRef.current) === null || _mapRef_current2 === void 0 ? void 0 : _mapRef_current2.selectFeature(id, type);
                selectPropertyCard("".concat(id), true);
            }
        }
    }, [
        preloadTravelAdExposure,
        preloadTravelAdLogExperiment,
        selectPropertyCard
    ]);
    var internalOnFeaturesPushed = React72.useCallback(function() {
        if (!selectExternalFeatureId()) {
            var _mapRef_current;
            var _ref = _sliced_to_array(((_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.listFeatures(function(f) {
                var _f_qualifiers;
                return (_f_qualifiers = f.qualifiers) === null || _f_qualifiers === void 0 ? void 0 : _f_qualifiers.includes("pinned");
            }).filter(filterFeatureObject)) || [], 1), feature = _ref[0];
            if (feature) {
                var _mapRef_current1;
                var id = feature.id, type = feature.type;
                (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.selectFeature(id, type);
                selectPropertyCard("".concat(id));
            } else {
                addPreloadedTravelAdHotel();
            }
        }
    }, []);
    var destinationIsBounds = React72.useMemo(function() {
        var _variables_destination_mapBounds, _variables_destination, _variables, _variables_criteria_primary_destination_mapBounds, _variables_criteria_primary_destination, _variables_criteria_primary, _variables_criteria, _variables1;
        return ((_variables = variables) === null || _variables === void 0 ? void 0 : (_variables_destination = _variables.destination) === null || _variables_destination === void 0 ? void 0 : (_variables_destination_mapBounds = _variables_destination.mapBounds) === null || _variables_destination_mapBounds === void 0 ? void 0 : _variables_destination_mapBounds.length) === 2 || ((_variables1 = variables) === null || _variables1 === void 0 ? void 0 : (_variables_criteria = _variables1.criteria) === null || _variables_criteria === void 0 ? void 0 : (_variables_criteria_primary = _variables_criteria.primary) === null || _variables_criteria_primary === void 0 ? void 0 : (_variables_criteria_primary_destination = _variables_criteria_primary.destination) === null || _variables_criteria_primary_destination === void 0 ? void 0 : (_variables_criteria_primary_destination_mapBounds = _variables_criteria_primary_destination.mapBounds) === null || _variables_criteria_primary_destination_mapBounds === void 0 ? void 0 : _variables_criteria_primary_destination_mapBounds.length) === 2;
    }, [
        variables
    ]);
    var searchButton = action && viewportChanged && onDestinationChanged ? /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        type: "absolute",
        position: {
            top: "twelve",
            left: "center"
        },
        cloneElement: true
    }, filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */  ? /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        type: "relative",
        position: {
            top: "twelve"
        }
    }, /* @__PURE__ */ React72.createElement(LodgingEGDSFloatingButton, {
        data: action,
        disabled: showLoading,
        onClick: updateSearch
    }))) : /* @__PURE__ */ React72.createElement(LodgingEGDSFloatingButton, {
        data: action,
        disabled: showLoading,
        onClick: updateSearch
    })) : null;
    var autoSearchCheckbox = ((_autoSearchOnMapMove = autoSearchOnMapMove) === null || _autoSearchOnMapMove === void 0 ? void 0 : _autoSearchOnMapMove.required) ? /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        type: "absolute",
        position: {
            top: "zero",
            right: "twelve"
        }
    }, /* @__PURE__ */ React72.createElement(UitkSpacing17, {
        margin: "three"
    }, /* @__PURE__ */ React72.createElement(UitkCard8, {
        border: true
    }, /* @__PURE__ */ React72.createElement(UitkCardContentSection5, {
        padded: [
            "inlinestart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(LodgingEGDSCheckbox, {
        data: autoSearchOnMapMove,
        onChange: onAutoSearchChecked,
        checked: autoSearch.current
    })))))) : null;
    React72.useEffect(function() {
        if (!autoSearch.current && autoSearchOnMapMove && autoSearchOnMapMove.state === "CHECKED" /* CHECKED */ ) {
            autoSearch.current = true;
        }
    }, [
        autoSearchOnMapMove
    ]);
    var loadingSpinner = showLoading && !error ? /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        "aria-label": "loading-spinner",
        type: "absolute",
        position: {
            top: "center",
            left: "center"
        },
        cloneElement: true
    }, /* @__PURE__ */ React72.createElement(UitkPageLoader2, {
        visible: true
    })) : null;
    var overTopFilter = filterPlacement === "OVERLAY_TOP" /* OVERLAY_TOP */  && // setting absolute element to be scrollable on an absolute layout is tricky without custom CSS
    /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        type: "absolute",
        position: {
            top: "two",
            left: "zero"
        },
        cloneElement: true
    }, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(UitkLayoutPosition10, {
        type: "relative"
    }, /* @__PURE__ */ React72.createElement(UitkLayoutGrid9, null, /* @__PURE__ */ React72.createElement(UitkLayoutGridItem9, null, /* @__PURE__ */ React72.createElement("div", null, /* @__PURE__ */ React72.createElement(UitkScrollable, {
        direction: "horizontal"
    }, /* @__PURE__ */ React72.createElement(UitkSpacing17, {
        padding: {
            block: "two",
            inlinestart: "two",
            inlineend: isSmallViewSize ? void 0 : "two"
        }
    }, filterComponent))))))));
    var updateSavedQualifier = function(tripItemId, toggleState) {
        if (tripItemId !== void 0) {
            if (toggleState) {
                var _mapRef_current;
                (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.addQualifierToFeature(tripItemId, "property", UitkEGMapsQualifier2.SAVED);
            } else {
                var _mapRef_current1;
                (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.removeQualifierFromFeature(tripItemId, "property", UitkEGMapsQualifier2.SAVED);
            }
        }
    };
    useSignalSubscriber([
        {
            query: {
                type: SaveItemSignals.TRIP_ITEM_SAVED
            },
            callback: function(event) {
                var _event_payload, _event, _event_payload1;
                return updateSavedQualifier((_event = event) === null || _event === void 0 ? void 0 : (_event_payload = _event.payload) === null || _event_payload === void 0 ? void 0 : _event_payload.tripItemId, (_event_payload1 = event.payload) === null || _event_payload1 === void 0 ? void 0 : _event_payload1.toggleState);
            }
        },
        {
            query: {
                type: SaveItemSignals.TRIP_ITEM_UNSAVED
            },
            callback: function(event) {
                var _event_payload, _event, _event_payload1;
                return updateSavedQualifier((_event = event) === null || _event === void 0 ? void 0 : (_event_payload = _event.payload) === null || _event_payload === void 0 ? void 0 : _event_payload.tripItemId, (_event_payload1 = event.payload) === null || _event_payload1 === void 0 ? void 0 : _event_payload1.toggleState);
            }
        }
    ]);
    var overfilteredCard = overfilteredCardData && /* @__PURE__ */ React72.createElement(OverfilteredCard, {
        data: overfilteredCardData
    });
    var content = mapRef.current || !error ? /* @__PURE__ */ React72.createElement(DynamicMap, {
        className: className,
        data: mapData,
        onInit: internalOnInit,
        beforeInit: internalBeforeInit,
        egMapsConfig: dynamicMapConfig,
        clientPadding: clientPadding,
        height: height,
        updateViewport: !destinationIsBounds,
        onFeaturesPushed: internalOnFeaturesPushed
    }, overTopFilter, searchButton, autoSearchCheckbox, loadingSpinner, overfilteredCard, /* @__PURE__ */ React72.createElement(FloatingLodgingCard, {
        data: selectedPropertyData,
        onClickCallback: internalLodgingCardClickCallback,
        onCardDismiss: clearSelectedProperty,
        showDismissButton: showDismissButton
    }), /* @__PURE__ */ React72.createElement(Experiment2, {
        name: "Lodging_SRP_basemap_content_MAB"
    }, /* @__PURE__ */ React72.createElement(ExperimentVariant2, {
        bucket: 1
    }, /* @__PURE__ */ React72.createElement(Viewport7, null, /* @__PURE__ */ React72.createElement(ViewSmall5, null, placeCardId ? /* @__PURE__ */ React72.createElement(FloatingPlaceCard, {
        size: PlaceCardSize.COMPACT,
        placeId: placeCardId
    }) : /* @__PURE__ */ React72.createElement("div", null)), /* @__PURE__ */ React72.createElement(ViewMedium7, null, placeCardId ? /* @__PURE__ */ React72.createElement(FloatingPlaceCard, {
        size: PlaceCardSize.STANDARD,
        placeId: placeCardId
    }) : /* @__PURE__ */ React72.createElement("div", null)))), /* @__PURE__ */ React72.createElement(ExperimentControl2, null)), children) : null;
    var toolbar = mapToolbar ? /* @__PURE__ */ React72.createElement(MapToolbar, {
        onClose: fullscreenOptions !== void 0 ? internalOnClose : void 0,
        data: mapToolbar,
        filterComponent: filterPlacement === "TOOLBAR" /* TOOLBAR */  && filterComponent
    }) : null;
    if (fullscreenOptions) {
        return /* @__PURE__ */ React72.createElement(UitkSheet5, {
            isVisible: fullscreenOptions.isDialogOpen,
            type: "full",
            triggerRef: fullscreenOptions.triggerRef
        }, toolbar, content);
    }
    return /* @__PURE__ */ React72.createElement(React72.Fragment, null, toolbar, content);
};
DynamicSearchMap.displayName = "DynamicSearchMap";
// src/components/property-search-map-trigger/property-search-map-trigger.tsx
import React74 from "react";
import { gql as gql68, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
// ../internal/src/components/map-trigger/map-trigger.tsx
import React73 from "react";
import { gql as gql67 } from "@apollo/client";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { Experiment as Experiment3, ExperimentControl as ExperimentControl3, ExperimentVariant as ExperimentVariant3 } from "@shared-ui/experiment-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium8, Viewport as Viewport8, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkFloatingButton as UitkFloatingButton2, UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkCard as UitkCard9, UitkCardContentSection as UitkCardContentSection6, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkIcon as UitkIcon12 } from "uitk-react-icons";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType4, UitkImage as UitkImage4 } from "uitk-react-images";
import { UitkLayoutPosition as UitkLayoutPosition11 } from "uitk-react-layout-position";
import { UitkLink as UitkLink8 } from "uitk-react-link";
var __MapTriggerFragment = gql67(_templateObject66());
var defaultCloseMapDialogPropBuilder = function(onClose) {
    return {
        closeMapDialog: onClose
    };
};
var fullscreenOptionsCloseMapDialogPropBuilder = function(onClose, isDialogOpen, triggerRef) {
    return {
        fullscreenOptions: {
            onClose: onClose,
            isDialogOpen: isDialogOpen,
            triggerRef: triggerRef
        }
    };
};
var MapTrigger = function(props) {
    var triggerRef = React73.useRef(null);
    var data = props.data, children = props.children, className = props.className, _props_dialogId = props.dialogId, dialogId = _props_dialogId === void 0 ? "map" : _props_dialogId, _props_dialogQueryKey = props.dialogQueryKey, dialogQueryKey = _props_dialogQueryKey === void 0 ? "pwaOverlay" : _props_dialogQueryKey, dialogView = props.dialogView, _props_closeMapDialogPropBuilder = props.closeMapDialogPropBuilder, closeMapDialogPropBuilder = _props_closeMapDialogPropBuilder === void 0 ? defaultCloseMapDialogPropBuilder : _props_closeMapDialogPropBuilder;
    var trackClick = useClickTracker22();
    var _useDialog6 = _sliced_to_array(useDialog6(dialogId, dialogQueryKey), 3), isDialogOpen = _useDialog6[0], dialogActions = _useDialog6[1], DialogComponent = _useDialog6[2];
    var mapPreviewImage = data.large, icon = data.icon, label = data.label, clientSideAnalytics = data.clientSideAnalytics;
    var openMapDialog = function() {
        if (clientSideAnalytics) {
            trackClick(clientSideAnalytics.referrerId, clientSideAnalytics.linkName);
        }
        dialogActions.openDialog();
    };
    var FloatingWrap = React73.useCallback(function() {
        if (isDialogOpen) {
            return null;
        }
        return dialogView === "FILTER_BAR" ? /* @__PURE__ */ React73.createElement(Experiment3, {
            name: "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_mweb"
        }, /* @__PURE__ */ React73.createElement(ExperimentControl3, null, /* @__PURE__ */ React73.createElement(UitkLayoutPosition11, {
            type: "fixed",
            position: {
                bottom: "six",
                left: "center",
                zindex: "layer3"
            },
            cloneElement: true
        }, /* @__PURE__ */ React73.createElement(UitkSecondaryButton3, {
            onClick: openMapDialog,
            className: className,
            domRef: triggerRef
        }, icon && /* @__PURE__ */ React73.createElement(UitkIcon12, {
            name: icon.id
        }), label))), /* @__PURE__ */ React73.createElement(ExperimentVariant3, {
            bucket: 1
        }, /* @__PURE__ */ React73.createElement(UitkLayoutPosition11, {
            type: "fixed",
            position: {
                bottom: "six",
                left: "center",
                zindex: "layer3"
            },
            cloneElement: true
        }, /* @__PURE__ */ React73.createElement(UitkFloatingButton2, {
            onClick: openMapDialog,
            className: className,
            domRef: triggerRef
        }, icon && /* @__PURE__ */ React73.createElement(UitkIcon12, {
            name: icon.id
        }), label)))) : /* @__PURE__ */ React73.createElement(UitkSecondaryButton3, {
            onClick: openMapDialog,
            isFullWidth: true,
            className: className,
            domRef: triggerRef
        }, icon && /* @__PURE__ */ React73.createElement(UitkIcon12, {
            name: icon.id
        }), label);
    }, [
        data,
        isDialogOpen
    ]);
    var MapThumbnail = React73.useCallback(function() {
        var _mapPreviewImage, _mapPreviewImage1, _mapPreviewImage2;
        if (isDialogOpen) {
            return null;
        }
        return /* @__PURE__ */ React73.createElement(UitkCard9, {
            overflow: true,
            border: true
        }, /* @__PURE__ */ React73.createElement(UitkFigure4, {
            ratio: UitkFigureAspectRatioType4.R4_1,
            "aria-hidden": "true",
            style: {
                maxHeight: 72
            }
        }, /* @__PURE__ */ React73.createElement(UitkImage4, {
            alt: (_mapPreviewImage = mapPreviewImage) === null || _mapPreviewImage === void 0 ? void 0 : _mapPreviewImage.description,
            src: (_mapPreviewImage1 = mapPreviewImage) === null || _mapPreviewImage1 === void 0 ? void 0 : _mapPreviewImage1.url,
            "aria-hidden": "true"
        })), /* @__PURE__ */ React73.createElement(UitkCardLink2, null, /* @__PURE__ */ React73.createElement("button", {
            type: "button",
            onClick: openMapDialog,
            ref: triggerRef
        }, (_mapPreviewImage2 = mapPreviewImage) === null || _mapPreviewImage2 === void 0 ? void 0 : _mapPreviewImage2.description)));
    }, [
        data,
        isDialogOpen
    ]);
    var MapPreview = React73.useCallback(function() {
        if (!mapPreviewImage) {
            return null;
        }
        var mapPreviewContent = /* @__PURE__ */ React73.createElement(UitkCard9, {
            border: true,
            className: className
        }, /* @__PURE__ */ React73.createElement(UitkCardContentSection6, {
            padded: false
        }, /* @__PURE__ */ React73.createElement(UitkFigure4, {
            ratio: UitkFigureAspectRatioType4.R21_9,
            roundcorner: [
                "startstart",
                "startend"
            ],
            "aria-hidden": "true"
        }, /* @__PURE__ */ React73.createElement(UitkImage4, {
            alt: mapPreviewImage.description,
            src: mapPreviewImage.url,
            "aria-hidden": "true"
        })), /* @__PURE__ */ React73.createElement(UitkCardLink2, null, /* @__PURE__ */ React73.createElement("button", {
            type: "button",
            onClick: openMapDialog,
            ref: triggerRef
        }, mapPreviewImage.description))), label && /* @__PURE__ */ React73.createElement(UitkCardContentSection6, null, /* @__PURE__ */ React73.createElement(UitkLink8, {
            align: "center"
        }, /* @__PURE__ */ React73.createElement("button", {
            type: "button",
            className: "uitk-button",
            onClick: openMapDialog
        }, label))));
        var HEIGHT_OF_QUICK_FILTERS = 60;
        return /* @__PURE__ */ React73.createElement(Experiment3, {
            name: "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_web"
        }, /* @__PURE__ */ React73.createElement(ExperimentControl3, null, mapPreviewContent), /* @__PURE__ */ React73.createElement(ExperimentVariant3, {
            bucket: 1
        }, dialogView === "FILTER_BAR" ? // exclude packages LOB
        /* @__PURE__ */ React73.createElement(UitkLayoutPosition11, {
            type: "sticky",
            position: {
                top: HEIGHT_OF_QUICK_FILTERS
            }
        }, mapPreviewContent) : /* @__PURE__ */ React73.createElement(React73.Fragment, null, mapPreviewContent)));
    }, [
        data,
        mapPreviewImage
    ]);
    var closeProps = closeMapDialogPropBuilder(dialogActions.closeDialog, isDialogOpen, triggerRef);
    if (!data) {
        return null;
    }
    return /* @__PURE__ */ React73.createElement(React73.Fragment, null, /* @__PURE__ */ React73.createElement(Viewport8, null, /* @__PURE__ */ React73.createElement(ViewSmall6, null, /* @__PURE__ */ React73.createElement(Experiment3, {
        name: "Lodging_SRP_map_thumbnail_mweb"
    }, /* @__PURE__ */ React73.createElement(ExperimentControl3, null, /* @__PURE__ */ React73.createElement(FloatingWrap, null)), /* @__PURE__ */ React73.createElement(ExperimentVariant3, {
        bucket: 1
    }, /* @__PURE__ */ React73.createElement(MapThumbnail, null)))), /* @__PURE__ */ React73.createElement(ViewMedium8, null, /* @__PURE__ */ React73.createElement(FloatingWrap, null)), /* @__PURE__ */ React73.createElement(ViewLarge4, null, /* @__PURE__ */ React73.createElement(MapPreview, null))), isDialogOpen && /* @__PURE__ */ React73.createElement(DialogComponent, null, React73.cloneElement(children, closeProps)));
};
MapTrigger.displayName = "MapTrigger";
MapTrigger.fragment = __MapTriggerFragment;
// src/components/property-search-map-trigger/property-search-map-trigger.tsx
var __Query2 = gql68(_templateObject67(), MapTrigger.fragment);
var PropertySearchMapTrigger = function(props) {
    var _previousData, _data;
    var inputs = props.inputs, children = props.children, className = props.className, _props_dialogId = props.dialogId, dialogId = _props_dialogId === void 0 ? "map" : _props_dialogId, _props_dialogQueryKey = props.dialogQueryKey, dialogQueryKey = _props_dialogQueryKey === void 0 ? "pwaOverlay" : _props_dialogQueryKey, dialogView = props.dialogView, batchKey = props.batchKey, externalData = props.externalData;
    var context = useBexApi5().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var shouldSkipPropertySearchMapDialogTriggerQuery = Boolean(externalData);
    var _useQuery3 = useQuery3(__Query2, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        skip: shouldSkipPropertySearchMapDialogTriggerQuery
    }), data = _useQuery3.data, loading = _useQuery3.loading, previousData = _useQuery3.previousData, error = _useQuery3.error;
    var _data_propertySearch_mapTrigger;
    var mapTriggerData = loading ? (_previousData = previousData) === null || _previousData === void 0 ? void 0 : _previousData.propertySearch.mapTrigger : (_data_propertySearch_mapTrigger = (_data = data) === null || _data === void 0 ? void 0 : _data.propertySearch.mapTrigger) !== null && _data_propertySearch_mapTrigger !== void 0 ? _data_propertySearch_mapTrigger : externalData;
    if (error || !mapTriggerData) {
        return null;
    }
    return /* @__PURE__ */ React74.createElement(MapTrigger, {
        data: mapTriggerData,
        className: className,
        dialogId: dialogId,
        dialogQueryKey: dialogQueryKey,
        dialogView: dialogView,
        closeMapDialogPropBuilder: fullscreenOptionsCloseMapDialogPropBuilder
    }, children);
};
PropertySearchMapTrigger.displayName = "PropertySearchMapTrigger";
export { DatedSearches, DynamicSearchMap, PropertySearchMapTrigger }; // istanbul ignore next -- @preserve
 /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map